window.products = [
  {
    "sku": "100EXTGRILLESQBK",
    "title": "ABS Black Exterior 100mm Square Grille Vent",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/100EXTGRILLESQ_125EXTGRILLESQ_150EXTGRILLESQ_200EXTGRILLESQ_OL_abd8c058-1412-4606-9ee2-02a71c12c3eb.pdf?v=1784518699",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/100EXTGRILLESQBK.webp?v=1784532712"
  },
  {
    "sku": "125EXTGRILLESQBK",
    "title": "ABS Black Exterior 125mm Square Grille Vent",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/100EXTGRILLESQ_125EXTGRILLESQ_150EXTGRILLESQ_200EXTGRILLESQ_OL.pdf?v=1762752962",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/125EXTGRILLESQBK.webp?v=1784532755"
  },
  {
    "sku": "150EXTGRILLESQBK",
    "title": "ABS Black Exterior 150mm Square Grille Vent",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/100EXTGRILLESQ_125EXTGRILLESQ_150EXTGRILLESQ_200EXTGRILLESQ_OL_abd8c058-1412-4606-9ee2-02a71c12c3eb.pdf?v=1784518699",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/150EXTGRILLESQBK.webp?v=1784532784"
  },
  {
    "sku": "200EXTGRILLESQBK",
    "title": "ABS Black Exterior 200mm Square Grille Vent",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/100EXTGRILLESQ_125EXTGRILLESQ_150EXTGRILLESQ_200EXTGRILLESQ_OL_abd8c058-1412-4606-9ee2-02a71c12c3eb.pdf?v=1784518699",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/200EXTGRILLESQBK.webp?v=1784532897"
  },
  {
    "sku": "100EXTGRILLESQ",
    "title": "ABS White Exterior 100mm Square Grille Vent",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/100EXTGRILLESQ_125EXTGRILLESQ_150EXTGRILLESQ_200EXTGRILLESQ_OL_abd8c058-1412-4606-9ee2-02a71c12c3eb.pdf?v=1784518699",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/100EXTGRILLESQ.jpg?v=1762751425"
  },
  {
    "sku": "125EXTGRILLESQ",
    "title": "ABS White Exterior 125mm Square Grille Vent",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/100EXTGRILLESQ_125EXTGRILLESQ_150EXTGRILLESQ_200EXTGRILLESQ_OL_abd8c058-1412-4606-9ee2-02a71c12c3eb.pdf?v=1784518699",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/125EXTGRILLESQ.jpg?v=1762751782"
  },
  {
    "sku": "150EXTGRILLESQ",
    "title": "ABS White Exterior 150mm Square Grille Vent",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/100EXTGRILLESQ_125EXTGRILLESQ_150EXTGRILLESQ_200EXTGRILLESQ_OL_abd8c058-1412-4606-9ee2-02a71c12c3eb.pdf?v=1784518699",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/150EXTGRILLESQ.jpg?v=1762752264"
  },
  {
    "sku": "200EXTGRILLESQ",
    "title": "ABS White Exterior 200mm Square Grille Vent",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/100EXTGRILLESQ_125EXTGRILLESQ_150EXTGRILLESQ_200EXTGRILLESQ_OL_abd8c058-1412-4606-9ee2-02a71c12c3eb.pdf?v=1784518699",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/200EXTGRILLESQ.jpg?v=1762752344"
  },
  {
    "sku": "18627/14",
    "title": "Brilliant  Oil Rubbed Bronze Aviator Ceiling Fan Extension Rod 900mm with Easy Connect Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "21466/13",
    "title": "Brilliant  Satin Nickel Hercules -120\'\' 1800mm Ceiling Fan Extension Rod",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "21437/05",
    "title": "Brilliant  White Smart Wi-Fi Indoor Camera",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_WiFi_Mia_Camera_21437.pdf?v=1748244527",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00642_MIA_Camera_21437.pdf?v=1757906122",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2143705_1.jpg?v=1737715939"
  },
  {
    "sku": "21881/05",
    "title": "Brilliant  White Smart Wi-Fi Pan and Tilt Camera",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_WiFi_Spin_Camera_21881.pdf?v=1748244528",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00742_Spin_Camera_21881.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2188105_1.jpg?v=1738648596"
  },
  {
    "sku": "22989/06",
    "title": "Brilliant 120\" Black Colossus II 6-Blade DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/COLOSSUS_II_65_72_84_120_DC_CEILING_FAN_22979_22982_22986_22989_-_INSTRUCTION_MANUAL_V2.pdf?v=1793182346",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Colossus_II_DC_Ceiling_Fan_Data_Sheets.pdf?v=1793182346",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2298906_e2d2f3b6-0e45-439e-a82c-dc4a60c14031.jpg?v=1766036643"
  },
  {
    "sku": "22989/13",
    "title": "Brilliant 120\" Satin Nickel Colossus II 6-Blade DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/COLOSSUS_II_65_72_84_120_DC_CEILING_FAN_22979_22982_22986_22989_-_INSTRUCTION_MANUAL_V2.pdf?v=1793182346",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Colossus_II_DC_Ceiling_Fan_Data_Sheets.pdf?v=1793182346",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2298913_96906417-add3-44be-bf9e-8bb38cb394f6.jpg?v=1766038658"
  },
  {
    "sku": "22989/05",
    "title": "Brilliant 120\" White Colossus II 6-Blade DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/COLOSSUS_II_65_72_84_120_DC_CEILING_FAN_22979_22982_22986_22989_-_INSTRUCTION_MANUAL_V2.pdf?v=1793182346",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Colossus_II_DC_Ceiling_Fan_Data_Sheets.pdf?v=1793182346",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2298905_d2d7c475-4519-4b9d-a3ac-06e8d0b98e6c.jpg?v=1766036342"
  },
  {
    "sku": "23136/05",
    "title": "Brilliant 48\" White 3-Bladed Tonga DC ABS Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN009056_23136_05_TONGA.pdf?v=1787293919",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/TONGA_DC_Ceiling_Fan_Data_Sheet_OL.pdf?v=1787293919",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2313605.png?v=1787556004"
  },
  {
    "sku": "22878/06",
    "title": "Brilliant 48 AC Black Cairns  Ceiling Fan With B22 Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008345_CAIRNS_48-52INCH_ABS_AC_CEILING_FAN_WITH_B22_LIGHT_KIT_22878_22880.pdf?v=1755677683",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22874_22878_Cairns_AC_Ceiling_Fan_OL.pdf?v=1755607975",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2287806_4ee9eba4-6c45-450d-baef-3b222288fab8.jpg?v=1755608479"
  },
  {
    "sku": "22874/06",
    "title": "Brilliant 48 AC Black Cairns Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008344_CAIRNS_48-52INCH_ABS_AC_CEILING_FAN_WITHOUT_LIGHT_22874_22876.pdf?v=1755677580",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22874_22878_Cairns_AC_Ceiling_Fan_OL.pdf?v=1755607975",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2287406.jpg?v=1755607935"
  },
  {
    "sku": "22874/05",
    "title": "Brilliant 48 AC White Cairns Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008344_CAIRNS_48-52INCH_ABS_AC_CEILING_FAN_WITHOUT_LIGHT_22874_22876.pdf?v=1755677580",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22874_22878_Cairns_AC_Ceiling_Fan_OL.pdf?v=1755607975",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2287405.jpg?v=1755607647"
  },
  {
    "sku": "22878/05",
    "title": "Brilliant 48 AC White Cairns Ceiling Fan With B22 Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008345_CAIRNS_48-52INCH_ABS_AC_CEILING_FAN_WITH_B22_LIGHT_KIT_22878_22880.pdf?v=1755677683",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22874_22878_Cairns_AC_Ceiling_Fan_OL.pdf?v=1755607975",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2287805_2_784c9051-e06d-4b97-a319-29a9d17d99bd.jpg?v=1755838233"
  },
  {
    "sku": "23036/05",
    "title": "Brilliant 48 DC Lite White Cairns Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008799_CAIRNS_48-52-56_INCH_ABS_DC_LITE_CEILING_FAN_WITH_WITHOUT_LIGHT_23036_23037_23038_23039_23091_23092.pdf?v=1778649376",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/CAIRNS_DC_LITE_Product_Portfolio_OL.pdf?v=1778649377",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2303605.webp?v=1779336402"
  },
  {
    "sku": "23038/05",
    "title": "Brilliant 48 DC Lite White Cairns Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008799_CAIRNS_48-52-56_INCH_ABS_DC_LITE_CEILING_FAN_WITH_WITHOUT_LIGHT_23036_23037_23038_23039_23091_23092.pdf?v=1778649376",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/CAIRNS_DC_LITE_Product_Portfolio_OL.pdf?v=1778649377",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2303805_1.webp?v=1779336601"
  },
  {
    "sku": "22032/06",
    "title": "Brilliant 52\" Black Matt Grace 4-Blade DC Ceiling Fan with Remote",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2203206.jpg?v=1765864221"
  },
  {
    "sku": "22034/06",
    "title": "Brilliant 52\" Black Matt Grace 4-Blade DC Ceiling Fan with Remote and LED Light",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2203406.jpg?v=1765863996"
  },
  {
    "sku": "22945/05",
    "title": "Brilliant 52\" White Costa 3-Blade Low Profile DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0897/7625/9391/files/BLIN008350_COSTA_52_INCH_3_BLADE_HUGGER_DC_CEILING_FAN_WITH_WITHOUT_CCT_DIMMABLE_LED_LIGHT_22945_22947_Installation_Manual_08082025.pdf?v=1765776421",
    "datasheet": "https://cdn.shopify.com/s/files/1/0897/7625/9391/files/22945_22947_COSTA_DC_Ceiling_Fan-3_OL.pdf?v=1765776421",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2294505.jpg?v=1765862450"
  },
  {
    "sku": "22947/05",
    "title": "Brilliant 52\" White Costa 3-Blade Low Profile DC Ceiling Fan with LED Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0897/7625/9391/files/BLIN008350_COSTA_52_INCH_3_BLADE_HUGGER_DC_CEILING_FAN_WITH_WITHOUT_CCT_DIMMABLE_LED_LIGHT_22945_22947_Installation_Manual_08082025.pdf?v=1765776421",
    "datasheet": "https://cdn.shopify.com/s/files/1/0897/7625/9391/files/22945_22947_COSTA_DC_Ceiling_Fan-3_OL.pdf?v=1765776421",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2294705.jpg?v=1765862646"
  },
  {
    "sku": "22876/06",
    "title": "Brilliant 52 AC Black Cairns Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008344_CAIRNS_48-52INCH_ABS_AC_CEILING_FAN_WITHOUT_LIGHT_22874_22876.pdf?v=1755677580",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22876_22880_Cairns_AC_Ceiling_Fan_OL_2.pdf?v=1755604777",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2287606.jpg?v=1755606447"
  },
  {
    "sku": "22880/06",
    "title": "Brilliant 52 AC Black Cairns Ceiling Fan With B22 Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22876_22880_Cairns_AC_Ceiling_Fan_OL_2.pdf?v=1755604777",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2288006.jpg?v=1755837173"
  },
  {
    "sku": "22876/05",
    "title": "Brilliant 52 AC White Cairns Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008344_CAIRNS_48-52INCH_ABS_AC_CEILING_FAN_WITHOUT_LIGHT_22874_22876.pdf?v=1755677580",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22876_22880_Cairns_AC_Ceiling_Fan_OL_2.pdf?v=1755604777",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2287605.jpg?v=1755606174"
  },
  {
    "sku": "22880/05",
    "title": "Brilliant 52 AC White Cairns Ceiling Fan With B22 Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22876_22880_Cairns_AC_Ceiling_Fan_OL_2.pdf?v=1755604777",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2288005_cec02c85-dded-4f7b-86c6-a0d4fa98f6b0.jpg?v=1755837109"
  },
  {
    "sku": "23037/05",
    "title": "Brilliant 52 DC Lite White Cairns Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008799_CAIRNS_48-52-56_INCH_ABS_DC_LITE_CEILING_FAN_WITH_WITHOUT_LIGHT_23036_23037_23038_23039_23091_23092.pdf?v=1778649376",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/CAIRNS_DC_LITE_Product_Portfolio_OL.pdf?v=1778649377",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2303705_1.webp?v=1779336493"
  },
  {
    "sku": "23039/05",
    "title": "Brilliant 52 DC Lite White Cairns Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008799_CAIRNS_48-52-56_INCH_ABS_DC_LITE_CEILING_FAN_WITH_WITHOUT_LIGHT_23036_23037_23038_23039_23091_23092.pdf?v=1778649376",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/CAIRNS_DC_LITE_Product_Portfolio_OL.pdf?v=1778649377",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2303905_1.webp?v=1779336684"
  },
  {
    "sku": "23091/05",
    "title": "Brilliant 56 DC Lite White Cairns Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008799_CAIRNS_48-52-56_INCH_ABS_DC_LITE_CEILING_FAN_WITH_WITHOUT_LIGHT_23036_23037_23038_23039_23091_23092.pdf?v=1778649376",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/CAIRNS_DC_LITE_Product_Portfolio_OL.pdf?v=1778649377",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2309105.webp?v=1779336755"
  },
  {
    "sku": "23092/05",
    "title": "Brilliant 56 DC Lite White Cairns Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008799_CAIRNS_48-52-56_INCH_ABS_DC_LITE_CEILING_FAN_WITH_WITHOUT_LIGHT_23036_23037_23038_23039_23091_23092.pdf?v=1778649376",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/CAIRNS_DC_LITE_Product_Portfolio_OL.pdf?v=1778649377",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2309205_1.webp?v=1779336817"
  },
  {
    "sku": "22235SP002",
    "title": "Brilliant 6-Speed Remote control to suit Selected DC Ceiling Fans",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22235SP002.png?v=1787297784"
  },
  {
    "sku": "22943/06",
    "title": "Brilliant 60\" Black Fantastic 3-Blade DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0897/7625/9391/files/BLIM23090_02_FANTASTIC_52in_60in_3_BLADE_DC_CEILING_FAN_22804_22943_05_06_INSTALLATION_MANUAL.pdf?v=1765784926",
    "datasheet": "https://cdn.shopify.com/s/files/1/0897/7625/9391/files/22943_FANTASTIC_DC_Ceiling_Fan_OL.pdf?v=1765784926",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22943_06.jpg?v=1765862326"
  },
  {
    "sku": "22943/05",
    "title": "Brilliant 60\" White Fantastic 3-Blade DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0897/7625/9391/files/BLIM23090_02_FANTASTIC_52in_60in_3_BLADE_DC_CEILING_FAN_22804_22943_05_06_INSTALLATION_MANUAL.pdf?v=1765784926",
    "datasheet": "https://cdn.shopify.com/s/files/1/0897/7625/9391/files/22943_FANTASTIC_DC_Ceiling_Fan_OL.pdf?v=1765784926",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22943_05.jpg?v=1765862143"
  },
  {
    "sku": "22979/06",
    "title": "Brilliant 65\" Black Colossus II 6-Blade DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/COLOSSUS_II_65_72_84_120_DC_CEILING_FAN_22979_22982_22986_22989_-_INSTRUCTION_MANUAL_V2.pdf?v=1793182346",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Colossus_II_DC_Ceiling_Fan_Data_Sheets.pdf?v=1793182346",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2297906_98600334-d593-4562-856c-0ca92b22c90d.jpg?v=1766037333"
  },
  {
    "sku": "22979/13",
    "title": "Brilliant 65\" Satin Nickel Colossus II 6-Blade DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/COLOSSUS_II_65_72_84_120_DC_CEILING_FAN_22979_22982_22986_22989_-_INSTRUCTION_MANUAL_V2.pdf?v=1793182346",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Colossus_II_DC_Ceiling_Fan_Data_Sheets.pdf?v=1793182346",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2297913_90592880-981b-4205-bbf2-523192709f9e.jpg?v=1766036922"
  },
  {
    "sku": "22979/05",
    "title": "Brilliant 65\" White Colossus II 6-Blade DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/COLOSSUS_II_65_72_84_120_DC_CEILING_FAN_22979_22982_22986_22989_-_INSTRUCTION_MANUAL_V2.pdf?v=1793182346",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Colossus_II_DC_Ceiling_Fan_Data_Sheets.pdf?v=1793182346",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2297905_a9ed162e-617a-40e3-a83c-d89c3d260fa3.jpg?v=1766037570"
  },
  {
    "sku": "22982/06",
    "title": "Brilliant 72\" Black Colossus II 6-Blade DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/COLOSSUS_II_65_72_84_120_DC_CEILING_FAN_22979_22982_22986_22989_-_INSTRUCTION_MANUAL_V2.pdf?v=1793182346",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Colossus_II_DC_Ceiling_Fan_Data_Sheets.pdf?v=1793182346",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2298206_ef22daeb-91ef-4c49-b3eb-e87d07ec1a79.jpg?v=1766036586"
  },
  {
    "sku": "22982/13",
    "title": "Brilliant 72\" Satin Nickel Colossus II 6-Blade DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/COLOSSUS_II_65_72_84_120_DC_CEILING_FAN_22979_22982_22986_22989_-_INSTRUCTION_MANUAL_V2.pdf?v=1793182346",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Colossus_II_DC_Ceiling_Fan_Data_Sheets.pdf?v=1793182346",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2298213_51403cf7-e723-4a64-abb2-3aa7e1d2e69e.jpg?v=1766037023"
  },
  {
    "sku": "22982/05",
    "title": "Brilliant 72\" White Colossus II 6-Blade DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/COLOSSUS_II_65_72_84_120_DC_CEILING_FAN_22979_22982_22986_22989_-_INSTRUCTION_MANUAL_V2.pdf?v=1793182346",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Colossus_II_DC_Ceiling_Fan_Data_Sheets.pdf?v=1793182346",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2298205_315f6ca6-bdf7-4036-baf5-b016af58db7f.jpg?v=1766036522"
  },
  {
    "sku": "22986/06",
    "title": "Brilliant 84\" Black Colossus II 6-Blade DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/COLOSSUS_II_65_72_84_120_DC_CEILING_FAN_22979_22982_22986_22989_-_INSTRUCTION_MANUAL_V2.pdf?v=1793182346",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Colossus_II_DC_Ceiling_Fan_Data_Sheets.pdf?v=1793182346",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2298606_6cc6ee84-c983-4ca8-83c3-d5b709379701.jpg?v=1766037708"
  },
  {
    "sku": "22986/13",
    "title": "Brilliant 84\" Satin Nickel Colossus II 6-Blade DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/COLOSSUS_II_65_72_84_120_DC_CEILING_FAN_22979_22982_22986_22989_-_INSTRUCTION_MANUAL_V2.pdf?v=1793182346",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Colossus_II_DC_Ceiling_Fan_Data_Sheets.pdf?v=1793182346",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2298613_4a076ef7-25d4-42e1-b1c6-10e5854c18d3.jpg?v=1766037441"
  },
  {
    "sku": "22986/05",
    "title": "Brilliant 84\" White Colossus II 6-Blade DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/COLOSSUS_II_65_72_84_120_DC_CEILING_FAN_22979_22982_22986_22989_-_INSTRUCTION_MANUAL_V2.pdf?v=1793182346",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Colossus_II_DC_Ceiling_Fan_Data_Sheets.pdf?v=1793182346",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2298605_984a6c35-036e-4f85-a701-bf46abdd0687.jpg?v=1766037617"
  },
  {
    "sku": "20360",
    "title": "Brilliant 9W A60 E27 LED Dimmable Globe",
    "instructions": "",
    "datasheet": "",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00428_LED_globe_20360_20361_20362_20362_20364_20365.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20360_1f41702a-be43-4a60-bafd-c00772599d5d.jpg?v=1739252379"
  },
  {
    "sku": "22264",
    "title": "Brilliant Accessory Pack for CCT COB LED Strip",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22264_Datasheet.pdf?v=1736247886",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22264_SDoC.pdf?v=1736247886",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22264.jpg?v=1736342158"
  },
  {
    "sku": "22265",
    "title": "Brilliant Accessory Pack for RGB+W COB LED Strip",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22265_Datasheet.pdf?v=1736315760",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22265_SDoC.pdf?v=1736315760",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22265.jpg?v=1736330790"
  },
  {
    "sku": "20255",
    "title": "Brilliant Aluma Ceiling Fan Extension Rod 900mm with Easy Connect Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "21865/06",
    "title": "Brilliant Amari Black Smart Wi-Fi 52\'\' DC Ceiling Fan",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_WiFi_Amari-52_Fan_and_Light_21865.pdf?v=1748244529",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00700_Amari_21863_21865_21875.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21865-06_5d553b9b-25f2-4dd9-a882-2a14b2bdc902.jpg?v=1739255101"
  },
  {
    "sku": "19283",
    "title": "Brilliant Amber Moon Beam LED Vintage Filament G125 Globe",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19283_Datasheet.pdf?v=1736163740",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19283_be2c7816-ab3c-43a7-9267-e136f0a4174a.jpg?v=1739252071"
  },
  {
    "sku": "22555/06",
    "title": "Brilliant Anka Black 18W CCT Up/Down Wall Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/INSTRUCTIONS_ANKA_22555_LED_CCT_up_down_wall_light_28052024_7be5fbeb-4834-4bfa-90dc-ffb8c6d020b4.pdf?v=1742355668",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22555_22561_ANKA_CCT_UP_DOWN_Wall_Light_OL.pdf?v=1742355669",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00866_Anka_22551_22553_22555_22557_22559_22561.pdf?v=1742355621",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2255506.jpg?v=1742355583"
  },
  {
    "sku": "22551/06",
    "title": "Brilliant Anka Black 9W CCT Surface Mount Downlight",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22551_Datasheet_b1c80fab-18c5-4d33-a4d1-217597cba178.pdf?v=1736321046",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22551_SDoC_99f3763f-a710-4d11-b1ad-99634a03e79f.pdf?v=1736321045",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22551-06.jpg?v=1739250889"
  },
  {
    "sku": "22553/06",
    "title": "Brilliant Anka Black 9W CCT Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22553_22559_ANKA_CCT_Fixed_Wall_Light_OL.pdf?v=1748244532",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00866_Anka_Wall_Light_22551_22553_22555_22557_22559_22561.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2255306_67cfe698-7328-41c9-a2e0-3402f9135dab.jpg?v=1737713546"
  },
  {
    "sku": "22557/06",
    "title": "Brilliant Anka Plus Black 12W CCT Surface Mount Downlight",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22557_Datasheet_a6c8009c-00f8-4bae-996a-b89ce96ac979.pdf?v=1736321126",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22557_SDoC_29c0b299-c829-4247-8739-432375e15013.pdf?v=1736321125",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22557-06.jpg?v=1739250944"
  },
  {
    "sku": "22559/06",
    "title": "Brilliant Anka Plus Black 12W CCT Wall Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22559_IM_2d380353-f548-44a0-85fb-ac8c5cc7ec7d.pdf?v=1736321256",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22553_22559_ANKA_CCT_Fixed_Wall_Light_OL.pdf?v=1748244532",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22559_SDoC_cb99c6a1-2822-4f5b-bcf3-1495db803e83.pdf?v=1736321256",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2255906_d6dbded9-06fa-43c8-b095-54ed2f6ee95d.jpg?v=1737713620"
  },
  {
    "sku": "22561/06",
    "title": "Brilliant Anka Plus Black 24W CCT Up/Down Wall Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/INSTRUCTIONS_ANKA_PLUS_22561_LED_CCT_up_down_wall_light_20062024_641c3b7e-d40c-4628-8d85-9924fcdefa69.pdf?v=1742355668",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22555_22561_ANKA_CCT_UP_DOWN_Wall_Light_OL.pdf?v=1742355669",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00866_Anka_22551_22553_22555_22557_22559_22561.pdf?v=1742355621",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2256106_1.jpg?v=1742355461"
  },
  {
    "sku": "22557/05",
    "title": "Brilliant Anka Plus White 12W CCT Surface Mount Downlight",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22557_Datasheet_a6c8009c-00f8-4bae-996a-b89ce96ac979.pdf?v=1736321126",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22557_SDoC_29c0b299-c829-4247-8739-432375e15013.pdf?v=1736321125",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22557-05.jpg?v=1739250918"
  },
  {
    "sku": "22559/05",
    "title": "Brilliant Anka Plus White 12W CCT Wall Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22559_IM_2d380353-f548-44a0-85fb-ac8c5cc7ec7d.pdf?v=1736321256",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22553_22559_ANKA_CCT_Fixed_Wall_Light_OL.pdf?v=1748244532",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22559_SDoC_cb99c6a1-2822-4f5b-bcf3-1495db803e83.pdf?v=1736321256",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2255905_dedcd0fe-c4f8-4d4b-ae4e-79bed3c0f338.jpg?v=1737713597"
  },
  {
    "sku": "22561/05",
    "title": "Brilliant Anka Plus White 24W CCT Up/Down Wall Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/INSTRUCTIONS_ANKA_PLUS_22561_LED_CCT_up_down_wall_light_20062024_641c3b7e-d40c-4628-8d85-9924fcdefa69.pdf?v=1742355668",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22555_22561_ANKA_CCT_UP_DOWN_Wall_Light_OL.pdf?v=1742355669",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00866_Anka_22551_22553_22555_22557_22559_22561.pdf?v=1742355621",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2256105_1.jpg?v=1742355432"
  },
  {
    "sku": "22555/05",
    "title": "Brilliant Anka White 18W CCT Up/Down Wall Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/INSTRUCTIONS_ANKA_22555_LED_CCT_up_down_wall_light_28052024_7be5fbeb-4834-4bfa-90dc-ffb8c6d020b4.pdf?v=1742355668",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22555_22561_ANKA_CCT_UP_DOWN_Wall_Light_OL.pdf?v=1742355669",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00866_Anka_22551_22553_22555_22557_22559_22561.pdf?v=1742355621",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2255505.jpg?v=1742355553"
  },
  {
    "sku": "22551/05",
    "title": "Brilliant Anka White 9W CCT Surface Mount Downlight",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22551_Datasheet_b1c80fab-18c5-4d33-a4d1-217597cba178.pdf?v=1736321046",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22551_SDoC_99f3763f-a710-4d11-b1ad-99634a03e79f.pdf?v=1736321045",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22551-05.jpg?v=1739250839"
  },
  {
    "sku": "22553/05",
    "title": "Brilliant Anka White 9W CCT Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22553_22559_ANKA_CCT_Fixed_Wall_Light_OL.pdf?v=1748244532",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00866_Anka_Wall_Light_22551_22553_22555_22557_22559_22561.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2255305_0b581af5-1e7f-4ebd-8ca9-e2049955a131.jpg?v=1737713517"
  },
  {
    "sku": "20167/05",
    "title": "Brilliant Antique White Vector 52\'\' AC ABS Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20167_IM.pdf?v=1736405012",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20167_Datasheet.pdf?v=1736405012",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20167_SDoC.pdf?v=1736405012",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20167_Extension_Rod.pdf?v=1736405011",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2016705_aebf7a2f-6546-44cb-819a-3f4eec9f2345.jpg?v=1761541939"
  },
  {
    "sku": "20168/05",
    "title": "Brilliant Antique White Vector 52 AC Ceiling Fan with Ezy-Fit ABS Blades",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20168_IM.pdf?v=1736331926",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Vector52_Fan_20167-20168_2.pdf?v=1742439443",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20168_SDoC.pdf?v=1736331926",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20168_Extension_Rod.pdf?v=1736331925",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2016805_17a56039-45dd-43f9-b3dc-911403921999.jpg?v=1746156497"
  },
  {
    "sku": "20918/06",
    "title": "Brilliant Bahama Black Smart Wi-Fi 52\'\' DC Ceiling Fan with CCT LED",
    "instructions": "",
    "datasheet": "",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00587_Bahama_20918.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2091806_56fefd30-e9e5-4683-8721-a5f0ba976486.jpg?v=1737005666"
  },
  {
    "sku": "18562/09",
    "title": "Brilliant Beige Flexiscan PIR Security Sensor (Series 2)",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18562_Datasheet_59056296-9abf-44c2-8f4b-cbd83670b18b.pdf?v=1736313284",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18562_SDoC_f953ac50-12c9-411f-bc8e-eb950862d37e.pdf?v=1736313284",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1856209.jpg?v=1736336696"
  },
  {
    "sku": "17911/09",
    "title": "Brilliant Beige Villa Coach Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/17911_Datasheet_5965b160-e8f1-4586-beca-bfdd632c1c9d.pdf?v=1736311157",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1791109.jpg?v=1736340429"
  },
  {
    "sku": "22242/06",
    "title": "Brilliant Black 18W CCT Dimmable Fan Light Kit",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22242_Datasheet_f217adf2-a85e-46c1-a863-e6ff2359d49e.pdf?v=1736313830",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00806_Tempo_Plus_22270_22273_22276_22279_22242.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2224206.jpg?v=1736334156"
  },
  {
    "sku": "19918/06",
    "title": "Brilliant Black 2-Pin 10m Garden Light Cable",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Garden_Light_Cable_21638-19918-20704-21637-19919.pdf?v=1748244529",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19918_06.jpg?v=1736406794"
  },
  {
    "sku": "21638/06",
    "title": "Brilliant Black 2-Pin 5m Garden Light Cable",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Garden_Light_Cable_21638-19918-20704-21637-19919.pdf?v=1748244529",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2163806.jpg?v=1736332529"
  },
  {
    "sku": "19919/06",
    "title": "Brilliant Black 2-Pin Garden Cable Splitter",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Garden_Light_Cable_21638-19918-20704-21637-19919.pdf?v=1748244529",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19919_06.jpg?v=1736419947"
  },
  {
    "sku": "21657/06",
    "title": "Brilliant Black 20W CCT Fan Light Kit for Aris, Como and Supra Ceiling Fans",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21657_IM.pdf?v=1736230406",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21657_Datasheet.pdf?v=1736230406",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00644_Como_Light_Kit_21341_21345_21348_21657.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2165706.jpg?v=1736414010"
  },
  {
    "sku": "22808/06",
    "title": "Brilliant Black 20W LED Fan Light Kit for Fantastic Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIM23091_01_FANTASTIC_DC_CEILING_FAN_LED_LIGHTKIT_22808_-_INSTRUCTION_MANUAL_V2.pdf?v=1765868537",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22808_05_06_FANTASTIC_LED_Light_Kit_OL.pdf?v=1765868542",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22808_05_6ed42081-fc59-422f-98f4-741eaa572ffc.jpg?v=1765868666"
  },
  {
    "sku": "20704/06",
    "title": "Brilliant Black 4-Pin 2.5m Garden Light Cable",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Garden_Light_Cable_21638-19918-20704-21637-19919.pdf?v=1748244529",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00523_Garden_Light_Kit_20701_20702_20703_20704_20953_20954_20958.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2070406.jpg?v=1736499916"
  },
  {
    "sku": "21637/06",
    "title": "Brilliant Black 4-Pin 5m Garden Light Cable",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Garden_Light_Cable_21638-19918-20704-21637-19919.pdf?v=1748244529",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2163706.jpg?v=1736413849"
  },
  {
    "sku": "21723/06",
    "title": "Brilliant Black Amari Series II  56\'\' DC 5-Blades Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21723_IM_6be485a6-5b6d-4ef7-a7ef-dba7895c3c82.pdf?v=1736404841",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21723_Datsheet_26118be2-ec8f-4a0b-9ea3-40a06ed4c34c.pdf?v=1736404840",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21723_SDoC_8fe67e18-8191-4959-9920-5e89efe486d4.pdf?v=1736404840",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21723_Extension_Rod_d7b7eed1-18fc-471c-9c84-b2e154b11558.pdf?v=1736404839",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21723-06.jpg?v=1739186190"
  },
  {
    "sku": "21719/06",
    "title": "Brilliant Black Amari Series II 4-Blades 52\'\' DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21719_IM_f493eac6-ad68-4d07-b37d-4568d21cc21e.pdf?v=1736400491",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21719_Datasheet_e9b77058-28b7-470c-b1a6-582787937170.pdf?v=1736400491",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21719_SDoC_c4c8d77d-64a0-40f4-9346-897cd52d0341.pdf?v=1736400491",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21719_Extension_Rod_001d81be-4fe7-414d-970e-6f7c9b5afd69.pdf?v=1736400490",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21719-06_939102af-6fc8-4d79-8cb4-2a7759b02ba2.jpg?v=1739188337"
  },
  {
    "sku": "21933/06",
    "title": "Brilliant Black Archy LED CCT Recessed Face Downlight",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21933_Datasheet_1abf2117-a6c6-48aa-8bce-ad47acc79a8c.pdf?v=1736248208",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00727_Archy_21933.pdf?v=1757906122",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21933-06.jpg?v=1739250174"
  },
  {
    "sku": "18839/06",
    "title": "Brilliant Black Astro Clip Lamp",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "21363/06",
    "title": "Brilliant Black Avenger RGB 30W DIY Floodlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21363_IM.pdf?v=1736225231",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21363_Datasheet.pdf?v=1736225232",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21363_SDoC.pdf?v=1736225232",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2136306.jpg?v=1736417976"
  },
  {
    "sku": "19667/06",
    "title": "Brilliant Black Avenger-II 20W LED DIY Floodlight with Sensor",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "19587/06",
    "title": "Brilliant Black Bahama 52\" DC Ceiling Fan",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19587_Datasheet_98375f0e-df39-4195-ad30-c644b90be412.pdf?v=1736407031",
    "sdoc": "",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19587_Extension_Rod_a35da56e-0873-49aa-87a7-2f6a73837ca0.pdf?v=1736407030",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19587-06.jpg?v=1739184958"
  },
  {
    "sku": "100550/06",
    "title": "Brilliant Black Bahama Ceiling Fan Extension Rod 900mm with Easy Connect Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "21845/06",
    "title": "Brilliant Black Belize 52\" DC 3-Blade Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21845_IM_85747530-3a48-48c4-bc7a-779f4818a5a1.pdf?v=1736407334",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21845_Datasheet_3cb73972-d15d-416c-ad86-69dc5811ad9e.pdf?v=1736407330",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21845_SDoC_a71b6758-fe19-4b64-a9a7-f7d6e12fe610.pdf?v=1736407329",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21845-06.jpg?v=1739186388"
  },
  {
    "sku": "99939/06",
    "title": "Brilliant Black Berea Exterior Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99939_Datasheet.pdf?v=1736408659",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00897_Berea_99939_SII_17383_18043.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/9993906.jpg?v=1736253042"
  },
  {
    "sku": "19893/06",
    "title": "Brilliant Black Blade Exit Sign Surface Mount Box Only",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "19878/06",
    "title": "Brilliant Black Blade Recessed 2W LED Emergency Exit Sign",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19878IM_f1b6426b-f57a-4da2-8be8-7dee62d04b68.pdf?v=1736230236",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19878_data_sheet_244928e4-5c4f-4cdb-b170-ffc8fdda5968.pdf?v=1736230236",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19878SDoc_5f98c9a6-1f3d-4e69-9f82-c071ba6c7a30.pdf?v=1736230236",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1987806.jpg?v=1736414192"
  },
  {
    "sku": "21634/06",
    "title": "Brilliant Black Botanic 9W Garden Spotlight",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "21636/06",
    "title": "Brilliant Black Botanic Dusk-to-Dawn Controller",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21636_IM.pdf?v=1736242193",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21636_IM.pdf?v=1736242193",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2163606.jpg?v=1736408053"
  },
  {
    "sku": "20702/06",
    "title": "Brilliant Black Botanic Smart Wi-Fi RGB Garden Light Kit",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Botanic_Garden_Light_Kit_Smart_20702.pdf?v=1742167998",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00523_Smart_Garden_Light_20702.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2070206_54aed9ab-ece9-4e61-b88d-866aeb517dc9.jpg?v=1738646359"
  },
  {
    "sku": "21639/06",
    "title": "Brilliant Black Brilliant Botanic 15cm Extension Spike Rod",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "18769/06",
    "title": "Brilliant Black Ceiling Fan Extension Rod 1800mm with Easy Connect Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "20265/06",
    "title": "Brilliant Black Ceiling Fan Extension Rod 900mm with Assembled Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "22084/06",
    "title": "Brilliant Black Celebrate 10 Light Festoon Extension Add-on Kit",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22084_Datasheet.pdf?v=1736244982",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00786_Celebrate_22082_22083_22084.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2208406.jpg?v=1736406503"
  },
  {
    "sku": "22082/06",
    "title": "Brilliant Black Celebrate 10 Light Festoon Light Kit",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22082_IM.pdf?v=1736307375",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22082_Datasheet.pdf?v=1736307375",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00786_Celebrate_22082_22083_22084.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2208206.jpg?v=1736341479"
  },
  {
    "sku": "22083/06",
    "title": "Brilliant Black Celebrate 20 Light Festoon Light Kit",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22083_IM.pdf?v=1736241855",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22083_Datasheet.pdf?v=1736241855",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00786_Celebrate_22082_22083_22084.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2208306.jpg?v=1736408374"
  },
  {
    "sku": "22128/06",
    "title": "Brilliant Black Ceres CCT 3-Light Track Kit",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22128_IM_3fc2f52a-b602-4c48-ab93-fe8a89b5fd0d.pdf?v=1736314373",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22128_Datasheet_dbf32af4-b50c-4767-89c9-f46a4a9c160a.pdf?v=1736314372",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00824_Ceres_track_22128.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22128_06_7e074c80-b8f8-49d4-9df8-8201d0eb4841.jpg?v=1737620198"
  },
  {
    "sku": "22127/06",
    "title": "Brilliant Black Ceres CCT Spotlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22127_IM_25b3b09f-ef89-4680-9939-55d0bb8a6b77.pdf?v=1736316556",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22127_Datasheet_887512f0-2c80-4d45-b8e8-26c17d60c0cf.pdf?v=1736316556",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00893_Ceres_22127.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22127_06_92e93612-92ff-4cc6-b83a-d6fc8dd1ffd4.jpg?v=1737457100"
  },
  {
    "sku": "22781/06",
    "title": "Brilliant Black Ceres Pendant Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22781_IM_e8a6f718-0779-4847-b85a-6e0731ff58e5.pdf?v=1736231145",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22781_Datasheet_7a5cb4f0-71a1-4f04-92ef-8094b7d75b0c.pdf?v=1736231145",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22781_SDoC_b0a47ef5-b320-4818-b8b9-be7943a90b18.pdf?v=1736231145",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22781_06.jpg?v=1736478792"
  },
  {
    "sku": "22677/06",
    "title": "Brilliant Black Colossus 120\" DC Ceiling Fan 6-Blade",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22677_IM_c3e42212-0cac-4fc3-801c-010a100772ba.pdf?v=1736409789",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22677_Datasheet_07ef8c7e-09d7-41a3-92b6-9b3df91ac679.pdf?v=1736409789",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00844_Colossus_22319_22573_22570_22677.pdf?v=1750048828",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22677_Extension_Rod_25c69be9-308d-4161-8326-57663cf1eef6.pdf?v=1736409788",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22677-06.jpg?v=1739187594"
  },
  {
    "sku": "22319/06",
    "title": "Brilliant Black Colossus 84\" DC Ceiling Fan 6-Blade",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22319_IM_db9811ac-9e15-4bbb-878c-3ddb90e487b1.pdf?v=1736404250",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22319_Datasheet_4fe78a71-c0e8-4786-8bbc-0dae1a4a295b.pdf?v=1736404249",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00844_Colossus_22319_22573_22570_22677.pdf?v=1750048828",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22319_Extension_Rod_5e6748b4-1d65-4085-a243-644cf448a26e.pdf?v=1736404249",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22319-06.jpg?v=1739187443"
  },
  {
    "sku": "20071/06",
    "title": "Brilliant Black Concorde-II 12W LED Light Kit",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20071_Datasheet.pdf?v=1736230887",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2007106.jpg?v=1736413368"
  },
  {
    "sku": "17530/06",
    "title": "Brilliant Black Denver-II LED Exterior Adjustable Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/17530_Datasheet.pdf?v=1736230553",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00321_Denver_II_17529_17530.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1753006.jpg?v=1736413949"
  },
  {
    "sku": "17529/06",
    "title": "Brilliant Black Denver-II LED Exterior Up/Down Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/17529_Datasheet.pdf?v=1736314770",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00321_Denver_II_17529_17530.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1752906.jpg?v=1736332448"
  },
  {
    "sku": "22804/06",
    "title": "Brilliant Black Fantastic 52\'\' DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIMXXXX_01_FANTASTIC_52in_3_BLADE_DC_CEILING_FAN_22804_05_06_INSTALLATION_MANUAL_31072024.pdf?v=1769747425",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22804_Datasheet_b7cc33be-aded-4643-b50e-46599b0cb148.pdf?v=1736320944",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00870_Fantastic_22804.pdf?v=1757906122",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22804-06.jpg?v=1739188184"
  },
  {
    "sku": "18675/06",
    "title": "Brilliant Black Finn Gloss Metal Pendant Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18675_IM.pdf?v=1736221051",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18675_Datasheet.pdf?v=1736221051",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18675_06.jpg?v=1736500127"
  },
  {
    "sku": "18562/06",
    "title": "Brilliant Black Flexiscan PIR Security Sensor (Series 2)",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18562_Datasheet_59056296-9abf-44c2-8f4b-cbd83670b18b.pdf?v=1736313284",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18562_SDoC_f953ac50-12c9-411f-bc8e-eb950862d37e.pdf?v=1736313284",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1856206.jpg?v=1736409848"
  },
  {
    "sku": "21640/06",
    "title": "Brilliant Black Ground Mounting Base for Botanic Garden Spotlight",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "22908/06",
    "title": "Brilliant Black Hardy 12W CCT Bunker Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22908_Hardy_Bunker_Light_OL.pdf?v=1781577871",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2290806_1.webp?v=1781609386"
  },
  {
    "sku": "19973/06",
    "title": "Brilliant Black Hardy Led Eyelid Vandal-Proof Polycarbonate Bunker",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19973_Datasheet_d3ebb46b-e2e2-476f-9716-b248c11a07e1.pdf?v=1736400956",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00888_Hardy_19971_19973.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1997306.jpg?v=1736318813"
  },
  {
    "sku": "19971/06",
    "title": "Brilliant Black Hardy LED Vandal-Proof Polycarbonate Bunker Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19971_Datasheet_387e5586-5a06-4e7b-b821-06b26e8f08a2.pdf?v=1736331887",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00888_Hardy_19971_19973.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1997106.jpg?v=1736323634"
  },
  {
    "sku": "20845/06",
    "title": "Brilliant Black Heated Towel Rail 5 Bar Hardwired",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20845_Datasheet.pdf?v=1736331781",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00567_Tower_Rail_20796_20845.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2084506.jpg?v=1736322778"
  },
  {
    "sku": "19604/06",
    "title": "Brilliant Black Hemingway Floor Lamp",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "22545/06",
    "title": "Brilliant Black Hendrick 15W 60cm LED Wall Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22545_IM.pdf?v=1736220631",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22545_Datasheet.pdf?v=1736220630",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22545_SDoC_a56277d2-0e9b-4fb8-9955-d1bc635afbb8.pdf?v=1736220630",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22545_06.jpg?v=1736402250"
  },
  {
    "sku": "22546/06",
    "title": "Brilliant Black Hendrick 22W 120cm LED Wall Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22546_IM.pdf?v=1736220719",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22546_Datasheet.pdf?v=1736220718",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22546_SDoC.pdf?v=1736220718",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22546_06.jpg?v=1736419701"
  },
  {
    "sku": "22547/06",
    "title": "Brilliant Black Hendrick 36W 180cm LED Wall Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22547_IM.pdf?v=1736246911",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22547_Datasheet.pdf?v=1736246911",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22547_SDoC._pdf.pdf?v=1736246911",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22547_06.jpg?v=1736405190"
  },
  {
    "sku": "21466/06",
    "title": "Brilliant Black Hercules -120\'\' 1800mm Ceiling Fan Extension Rod",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "21021/06",
    "title": "Brilliant Black Hercules 120\'\' Ceiling Fan Extension Rod 900mm with Easy Connect Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "20616/06",
    "title": "Brilliant Black Hunter Trio Single Floodlight",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20616_Datasheet_2ef1fda7-655c-416c-b5cc-3236d81b0613.pdf?v=1736311519",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00697_Hunter_Trio_20616_20622_20625.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2061606.jpg?v=1736340158"
  },
  {
    "sku": "20622/06",
    "title": "Brilliant Black Hunter Trio Twin Floodlight",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20622_Datasheet.pdf?v=1736246500",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00697_Hunter_Trio_20616_20622_20625.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2062206.jpg?v=1736405986"
  },
  {
    "sku": "20625/06",
    "title": "Brilliant Black Hunter Trio Twin Floodlight with Sensor",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20625_Datasheet_917e4c9e-5c0c-45b3-b62c-2225bbf18f23.pdf?v=1736315829",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00697_Hunter_Trio_20616_20622_20625.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2062506.jpg?v=1736416333"
  },
  {
    "sku": "19239/06",
    "title": "Brilliant Black Hunter-III LED Single Light Floodlight",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19239_Datasheet_ecfcea38-826b-4e51-bf2a-ba711fd64e1c.pdf?v=1736242304",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00353_Hunter_III_19242_19245_19239_19975.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1923906.jpg?v=1736407978"
  },
  {
    "sku": "19975/06",
    "title": "Brilliant Black Hunter-III LED Single Light Floodlight with Sensor",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19975_Datasheet_0c600b0a-41b0-45f8-888f-bbefe6b84b6d.pdf?v=1736315317",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00353_Hunter_III_19242_19245_19239_19975.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1997506.jpg?v=1736405863"
  },
  {
    "sku": "19242/06",
    "title": "Brilliant Black Hunter-III LED Twin Light Floodlight",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19242_Datasheet.pdf?v=1736226474",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00353_Hunter_III_19242_19245_19239_19975.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1924206.jpg?v=1736416799"
  },
  {
    "sku": "19245/06",
    "title": "Brilliant Black Hunter-III LED Twin Light Floodlight with Sensor",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19245_Datasheet_b1167f13-abf6-4cd3-89e0-e3a0cea39b2d.pdf?v=1736311319",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00353_Hunter_III_19242_19245_19239_19975.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1924506.jpg?v=1736340367"
  },
  {
    "sku": "21427/06",
    "title": "Brilliant Black Kalla Floor Lamp",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21427_IM_72aa4611-9336-41f7-8ace-9c3d62d22beb.pdf?v=1736243945",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21427_Datasheet_b2189bf6-4b17-462a-8ad1-d0702efe2449.pdf?v=1736243945",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00681_Kalla_Task_Lamp_21426_21427.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2142706.jpg?v=1736478233"
  },
  {
    "sku": "21426/06",
    "title": "Brilliant Black Kalla LED Task Lamp",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21426_IM_556b568c-ec6d-42cd-b59c-55b3d027c2a1.pdf?v=1736242966",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21426_Datasheet_15069b85-c40b-43d0-a191-644d5f1a6749.pdf?v=1736242966",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21426_SDoC_2b2775c6-4b18-4d9c-a19a-3d172ea73389.pdf?v=1736242966",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2142606.jpg?v=1736407554"
  },
  {
    "sku": "22016/06",
    "title": "Brilliant Black Kensley 10W Impact Poly LED Bunker Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Kensley_Bunker_Light_22016_22018.pdf?v=1748244529",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00784_Kensley_22016_22018.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2201606.jpg?v=1738646927"
  },
  {
    "sku": "22020/06",
    "title": "Brilliant Black Kensley 20W CCT LED Bunker Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22020.pdf?v=1741316346",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2202006_2358ca15-a78d-49ad-92de-c688b0bf660c.jpg?v=1737622236"
  },
  {
    "sku": "22018/06",
    "title": "Brilliant Black Kensley 20W Impact Poly LED Bunker Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Kensley_Bunker_Light_22016_22018.pdf?v=1748244529",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00784_Kensley_22016_22018.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2201806_cc3cd427-6bcb-4e36-9f25-93898674d05b.jpg?v=1737622593"
  },
  {
    "sku": "18991/06",
    "title": "Brilliant Black Kyoto Table Lamp",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18991_IM.pdf?v=1736313110",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18991_Datasheet.pdf?v=1736313110",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1899106.jpg?v=1737620637"
  },
  {
    "sku": "21430/06",
    "title": "Brilliant Black Laine LED Task Lamp",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21430_IM_7736e9d9-4824-48cd-9301-8ec24c42a82c.pdf?v=1736312908",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21430_Datasheet_5efbde89-aa54-4b64-95ca-8c840ae95288.pdf?v=1736312908",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21430_SDoC_d9cd1954-47c4-4465-8cbe-cf3656a39d0d.pdf?v=1736312908",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2143006_c6eb8285-d80d-44d0-9a57-cb30fd87a1e3.jpg?v=1738064344"
  },
  {
    "sku": "22201/06",
    "title": "Brilliant Black LED 22W Light Kit for Mascot DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22201_IM.pdf?v=1736310810",
    "datasheet": "",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00756_Mascot_22197_22199_22201.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2220106.jpg?v=1736341133"
  },
  {
    "sku": "22882/06",
    "title": "Brilliant Black LED Light Kit for Cairns Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008343_CAIRNS_48-52_18W_CCT_LED_LIGHT_KIT_22882.pdf?v=1755677502",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22882_Cairns_LED_Light_Kit-2_OL.pdf?v=1764057532",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2288206.jpg?v=1755608943"
  },
  {
    "sku": "22747/06",
    "title": "Brilliant Black Luca Pendant Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22747_IM_8bcd74c9-5188-4a9b-b44a-1288b9475f03.pdf?v=1736313475",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22747_Datasheet_d8477044-1db2-4705-9883-12d1a75fcf05.pdf?v=1736313476",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22747_SDoC_c0708364-f807-4b67-9f10-fede734dedd2.pdf?v=1736313475",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22747_06.jpg?v=1736478918"
  },
  {
    "sku": "21478/06",
    "title": "Brilliant Black Marvel 3-In-1 Bathroom Mate",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21478_IM_7e814c13-af44-424e-a3d3-939d0f748633.pdf?v=1736399016",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21478_Datasheet_9bd4e98a-5930-45ad-a007-ccb8c0a5ed6b.pdf?v=1736399016",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21478_SDoC_a86cb05c-e300-4295-bae4-d14135f0c596.pdf?v=1736399015",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2147805_17826a4c-2237-4e36-b3d6-7d97545b467e.jpg?v=1737630528"
  },
  {
    "sku": "22197/06",
    "title": "Brilliant Black Mascot 52\" DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22197_IM_b574f47d-355f-406e-9791-2c9cd08c4ffa.pdf?v=1736330602",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22197_Datasheet_eca9ebfc-b1e3-489c-97e9-81187956f70d.pdf?v=1736330602",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00756_Mascot_22197_22199_22201.pdf?v=1750048828",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22197_Extension_Rod_22e0369f-d4b3-454a-bb4a-97936da9077f.pdf?v=1736330601",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22197-06.jpg?v=1739186857"
  },
  {
    "sku": "22199/06",
    "title": "Brilliant Black Mascot 58 DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22199_IM.pdf?v=1736335218",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22199_Datasheet.pdf?v=1736335218",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00756_Mascot_22197_22199_22201.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22199-06.jpg?v=1739186944"
  },
  {
    "sku": "20454/06",
    "title": "Brilliant Black Mini Trim II CCT Gimbal Downlight",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20454_Datasheet_88808674-e553-4383-98bb-c2dd8e30569f.pdf?v=1736316452",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00889_Mini_Trim_20454.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20454-06.jpg?v=1739249514"
  },
  {
    "sku": "20429SP001/06",
    "title": "Brilliant Black Optional Trilogy Rings for 20429 LED Downlight-5-Pack",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "19921/06",
    "title": "Brilliant Black Pinnacle LED Garden Spotlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19921_IM.pdf?v=1736231325",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19921_Datasheet.pdf?v=1736231325",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00886_Garden_Light_19917_19920_19921_19922_19923_19924_19925.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1992106.jpg?v=1736412955"
  },
  {
    "sku": "22087/06",
    "title": "Brilliant Black Preston 48\" DC Ceiling Fan Hugger",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22087_IM_0dc8e114-fd6d-4882-822e-96686275452c.pdf?v=1736400609",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22087_Datasheet_dc92519f-87d6-4222-bbbc-3006a4aca897.pdf?v=1736400609",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22087-06.jpg?v=1739186758"
  },
  {
    "sku": "21910/06",
    "title": "Brilliant Black Rawson 100W CCT Slim DIY Floodlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21910_IM.pdf?v=1736162964",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21910_Datasheet.pdf?v=1736162963",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00818_Rawson_21908_21909_21910.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2191006.jpg?v=1736342946"
  },
  {
    "sku": "21908/06",
    "title": "Brilliant Black Rawson 20W CCT Slim DIY Floodlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21908_IM.pdf?v=1736225952",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21908_Datasheet.pdf?v=1736225952",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00818_Rawson_21908_21909_21910.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2190806.jpg?v=1736417585"
  },
  {
    "sku": "21909/06",
    "title": "Brilliant Black Rawson 50W CCT Slim DIY Floodlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21909_IM.pdf?v=1736311736",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21909_Datasheet.pdf?v=1736311735",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00818_Rawson_21908_21909_21910.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2190906.jpg?v=1736339664"
  },
  {
    "sku": "19689/06",
    "title": "Brilliant Black Rectangle Bolton LED Exterior Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19689_Datasheet.pdf?v=1736316518",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00877_Bolton_Bunker_19688_19689.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1968906.jpg?v=1736489837"
  },
  {
    "sku": "21625SP001",
    "title": "Brilliant Black Seaford 20cm Extension Rod for Garden Lights",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "20601/06",
    "title": "Brilliant Black Seaford LED Exterior Up/Down Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20601_Datasheet_8e5b6cca-bdec-40e4-9166-a076028806a7.pdf?v=1736247772",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00536_Seaford_20597_20601_20605_20607.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2060106.jpg?v=1737714359"
  },
  {
    "sku": "20597/06",
    "title": "Brilliant Black Seaford LED Exterior Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20597_Datasheet_aa44543d-88aa-43c6-84e0-f156b3440dcb.pdf?v=1736227640",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20597_SDoC_2f0ce134-e5a8-46c8-a17a-eb21e2035ec1.pdf?v=1736227639",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2059706.jpg?v=1737714093"
  },
  {
    "sku": "21625/06",
    "title": "Brilliant Black Seaford LED Garden Spotlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21625_IM_052c6168-a1f3-436a-ae2e-e9e364cc1f74.pdf?v=1736316183",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21625_Datasheet_46bf5079-d5b4-41bc-8669-8f10ce1145fb.pdf?v=1736316183",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2162506.jpg?v=1738646373"
  },
  {
    "sku": "22810/06",
    "title": "Brilliant Black Seema Linear Pendant Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22810_IM.pdf?v=1736314184",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22810_Datasheet.pdf?v=1736314184",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22810_SDoC.pdf?v=1736314184",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22810_06.jpg?v=1736479114"
  },
  {
    "sku": "20788/06",
    "title": "Brilliant Black Shielder LED Single Light Floodlight",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20788_Datasheet_796458ca-134d-479f-aa11-5bbbe6248c4e.pdf?v=1736226638",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00569_Shielder_20784_20786_20788.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2078806.jpg?v=1736416746"
  },
  {
    "sku": "20786/06",
    "title": "Brilliant Black Shielder LED Twin Floodlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Shielder_20786_Double_Instructions____12082019.pdf?v=1746509974",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20786_Datasheet_3e76373d-09fb-49e0-8185-3dcc3d95c8ce.pdf?v=1736313208",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00569_Shielder_20784_20786_20788.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2078606.jpg?v=1736409797"
  },
  {
    "sku": "20784/06",
    "title": "Brilliant Black Shielder LED Twin Light Floodlight with Sensor",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20784_Datasheet_673655ff-5220-4e8a-a85e-0fec30b38a76.pdf?v=1736314147",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00569_Shielder_20784_20786_20788.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2078406.jpg?v=1736333448"
  },
  {
    "sku": "21463",
    "title": "Brilliant Black Smart Nexus Universal Gateway Home Lite",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21463_IM_1515b510-74b8-49db-8e2e-439bf8f52c4f.pdf?v=1736226781",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21463_Datasheet_7a23d228-f47e-44fe-b998-e0d4ff33ea8c.pdf?v=1736226779",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21463SDoC_a773ae44-2358-463a-bcbc-0459f233f5bc.pdf?v=1736226779",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21463_1.jpg?v=1737354012"
  },
  {
    "sku": "21464",
    "title": "Brilliant Black Smart Nexus Universal Gateway Home Plus",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21464_IM.pdf?v=1734501310",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21464_Datasheet.pdf?v=1734501318",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00667_Nexus_Gateway_21463_21464_21465.pdf?v=1757906122",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2146401.jpg?v=1736416177"
  },
  {
    "sku": "22163/06",
    "title": "Brilliant Black Smart Wi-Fi Video Doorbell and Chime",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_WiFi_Doorbell_and_Chime_22163.pdf?v=1748244528",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00878_Door_Bell_Chime_22163.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2216306_1.jpg?v=1737005664"
  },
  {
    "sku": "21476/06",
    "title": "Brilliant Black Solace 4-In-1 Bathroom Mate",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21476_IM_edbc0668-2302-4dd6-ae01-f49c6c083bff.pdf?v=1736404666",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21476_Datasheet_895b7213-e49c-4ebf-b079-c4a058f37e34.pdf?v=1736404666",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21476_SDoC_b9df3c4c-2363-469f-864f-4a5eea84f611.pdf?v=1736404665",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2147606.jpg?v=1736257554"
  },
  {
    "sku": "21785/06",
    "title": "Brilliant Black Solace XL 4-In-1 Bathroom Mate",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21785_IM_55c8730e-b3da-4f0e-9450-c6ed37f9a72a.pdf?v=1736394306",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21785_Datasheet_e256f696-d6fa-4cc6-8cc2-e7533466277b.pdf?v=1736394306",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21785_SDoC_e9605dc1-0606-416e-83ef-0eb1fa7dc4a2.pdf?v=1736394306",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2178506.jpg?v=1736319406"
  },
  {
    "sku": "22767/06",
    "title": "Brilliant Black Solana 18W LED CCT Light Kit",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIM23089_01_SOLANA_CEILING_FAN_LED_LIGHTKIT_22767_05_06_INSTALLATION_MANUAL_21112024.pdf?v=1769747425",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2276706.jpg?v=1756353511"
  },
  {
    "sku": "22759/06",
    "title": "Brilliant Black Solana 48\" AC ABS Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIM23089_01_SOLANA_48in_52in_3_BLADE_AC_CEILING_FAN_22759_22761_05_06_INSTALLATION_MANUAL_21112024.pdf?v=1769747426",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Solana_Data_Sheet.pdf?v=1793182345",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00868_Solana_22759_22761.pdf?v=1757906123",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22759_Extension_Rod_abfeecbb-4976-4e12-b5e3-98ba5ac338ef.pdf?v=1736410773",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22759-06.jpg?v=1739187969"
  },
  {
    "sku": "22763/06",
    "title": "Brilliant Black Solana 48\" DC ABS Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIM23089_02_SOLANA_48in_52in_3_BLADE_DC_CEILING_FAN_22763_22765_05_06_INSTALLATION_MANUAL_21112024.pdf?v=1769747426",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22763_Datasheet_c986aa62-5281-4e95-a00e-02f4cb222850.pdf?v=1736410962",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00869_Solana_22763_22765.pdf?v=1757906124",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22763_Extension_Rod_ade3ddeb-03b9-46f4-b2c8-937945098263.pdf?v=1736410960",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22763-06.jpg?v=1739188082"
  },
  {
    "sku": "22761/06",
    "title": "Brilliant Black Solana 52\" AC ABS Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIM23089_01_SOLANA_48in_52in_3_BLADE_AC_CEILING_FAN_22759_22761_05_06_INSTALLATION_MANUAL_21112024.pdf?v=1769747426",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Solana_Data_Sheet.pdf?v=1793182345",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00868_Solana_22759_22761.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22761-06.jpg?v=1739188034"
  },
  {
    "sku": "22765/06",
    "title": "Brilliant Black Solana 52\" DC ABS Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIM23089_02_SOLANA_48in_52in_3_BLADE_DC_CEILING_FAN_22763_22765_05_06_INSTALLATION_MANUAL_21112024.pdf?v=1769747426",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22765_Datasheet_c9e575f7-da87-4d70-b518-800c7da69ed0.pdf?v=1736411097",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00869_Solana_22763_22765.pdf?v=1757906124",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22765-06.jpg?v=1739188131"
  },
  {
    "sku": "22769/06",
    "title": "Brilliant Black Solana Clipper Light Kit",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIM23089_01_SOLANA_CEILING_FAN_CLIPPER_LIGHTKIT_22769_05_06_INSTALLATION_MANUAL_21112024.pdf?v=1769747425",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2276906.jpg?v=1756367387"
  },
  {
    "sku": "19485/06",
    "title": "Brilliant Black Stealth Slimline LED DIY Floodlight",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19485_Datasheet.pdf?v=1736227595",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00359_Stealth_19484_19485_19487_19489_19491_19493_19495_19497.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1948506.jpg?v=1736415509"
  },
  {
    "sku": "21624/06",
    "title": "Brilliant Black Stiletto-II LED Garden Spotlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21624_IM.pdf?v=1736314317",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21624_Datasheet.pdf?v=1736314318",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00890_Stiletto_21624.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2162406.jpg?v=1738646320"
  },
  {
    "sku": "22822/06",
    "title": "Brilliant Black Stinger LED Single Flood Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22822_IM_84df51a5-a387-4df0-a9e2-e2557cce9b3e.pdf?v=1736320709",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22822_Datasheet_62fa5b66-f202-4b47-b2da-dd6ea80992f2.pdf?v=1736320710",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22822_SDoC_fa1f6735-5773-4853-9f17-11326dde254c.pdf?v=1736320709",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2282206.jpg?v=1736328522"
  },
  {
    "sku": "22287/06",
    "title": "Brilliant Black Stinger LED Twin Floodlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22287_IM_4e7f19eb-b473-44dd-a181-a4d4f330ed59.pdf?v=1736313649",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22287_Datasheet_b2eb2e83-e3c1-48c4-8155-9967e7aefbd2.pdf?v=1736313649",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00807_Stinger_22287_22289.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2228706.jpg?v=1736335139"
  },
  {
    "sku": "22289/06",
    "title": "Brilliant Black Stinger LED Twin Security Light with Sensor",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22289_IM_01c6d00c-40a9-4d07-a027-42e921a92c45.pdf?v=1736311549",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22289_Datasheet.pdf?v=1736239876",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00807_Stinger_22287_22289.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2228906.jpg?v=1736410997"
  },
  {
    "sku": "22824/06",
    "title": "Brilliant Black Stinger Single Floodlight with Sensor",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22824_IM.pdf?v=1736320511",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22824_Datasheet.pdf?v=1736320511",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22824_SDoC.pdf?v=1736320510",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2282406.jpg?v=1736328415"
  },
  {
    "sku": "20580/06",
    "title": "Brilliant Black Tempest 52\'\' AC 4-Blade Ceiling Fan with LED Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20580_IM.pdf?v=1736330069",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20580_Datasheet.pdf?v=1736330068",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20580_SDoC.pdf?v=1736330068",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20580_Extension_Rod.pdf?v=1736330068",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20580-06.jpg?v=1739245162"
  },
  {
    "sku": "22235/06",
    "title": "Brilliant Black Tempest ABS 52\" DC Ceiling Fan",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22235_Datasheet_9604c23b-3328-44a9-80ab-fbf73d36c738.pdf?v=1736408374",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00808_Tempest_ABS_22235.pdf?v=1750048828",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22235_Extension_Rod_96a5ec15-c927-4ed1-887f-424404b2dd04.pdf?v=1736408374",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22235-06.jpg?v=1739188444"
  },
  {
    "sku": "22237/06",
    "title": "Brilliant Black Tempest ABS DC LED Ceiling FanLight kit",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22237_Datasheet.pdf?v=1736225852",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00808_Tempest_ABS_22235_22237.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2223706.jpg?v=1736417717"
  },
  {
    "sku": "22312/06",
    "title": "Brilliant Black Tempest DC ABS 1800mm Ceiling Fan Extension Rod",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "22309/06",
    "title": "Brilliant Black Tempest DC ABS 900mm Ceiling Fan Extension Rod",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "99988/06",
    "title": "Brilliant Black Tempest-II 52\'\' AC 4-Blade Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99988_IM.pdf?v=1736221521",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99988_Datasheet.pdf?v=1736221520",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00378_Tempest_99988.pdf?v=1757906121",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99988_Extension_Rod.pdf?v=1736221519",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99988-06.jpg?v=1739248924"
  },
  {
    "sku": "22270/06",
    "title": "Brilliant Black Tempo Plus 48\" AC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22270_IM_03e0bece-975a-4017-8d09-fda875011deb.pdf?v=1736407267",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22270_Datasheet_888c0222-7775-4b0e-a25e-a4c7ca384c03.pdf?v=1736407267",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22270_SDoC_491d07ba-10b3-4d0b-9be2-dff526fdd0f3.pdf?v=1736407266",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22270_Extension_Rod_3e5b6673-3800-4897-b65e-726f14f72618.pdf?v=1736407266",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22270-06.jpg?v=1739187213"
  },
  {
    "sku": "22273/06",
    "title": "Brilliant Black Tempo Plus 48\'\' AC 4-Blade Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22273_IM_d9febbeb-711b-4167-8b24-4df67f2dbe41.pdf?v=1736408230",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22273_Datasheet_df49e1ac-446a-46e8-9171-3f179f878625.pdf?v=1736408230",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22273_SDoC_b72c8e42-5e40-4592-8a51-c9f567a63b9e.pdf?v=1736408229",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22273_Extension_Rod_ff8ef87b-1586-4e3b-ba30-f9ad829ebf3b.pdf?v=1736408229",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22273-06.jpg?v=1739246111"
  },
  {
    "sku": "22279/06",
    "title": "Brilliant Black Tempo Plus 52\'\' AC 4-Blade Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22279_IM_6e1faf95-bd3b-430c-86fc-4ac9536a6eb9.pdf?v=1736392602",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22279_Datasheet_99575fe8-402f-4156-bfca-eadd24112e13.pdf?v=1736392602",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22279_SDoC_27992234-f9ac-4d5e-9b5e-227aa5921cc3.pdf?v=1736392602",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22279_Extension_Rod_6d31bc3d-50a4-4698-80af-eada81c628b3.pdf?v=1736392601",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22279-06.jpg?v=1739246241"
  },
  {
    "sku": "21885/06",
    "title": "Brilliant Black Transformer - 36W DC with 2-Pin Cable (Alternative To 19916/06)",
    "instructions": "",
    "datasheet": "",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00720_Transformer_19916_19917_20928_21885_20929_21886.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "19916/06",
    "title": "Brilliant Black Transformer 36W Outdoor Garden Lighting with Flex & Plug",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19916_IM.pdf?v=1736162378",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19916_Datasheet.pdf?v=1736162377",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00720_Transformer_19916_19917_20928_21885_20929_21886.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19916_06.jpg?v=1736342840"
  },
  {
    "sku": "19917/06",
    "title": "Brilliant Black Transformer 60W Outdoor Garden Lighting with Flex & Plug",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19917_IM.pdf?v=1736243035",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19917_Datasheet._pdf.pdf?v=1736243035",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00720_Transformer_19916_19917_20928_21885_20929_21886.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19917_06.jpg?v=1736407498"
  },
  {
    "sku": "18060/06",
    "title": "Brilliant Black Uni-Scan 180 PIR Security Sensor",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18060_Datasheet_682b9c86-cee0-462e-b0b3-384f3c865ff7.pdf?v=1736306262",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18060_SDoC_4e5b06c9-d53c-41b0-bac7-21af10034d21.pdf?v=1736306262",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1806005_76d6d804-5b04-4863-ac03-f87ced07180f.jpg?v=1736409906"
  },
  {
    "sku": "22693/06",
    "title": "Brilliant Black Vector 48 DC Ceiling Fan with CCT LED Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22693_IM_b540230f-542f-43fa-9900-4dde2ebc5e18.pdf?v=1736407199",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22693_Datsheet_fbf8df55-e8fb-45d3-ad71-0bcbefe1380b.pdf?v=1736407199",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22693_SDoC_165c701d-6700-4514-8233-020e7370a867.pdf?v=1736407199",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22693_Extension_Rod_dd95b980-ec1a-4131-9846-c4ce366aea89.pdf?v=1736407199",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22693-06.jpg?v=1739248742"
  },
  {
    "sku": "22687/06",
    "title": "Brilliant Black Vector 48 DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22687_IM_7bb628d6-d1c0-4e0a-936b-daa138d4412f.pdf?v=1736406000",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22687_Datasheet_1488833e-b64e-4b43-baea-59b65b8bd6a0.pdf?v=1736406000",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22687_SDoC_c2371c39-83d5-4d39-be5e-2b117c1be3ea.pdf?v=1736405999",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22687_Extension_Rod_597f0982-c097-4bdc-894e-d306db58b868.pdf?v=1736405999",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22687-06.jpg?v=1739187889"
  },
  {
    "sku": "22689/06",
    "title": "Brilliant Black Vector 52\" DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22689_IM_2fdd3fdb-5d4d-4d87-8b7e-e81b4a7805d2.pdf?v=1736328464",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22689_Datasheet_f673a7cc-8403-4a22-9c89-0d08f6f865f0.pdf?v=1736328464",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22689_SDoC_b3620fec-a4b7-4e2c-8c62-67ccdbce8253.pdf?v=1736328463",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22689_Extension_Rod_e9577bea-9391-4b98-98f0-4b82f6ff79e2.pdf?v=1736328463",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22689-06.jpg?v=1739187836"
  },
  {
    "sku": "22695/06",
    "title": "Brilliant Black Vector 52\'\' DC 4-Blade Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22695_IM.pdf?v=1736327867",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22695_Datasheet.pdf?v=1736327867",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22695_SDoC.pdf?v=1736327866",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22695_Extension_Rod.pdf?v=1736327866",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22695-06.jpg?v=1739248798"
  },
  {
    "sku": "22691/06",
    "title": "Brilliant Black Vector 56\" DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22691_IM_6db5e34a-1559-4358-9753-9531c1ce1006.pdf?v=1736313364",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22691_Datasheet_ecd36f36-08a3-4132-93a8-64fa684cf201.pdf?v=1736313364",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22691_SDoC_412614d1-4838-4724-a7a6-65a29f5f4aa3.pdf?v=1736313363",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22691_Extension_Rod_722c289e-b3a8-4a1f-8804-53a6ab5d185b.pdf?v=1736313363",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22691-06.jpg?v=1739187768"
  },
  {
    "sku": "22697/06",
    "title": "Brilliant Black Vector 56\'\' DC Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22697_IM.pdf?v=1736321415",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22697_Datasheet.pdf?v=1736321415",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22697_SDoC.pdf?v=1736321414",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22697_Extension_Rod.pdf?v=1736321413",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22697-06.jpg?v=1739248874"
  },
  {
    "sku": "21912/06",
    "title": "Brilliant Black Vector II Ceiling Fan Extension Rod 1800mm with Easy Connect Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "21546/06",
    "title": "Brilliant Black Vector-III 48 AC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21546.IM_523030df-1cff-4456-963e-79ae483d3bd4.pdf?v=1736400362",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21546_Datasheet_89eeaeeb-f2aa-4a54-814c-47f945c4a83b.pdf?v=1736400362",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21546_SDoC_4ef6cb62-ed2c-4fae-8b83-087f6e8ebc93.pdf?v=1736400361",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21546_Extension_Rod_8bdd0448-3b24-468b-b539-f6dee0bba4de.pdf?v=1736400361",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21546-06.jpg?v=1739185596"
  },
  {
    "sku": "22291/06",
    "title": "Brilliant Black Vector-III 48 AC Ceiling Fan with CCT LED Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22291_IM_b16f7ded-966f-4db9-a913-b2fcf2cdd875.pdf?v=1736404787",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22291_Datasheet_b8a35a34-eac2-4f1b-b556-764e72859884.pdf?v=1736404788",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22291_SDoC_20f645c2-6075-4abb-8aee-4e7def637eba.pdf?v=1736404786",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22291_Extension_Rod_e99df6f3-466a-467e-b163-d9bb1734af81.pdf?v=1736404786",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22291-06.jpg?v=1739248548"
  },
  {
    "sku": "21548/06",
    "title": "Brilliant Black Vector-III 52 AC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21548_IM_a8755bd4-1c28-4029-91ea-7cf05f7b604e.pdf?v=1736409920",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21548_Datasheet_d2d4c200-ec9a-4403-9aed-a172559ed981.pdf?v=1736409921",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21548_SDoC_a386af7d-9eb5-4293-9385-dd7cbd8ada40.pdf?v=1736409920",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21548_Extension_Rod_600d9ae5-315f-4f87-ae31-d0176145ab35.pdf?v=1736409920",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21548-06.jpg?v=1739185663"
  },
  {
    "sku": "22293/06",
    "title": "Brilliant Black Vector-III 52 AC Ceiling Fan with CCT LED Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22293_IM.pdf?v=1736399661",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22293_Datasheet.pdf?v=1736399662",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22293_SDoC.pdf?v=1736399661",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22293_Extension_Rod.pdf?v=1736399660",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22293-06.jpg?v=1739248638"
  },
  {
    "sku": "22563/06",
    "title": "Brilliant Black Vector-III 56\" AC ABS Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22563.pdf?v=1752049376",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Vector-III-56_Fan_22563-22565.pdf?v=1752049377",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22563_SDoC_f8638b87-b527-436a-9494-1c07ef394b68.pdf?v=1736408061",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22563_Extension_Rod_d2d34305-3f20-430e-a109-78be1848aa5c.pdf?v=1736408061",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22563-06.jpg?v=1739187535"
  },
  {
    "sku": "22565/06",
    "title": "Brilliant Black Vector-III 56\'\' AC 4-Blade Ceiling Fan with LED CCT Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIM23070_3_VECTOR_III_48-52-56_INCH_ABS_AC_CEILING_FAN_WITH_CCT_DIMMABLE_LED_ARRAY_22565_22291_22293.pdf?v=1786503738",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Vector-III-56_Fan_22563-22565_3ec7313f-90b3-43fb-b7a0-1f954b34d281.pdf?v=1786503740",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22565_SDoC.pdf?v=1736328522",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22565-06.jpg?v=1739248691"
  },
  {
    "sku": "17911/06",
    "title": "Brilliant Black Villa Coach Wall Light Coach Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/17911_Datasheet_5965b160-e8f1-4586-beca-bfdd632c1c9d.pdf?v=1736311157",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1791106.jpg?v=1736416708"
  },
  {
    "sku": "22010/06",
    "title": "Brilliant Black Welby LED Round Bunker Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22010_IM.pdf?v=1736403971",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22010_Datasheet.pdf?v=1736403971",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00830_Jenkins_Welby_22010_22011.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2201006.jpg?v=1736318549"
  },
  {
    "sku": "20924",
    "title": "Brilliant Black Wi-Fi Outdoor Double Plug",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_WiFi_Outdoor_Double_Plug_20924.pdf?v=1748244533",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00790_Outdoor_plug_20924.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20924.jpg?v=1737111929"
  },
  {
    "sku": "99983/06",
    "title": "Brilliant Black with Black Blades Tempest 52\'\' AC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99983_99988_IM_ccdf426d-3fbf-453f-b2fc-f1bed6268f06.pdf?v=1756349582",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99983_Datsheet_eee0e3e5-41a9-4a23-9c32-523d292ba214.pdf?v=1736315130",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99983_SDoC_1f0fb2cd-3a0a-4ce1-988d-127be2f7e806.pdf?v=1736315130",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99983_Extension_Rod_94672144-bbfa-443c-a41c-e0db90cd86fa.pdf?v=1736315129",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99983-06.jpg?v=1739188236"
  },
  {
    "sku": "22204/51",
    "title": "Brilliant Black with Walnut Finish Blades Durban 58\'\' Ceiling Fan",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22204-51.jpg?v=1739186995"
  },
  {
    "sku": "21639SP001",
    "title": "Brilliant Botanic 15cm Extension Spike",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "20701/06",
    "title": "Brilliant Botanic WiFi RGB LED Outdoor Garden Light Controller",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_Botanic_Garden_Controller_20701.pdf?v=1748244527",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00523_Garden_Light_Kit_20701_20702_20703_20704_20953_20954_20958.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2070106_1_535193ba-2d16-4454-8b8a-fea41c97fe15.jpg?v=1737005665"
  },
  {
    "sku": "99983/13",
    "title": "Brilliant Brush Aluminium with Silver Blades Tempest 52\'\' AC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99983_99988_IM_ccdf426d-3fbf-453f-b2fc-f1bed6268f06.pdf?v=1756349582",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99983_Datsheet_eee0e3e5-41a9-4a23-9c32-523d292ba214.pdf?v=1736315130",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99983_SDoC_1f0fb2cd-3a0a-4ce1-988d-127be2f7e806.pdf?v=1736315130",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99983_Extension_Rod_94672144-bbfa-443c-a41c-e0db90cd86fa.pdf?v=1736315129",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99983-13.jpg?v=1739188265"
  },
  {
    "sku": "20580/13",
    "title": "Brilliant Brushed Aluminium Tempest 52\'\' AC 4-Blade Ceiling Fan with LED Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20580_IM_2d0d4a66-5fe0-4c90-ada9-7860e17d5024.pdf?v=1736406096",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20580_Datasheet_22a617f5-6c11-48dc-b097-e4ec443ec3b2.pdf?v=1736406095",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20580_SDoC_866d4db5-d862-4ac8-afdb-21d7d2c6ddcd.pdf?v=1736406096",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20580_Extension_Rod_b09db9cd-38cb-4337-b09f-932ef067d972.pdf?v=1736406094",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20580-13.jpg?v=1739245187"
  },
  {
    "sku": "100550/20",
    "title": "Brilliant Brushed Aluminium Tempest AC 900mm Ceiling Fan Extension Rod",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "99988/13",
    "title": "Brilliant Brushed Aluminium Tempest-II 52\'\' AC 4-Blade Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99988_IM_ccdf426d-3fbf-453f-b2fc-f1bed6268f06.pdf?v=1736315038",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99988_Datasheet_28fb34b0-ecfc-423a-a2c9-0655624623b4.pdf?v=1736315038",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00378_Tempest_99988.pdf?v=1757906121",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99988_Extension_Rod_863c4f52-0d40-4b51-8e49-f47db110410b.pdf?v=1736315037",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99988-13.jpg?v=1739248952"
  },
  {
    "sku": "22273/13",
    "title": "Brilliant Brushed Aluminium Tempo Plus 48\'\'  AC 4-Blade Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22273_IM_d9febbeb-711b-4167-8b24-4df67f2dbe41.pdf?v=1736408230",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22273_Datasheet_df49e1ac-446a-46e8-9171-3f179f878625.pdf?v=1736408230",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22273_SDoC_b72c8e42-5e40-4592-8a51-c9f567a63b9e.pdf?v=1736408229",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22273_Extension_Rod_ff8ef87b-1586-4e3b-ba30-f9ad829ebf3b.pdf?v=1736408229",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22273-13.jpg?v=1739246141"
  },
  {
    "sku": "20429SP001/13",
    "title": "Brilliant Brushed Chrome Optional Trilogy Rings for 20429 LED Downlight-5-Pack",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "20601/13",
    "title": "Brilliant Brushed Chrome Seaford LED Exterior Up/Down Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20601_Datasheet_8e5b6cca-bdec-40e4-9166-a076028806a7.pdf?v=1736247772",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00536_Seaford_20597_20601_20605_20607.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2060113.jpg?v=1737714380"
  },
  {
    "sku": "20597/13",
    "title": "Brilliant Brushed Chrome Seaford LED Exterior Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20597_Datasheet_aa44543d-88aa-43c6-84e0-f156b3440dcb.pdf?v=1736227640",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20597_SDoC_2f0ce134-e5a8-46c8-a17a-eb21e2035ec1.pdf?v=1736227639",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2059713.jpg?v=1737714112"
  },
  {
    "sku": "17950/13",
    "title": "Brilliant Brushed Chrome Spirelet Oyster Flush Ceiling Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/17950_Datasheet.pdf?v=1736148760",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1795013.jpg?v=1736420066"
  },
  {
    "sku": "22270/13",
    "title": "Brilliant Brushed Chrome Tempo Plus 48\" AC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22270_IM_03e0bece-975a-4017-8d09-fda875011deb.pdf?v=1736407267",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22270_Datasheet_888c0222-7775-4b0e-a25e-a4c7ca384c03.pdf?v=1736407267",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22270_SDoC_491d07ba-10b3-4d0b-9be2-dff526fdd0f3.pdf?v=1736407266",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22270_Extension_Rod_3e5b6673-3800-4897-b65e-726f14f72618.pdf?v=1736407266",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22270-13.jpg?v=1739187266"
  },
  {
    "sku": "22276/13",
    "title": "Brilliant Brushed Chrome Tempo Plus 52\" AC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22276_IM_1982c2b6-f372-4429-a234-f9609b8e2c01.pdf?v=1736409992",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22276_Datasheet_0a2215a2-2056-4c01-97d6-21ab38c9dd62.pdf?v=1736409992",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00806_Tempo_Plus_22270_22273_22276_22279_22242.pdf?v=1757906121",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22276_Extension_Rod_0d6e56f6-66c0-410e-a240-fbad35f39b3e.pdf?v=1736409991",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22276-13.jpg?v=1739187355"
  },
  {
    "sku": "22279/13",
    "title": "Brilliant Brushed Chrome Tempo Plus 52\'\' AC 4-Blade Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22279_IM_6e1faf95-bd3b-430c-86fc-4ac9536a6eb9.pdf?v=1736392602",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22279_Datasheet_99575fe8-402f-4156-bfca-eadd24112e13.pdf?v=1736392602",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22279_SDoC_27992234-f9ac-4d5e-9b5e-227aa5921cc3.pdf?v=1736392602",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22279_Extension_Rod_6d31bc3d-50a4-4698-80af-eada81c628b3.pdf?v=1736392601",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22279-13.jpg?v=1739248450"
  },
  {
    "sku": "47802/00",
    "title": "Brilliant Ceiling Fan Extension Rod Easy Connect Wiring Loom Kit",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "19692/51",
    "title": "Brilliant Charcoal Delatite 12W Round LED Exterior Bunker Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19692_Datasheet.pdf?v=1736329628",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19692_SDoC.pdf?v=1736329629",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1969251.jpg?v=1736326941"
  },
  {
    "sku": "19693/51",
    "title": "Brilliant Charcoal Delatite 20W Round LED Exterior Bunker Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19693_Datasheet.pdf?v=1736336379",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19693_SDoC.pdf?v=1736336378",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1969351.jpg?v=1736320959"
  },
  {
    "sku": "17943/51",
    "title": "Brilliant Charcoal Dormon Entasis Exterior Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/17943_Datasheet.pdf?v=1736241025",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1794351.jpg?v=1738646214"
  },
  {
    "sku": "18049/51",
    "title": "Brilliant Charcoal Eave Exterior Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18049_Datasheet.pdf?v=1736393555",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00591_Eave_18048_18049.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1804951.jpg?v=1736319669"
  },
  {
    "sku": "18048/51",
    "title": "Brilliant Charcoal Eave Lantern Exterior Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18048_Datasheet.pdf?v=1736314107",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18048_SDoC.pdf?v=1736314107",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1804851.jpg?v=1736333498"
  },
  {
    "sku": "17942/51",
    "title": "Brilliant Charcoal Entasis Exterior Wall Light Exterior Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/17942_Datasheet_a1f0e27e-59e9-449c-872d-68ff358c51f2.pdf?v=1736311600",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00882_Entasis_17942.pdf?v=1757906122",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1794251.jpg?v=1736339891"
  },
  {
    "sku": "19929/51",
    "title": "Brilliant Charcoal Essex LED Oval Bunker Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19929_Datasheet_8d2cc588-b480-489b-a26b-066719464618.pdf?v=1736405246",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00887_Essex_19820_19929_19930.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1992951.jpg?v=1736322625"
  },
  {
    "sku": "19930/51",
    "title": "Brilliant Charcoal Essex Louvred LED Oval Bunker Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19930_Datasheet_c15253d3-1ce5-41ea-956a-f6dd96bc18a2.pdf?v=1736330435",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00887_Essex_19820_19929_19930.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1993051.jpg?v=1736323535"
  },
  {
    "sku": "20779/51",
    "title": "Brilliant Charcoal Glenelg Ambient LED Exterior Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20779_Datasheet.pdf?v=1736162178",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00564_Glenelg_20775_20777_20779_20781.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2077951.jpg?v=1737713689"
  },
  {
    "sku": "20777/51",
    "title": "Brilliant Charcoal Glenelg LED Exterior Up/Down Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20777_Datasheet_d43aae46-5be9-4372-a011-986fe652f099.pdf?v=1736239260",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00564_Glenelg_20775_20777_20779_20781.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20777_51.jpg?v=1737714796"
  },
  {
    "sku": "20775/51",
    "title": "Brilliant Charcoal Glenelg LED Exterior Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20775_Datasheet_c10040be-a5bf-4045-87f8-7602fc9d2dc5.pdf?v=1736312860",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00564_Glenelg_20775_20777_20779_20781.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20775_51.jpg?v=1737714750"
  },
  {
    "sku": "20781/51",
    "title": "Brilliant Charcoal Glenelg-Ambient LED Exterior Up/Down Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20781_Datasheet_ba6bcd3a-6240-4085-9b28-912cfbfa6658.pdf?v=1736313971",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00564_Glenelg_20775_20777_20779_20781.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20781_51.jpg?v=1737715007"
  },
  {
    "sku": "19696/51",
    "title": "Brilliant Charcoal Lachlan LED Square Step Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19696_Datasheet_f6f37be9-a24a-4ba6-9658-3561576981cd.pdf?v=1736315684",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00885_Lachlan_19696_19698_20029_20030.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1969651.jpg?v=1736499080"
  },
  {
    "sku": "17952/51",
    "title": "Brilliant Charcoal Prairie Exterior Up/Down Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/17952_Datasheet_61b50349-8545-4df3-a6f0-5431453f5d66.pdf?v=1736241648",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00884_Prairie_17952.pdf?v=1757906124",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1795251_957365e7-c032-4811-85e2-9314f6643b86.jpg?v=1736499243"
  },
  {
    "sku": "19675/51",
    "title": "Brilliant Charcoal Vernier-II COB LED Up/Down Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19675_Datasheet.pdf?v=1736316145",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19675_SDoC.pdf?v=1736316145",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1967551.jpg?v=1736489712"
  },
  {
    "sku": "19587/51",
    "title": "Brilliant Charcoal with Maple Timber Finish Blades Bahama 52\" DC Ceiling Fan",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19587_Datasheet_98375f0e-df39-4195-ad30-c644b90be412.pdf?v=1736407031",
    "sdoc": "",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19587_Extension_Rod_a35da56e-0873-49aa-87a7-2f6a73837ca0.pdf?v=1736407030",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19587-51.jpg?v=1739185179"
  },
  {
    "sku": "21625SP002",
    "title": "Brilliant Chrome Seaford 20cm Extension Rod for Garden Lights",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "21625/15",
    "title": "Brilliant Chrome Seaford LED Garden Spotlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21625_IM_052c6168-a1f3-436a-ae2e-e9e364cc1f74.pdf?v=1736316183",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21625_Datasheet_46bf5079-d5b4-41bc-8669-8f10ce1145fb.pdf?v=1736316183",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2162515.jpg?v=1738647492"
  },
  {
    "sku": "19107",
    "title": "Brilliant Clear Eco-Halogen A60 42W B22 Classic Globe",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19107.jpg?v=1739252009"
  },
  {
    "sku": "19108",
    "title": "Brilliant Clear Eco-Halogen A60 42W E27 Classic Globe",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19108_d1ec61ef-7383-4183-a39c-3269bf0e8867.jpg?v=1739252037"
  },
  {
    "sku": "17880",
    "title": "Brilliant Cool White LED 5M Strip Light with Driver with Flex & Plug",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/17880.jpg?v=1738064167"
  },
  {
    "sku": "21789",
    "title": "Brilliant Cool White LED MR16 5W Globe",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21789_Datasheetpdf.pdf?v=1736311122",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21789_aaf29e39-858d-42f0-9002-ade2faf7010d.jpg?v=1739252558"
  },
  {
    "sku": "22004",
    "title": "Brilliant Cool White Pixel 10m Strip Light Kit",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22004_Datasheet.pdf?v=1736230712",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00875_Strip_Light_Kit_22001_22002_22003_22004_22007_22008.pdf?v=1750048827",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22004.jpg?v=1736413765"
  },
  {
    "sku": "22003",
    "title": "Brilliant Cool White Pixel 5m Strip Light Kit",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22003_Datasheet.pdf?v=1736315445",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00875_Strip_Light_Kit_22001_22002_22003_22004_22007_22008.pdf?v=1750048827",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22003.jpg?v=1736330946"
  },
  {
    "sku": "20717/05",
    "title": "Brilliant Cordia Wi-Fi CCT LED Ceiling Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_Cordia_CCT_20717.pdf?v=1748244525",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00522_Smart_Oyster_20717.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2071705.jpg?v=1737005665"
  },
  {
    "sku": "21793/05",
    "title": "Brilliant Duncan 1200mm Dual-Watt CCT LED Batten",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21793_IM.pdf?v=1736240270",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21793_Datasheet.pdf?v=1736240270",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21793_SCoD.pdf?v=1736240270",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2179305.jpg?v=1736409964"
  },
  {
    "sku": "21792/05",
    "title": "Brilliant Duncan 600mm Dual-Watt CCT LED Batten",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21792_IM.pdf?v=1736247467",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21792_Datasheet.pdf?v=1736247467",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21792_SDoC.pdf?v=1736247468",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2179205.jpg?v=1736404752"
  },
  {
    "sku": "23167/05",
    "title": "Brilliant Eco II LED CCT Flicker Free Flush Downlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0897/7625/9391/files/23167_23168_BLIN009073_OL_IM.pdf?v=1788330127",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/23167_23168_05_ECO_II_LED_Downlight_1.pdf?v=1788329121",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2316705.png?v=1788329298"
  },
  {
    "sku": "23168/05",
    "title": "Brilliant Eco II LED CCT Flicker Free Recessed Downlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0897/7625/9391/files/23167_23168_BLIN009073_OL_IM.pdf?v=1788330127",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/23167_23168_05_ECO_II_LED_Downlight_1.pdf?v=1788329121",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2316805_3243f28c-3c84-4ad5-9e3d-8c367d33264b.png?v=1788339240"
  },
  {
    "sku": "21524/06",
    "title": "Brilliant Evelyn Black LED Indoor Step Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21524_Datasheet_5fd26986-6185-44b5-a32a-8573b0f22568.pdf?v=1736406056",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00729_Evelyn_21524.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21524-06.jpg?v=1739251524"
  },
  {
    "sku": "21524/05",
    "title": "Brilliant Evelyn White LED Indoor Step Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21524_Datasheet_5fd26986-6185-44b5-a32a-8573b0f22568.pdf?v=1736406056",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00729_Evelyn_21524.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21524-05.jpg?v=1739251472"
  },
  {
    "sku": "22802",
    "title": "Brilliant Exhaust Fan Delay On / Off Timer",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008538_02_Exhaust_Fan_run_ON-OFF_Timer_22802_Series_2_-_Instruction_Manual.pdf?v=1773732168",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22802_Data_Sheets_OL.pdf?v=1773732170",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22802_SDoC.pdf?v=1736408589",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22802.png?v=1773734227"
  },
  {
    "sku": "99222",
    "title": "Brilliant Fan Remote with Deluxe Universal AC Remote with LCD screen",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99222_Datasheet.pdf?v=1736314406",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00598_99222.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99222.jpg?v=1736333034"
  },
  {
    "sku": "18550",
    "title": "Brilliant Fancy 3W E27 LED Globe",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/LED_Fancy_Round_3W_18549-18550-18551-18880.pdf?v=1748244529",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00880_LED_Globe_18545_18547_18549_18550.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18550_09e046b3-f25c-4b97-8ac2-783261976276.jpg?v=1739251809"
  },
  {
    "sku": "19098",
    "title": "Brilliant G4 LED Capsules Globe",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19098.jpg?v=1739251979"
  },
  {
    "sku": "21527/08",
    "title": "Brilliant Grey Catania Terrazzo Up/Down Wall Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21527_IM.pdf?v=1736313862",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21527_Datasheet.pdf?v=1736313862",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00695_Catania_21527.pdf?v=1757906122",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2152708.jpg?v=1737713714"
  },
  {
    "sku": "22372/08",
    "title": "Brilliant Grey Endura 20W/40W Switchable Microwave Sensor Tri-Proof CCT LED Batten",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22372_Datasheet.pdf?v=1736321705",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00816_Endura_22371_22372.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2237208.jpg?v=1736327576"
  },
  {
    "sku": "22371/08",
    "title": "Brilliant Grey Endura 20W/40W Switchable Tri-Proof CCT LED Batten",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22371_Datasheet.pdf?v=1736336501",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00816_Endura_22371_22372.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2237108.jpg?v=1736320331"
  },
  {
    "sku": "21526/08",
    "title": "Brilliant Grey Sienna Terrazzo Up/Down Wall Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21526_IM.pdf?v=1736316100",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21526_Datasheet.pdf?v=1736316100",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2152608.jpg?v=1737713663"
  },
  {
    "sku": "19997/08",
    "title": "Brilliant Grey Stellar Non-Emergency LED Batten",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1999708.jpg?v=1788508783"
  },
  {
    "sku": "22330/05",
    "title": "Brilliant Halton Dual Wattage CCT LED Batten",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22330_IM.pdf?v=1736247363",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22330_Datasheet.pdf?v=1736247363",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22330SDoC.pdf?v=1736247363",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2233005.jpg?v=1736404810"
  },
  {
    "sku": "18782",
    "title": "Brilliant Heat-lamp 275W Infrared Globes for Bathroom Heaters",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18782_Datasheet.pdf?v=1736311922",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18782_34ec1811-d273-4a90-b80f-6a67185232b5.jpg?v=1739251935"
  },
  {
    "sku": "21523/05",
    "title": "Brilliant Hensley White LED Indoor Step Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21523_Datasheet.pdf?v=1736404010",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00730_Hensley_21523_21525.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21523-05.jpg?v=1739251444"
  },
  {
    "sku": "21835/06",
    "title": "Brilliant Imogene Black LED Wall Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21835_IM.pdf?v=1736225157",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21835_Datasheet.pdf?v=1736225157",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00725_Imogene_21835_21837.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21835-06.jpg?v=1739251586"
  },
  {
    "sku": "21835/05",
    "title": "Brilliant Imogene White LED Wall Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21835_IM_32212da3-987a-4600-ba20-bb8a47a24a6c.pdf?v=1736311969",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21835_Datasheet_6de3f72e-a6c5-4d0d-aac7-ef9d35a7c734.pdf?v=1736311969",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00725_Imogene_21835_21837.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21835-05.jpg?v=1739251559"
  },
  {
    "sku": "20300",
    "title": "Brilliant Indicator LED Globe",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20300.jpg?v=1739252315"
  },
  {
    "sku": "22262",
    "title": "Brilliant LED COB CCT Spotless Strip light Kit",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22262_IM.pdf?v=1736314803",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22262_Datasheet.pdf?v=1736314802",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22262_SDoC.pdf?v=1736314802",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22262.jpg?v=1736332230"
  },
  {
    "sku": "22263",
    "title": "Brilliant LED COB RGB & White Spotless Strip light Kit",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22263_IM.pdf?v=1736315712",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22263_Datasheet.pdf?v=1736315713",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22263_SDoC.pdf?v=1736315712",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22263.jpg?v=1736500549"
  },
  {
    "sku": "21837/06",
    "title": "Brilliant Lila Black LED Wall Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21837_IM_bb14ad8c-6f2e-4f25-a941-629d8a6b83a2.pdf?v=1736314230",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21837_Datasheet_ceaef0b7-a2c6-4af8-9e34-3a370ac4b391.pdf?v=1736314230",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00725_Imogene_21835_21837.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21837-06.jpg?v=1739251695"
  },
  {
    "sku": "21837/05",
    "title": "Brilliant Lila White LED Wall Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21837_IM_bb14ad8c-6f2e-4f25-a941-629d8a6b83a2.pdf?v=1736314230",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21837_Datasheet_ceaef0b7-a2c6-4af8-9e34-3a370ac4b391.pdf?v=1736314230",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00725_Imogene_21835_21837.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21837-05.jpg?v=1739251665"
  },
  {
    "sku": "21952/06",
    "title": "Brilliant Matt Black Amari II Ceiling Fan Extension Rod 1800mm with Easy Connect Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "21721/06",
    "title": "Brilliant Matt Black Amari Series II  52\'\' DC 4-Blade Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21721_IM.pdf?v=1736321486",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21721_Datasheet.pdf?v=1736321486",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21721_SDoC.pdf?v=1736321486",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21721_Extension_Rod.pdf?v=1736321484",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21721-06.jpg?v=1739245342"
  },
  {
    "sku": "21725/06",
    "title": "Brilliant Matt Black Amari Series II 5-Blade 56\'\' DC Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21725_IM.pdf?v=1736401001",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21725_Datasheet.pdf?v=1736401000",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21725_SDoc.pdf?v=1736401000",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21725_Extension_Rod.pdf?v=1736401000",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21725-06.jpg?v=1739245407"
  },
  {
    "sku": "21810/06",
    "title": "Brilliant Matt Black Amari Series II Ceiling Fan Extension Rod 900mm with Easy Connect Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "22970/06",
    "title": "Brilliant Matt Black Cairns 48\" DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008449_CAIRNS_48-52_INCH_ABS_DC_CEILING_FAN_WITH_WITHOUT_LIGHT_22970_22972_22974_22976.pdf?v=1763957976",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22970_22974_Cairns_DC_Ceiling_Fan-2_OL.pdf?v=1764040354",
    "sdoc": "",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22721_Extension_Rod.pdf?v=1736240090",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2297006.jpg?v=1755147684"
  },
  {
    "sku": "22974/06",
    "title": "Brilliant Matt Black Cairns 48\" DC Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008449_CAIRNS_48-52_INCH_ABS_DC_CEILING_FAN_WITH_WITHOUT_LIGHT_22970_22972_22974_22976.pdf?v=1763957976",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22970_22974_Cairns_DC_Ceiling_Fan-2_OL.pdf?v=1764040354",
    "sdoc": "",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22721_Extension_Rod.pdf?v=1736240090",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2297406.jpg?v=1755147960"
  },
  {
    "sku": "22972/06",
    "title": "Brilliant Matt Black Cairns 52\" DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008449_CAIRNS_48-52_INCH_ABS_DC_CEILING_FAN_WITH_WITHOUT_LIGHT_22970_22972_22974_22976.pdf?v=1763957976",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22972_22976_Cairns_DC_Ceiling_Fan-2_OL.pdf?v=1764040354",
    "sdoc": "",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22721_Extension_Rod.pdf?v=1736240090",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22972_06.jpg?v=1755147823"
  },
  {
    "sku": "22976/06",
    "title": "Brilliant Matt Black Cairns 52\" DC Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008449_CAIRNS_48-52_INCH_ABS_DC_CEILING_FAN_WITH_WITHOUT_LIGHT_22970_22972_22974_22976.pdf?v=1763957976",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22972_22976_Cairns_DC_Ceiling_Fan-2_OL.pdf?v=1764040354",
    "sdoc": "",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22721_Extension_Rod.pdf?v=1736240090",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22976_06.jpg?v=1755148077"
  },
  {
    "sku": "21341/06",
    "title": "Brilliant Matt Black Como 36\'\' AC 3-Blade Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21341_IM.pdf?v=1736330514",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21341_Datasheet.pdf?v=1736330514",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21341_SDoC.pdf?v=1736330515",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21341_Extension_Rod.pdf?v=1736330514",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21341-06.jpg?v=1739245252"
  },
  {
    "sku": "18627/06",
    "title": "Brilliant Matt Black Hercules 82\'\' 900mm Ceiling Fan Extension Rod",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "23141/06",
    "title": "Brilliant Matt Black Logan 18W CCT LED Light Kit",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008851_LOGAN_LED_LIGHTKIT.pdf?v=1792737381",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/23141_Logan_Lightkit_OL.pdf?v=1792737381",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "23139/06",
    "title": "Brilliant Matt Black Logan 52\" DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008849_1.pdf?v=1792573946",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/23139_Logan_52_DC_ceiling_fan_OL.pdf?v=1792573941",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2313906.jpg?v=1792574171"
  },
  {
    "sku": "21843/06",
    "title": "Brilliant Matt Black Malta DC 52\" Ceiling Fan with LED Light",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21843-06.jpg?v=1739245441"
  },
  {
    "sku": "20099/06",
    "title": "Brilliant Matt Black Maxi 18W LED Dimmable Light Kit",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20099_Datasheet_765d7f2d-1d06-4ba6-8aad-a886a32860d4.pdf?v=1736315354",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20099_SDoC_13167e16-c47c-4630-b17e-0fafa6e61ee5.pdf?v=1736315354",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2009906.jpg?v=1736341919"
  },
  {
    "sku": "22276/06",
    "title": "Brilliant Matt Black Tempo Plus 52\" AC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22276_IM_1982c2b6-f372-4429-a234-f9609b8e2c01.pdf?v=1736409992",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22276_Datasheet_0a2215a2-2056-4c01-97d6-21ab38c9dd62.pdf?v=1736409992",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00806_Tempo_Plus_22270_22273_22276_22279_22242.pdf?v=1757906121",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22276_Extension_Rod_0d6e56f6-66c0-410e-a240-fbad35f39b3e.pdf?v=1736409991",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22276-06.jpg?v=1739187329"
  },
  {
    "sku": "21657/77",
    "title": "Brilliant Matt Titanium 20W CCT Fan Light Kit for Aris, Como and Supra fans",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21657_IM_710d7698-eb53-448b-82e7-c2f0f5239bfb.pdf?v=1736315280",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21657_Datasheet_338d1759-8e4b-484e-90db-a79d2ef3f8ed.pdf?v=1736315280",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00644_Como_Light_Kit_21341_21345_21348_21657.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2165777.jpg?v=1736331230"
  },
  {
    "sku": "21341/77",
    "title": "Brilliant Matt Titanium Como 36\'\' AC 3-Blade Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21341_IM.pdf?v=1736330514",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21341_Datasheet.pdf?v=1736330514",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21341_SDoC.pdf?v=1736330515",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21341_Extension_Rod.pdf?v=1736330514",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21341-77.jpg?v=1739245284"
  },
  {
    "sku": "21952/05",
    "title": "Brilliant Matt White Amari II Ceiling Fan Extension Rod 1800mm with Easy Connect Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "21721/05",
    "title": "Brilliant Matt White Amari Series II 4-Blade 52\'\' DC Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21721_IM.pdf?v=1736321486",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21721_Datasheet.pdf?v=1736321486",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21721_SDoC.pdf?v=1736321486",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21721_Extension_Rod.pdf?v=1736321484",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2172105_8c7a7723-05a4-4ae7-9cbe-9e99d24c8d8e.jpg?v=1761626979"
  },
  {
    "sku": "21725/05",
    "title": "Brilliant Matt White Amari Series II 5-Blade 56\'\' DC Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21725_IM_66659d64-1289-416c-8b66-6c0bc7fa4c54.pdf?v=1736408477",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21725_Datasheet_d6736a9c-d479-4ee1-be9b-826e0aca46a9.pdf?v=1736408477",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21725_SDoc_8fb5beae-2619-49f0-b508-f501edbcb2ab.pdf?v=1736408477",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21725_Extension_Rod_829796c5-3b52-411c-a7ba-1719b71ab7e0.pdf?v=1736408476",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21725-05.jpg?v=1739245371"
  },
  {
    "sku": "21810/05",
    "title": "Brilliant Matt White Amari Series II Ceiling Fan Extension Rod 900mm with Easy Connect Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "18627/55",
    "title": "Brilliant Matt White Aviator Ceiling Fan Extension Rod 900mm with Easy Connect Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "22970/05",
    "title": "Brilliant Matt White Cairns 48\" DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008449_CAIRNS_48-52_INCH_ABS_DC_CEILING_FAN_WITH_WITHOUT_LIGHT_22970_22972_22974_22976.pdf?v=1763957976",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22970_22974_Cairns_DC_Ceiling_Fan-2_OL.pdf?v=1764040354",
    "sdoc": "",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22721_Extension_Rod.pdf?v=1736240090",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2297005.jpg?v=1755147646"
  },
  {
    "sku": "22974/05",
    "title": "Brilliant Matt White Cairns 48\" DC Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008449_CAIRNS_48-52_INCH_ABS_DC_CEILING_FAN_WITH_WITHOUT_LIGHT_22970_22972_22974_22976.pdf?v=1763957976",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22970_22974_Cairns_DC_Ceiling_Fan-2_OL.pdf?v=1764040354",
    "sdoc": "",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22721_Extension_Rod.pdf?v=1736240090",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2297405.jpg?v=1755147891"
  },
  {
    "sku": "22972/05",
    "title": "Brilliant Matt White Cairns 52\" DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008449_CAIRNS_48-52_INCH_ABS_DC_CEILING_FAN_WITH_WITHOUT_LIGHT_22970_22972_22974_22976.pdf?v=1763957976",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22972_22976_Cairns_DC_Ceiling_Fan-2_OL.pdf?v=1764040354",
    "sdoc": "",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22721_Extension_Rod.pdf?v=1736240090",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2297205.jpg?v=1755147760"
  },
  {
    "sku": "22976/05",
    "title": "Brilliant Matt White Cairns 52\" DC Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008449_CAIRNS_48-52_INCH_ABS_DC_CEILING_FAN_WITH_WITHOUT_LIGHT_22970_22972_22974_22976.pdf?v=1763957976",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22972_22976_Cairns_DC_Ceiling_Fan-2_OL.pdf?v=1764040354",
    "sdoc": "",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22721_Extension_Rod.pdf?v=1736240090",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22976_05.jpg?v=1755148018"
  },
  {
    "sku": "23141/05",
    "title": "Brilliant Matt White Logan 18W CCT LED Light Kit",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008851_LOGAN_LED_LIGHTKIT.pdf?v=1792737381",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/23141_Logan_Lightkit_OL.pdf?v=1792737381",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "23139/05",
    "title": "Brilliant Matt White Logan 52\" DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008849_1.pdf?v=1792573946",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/23139_Logan_52_DC_ceiling_fan_OL.pdf?v=1792573941",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2313905.png?v=1792573841"
  },
  {
    "sku": "20894/05",
    "title": "Brilliant Matt White Maxi 66 DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20894_IM_141984ce-d380-4c2a-84df-a41b5eb5b668.pdf?v=1736404606",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20894_Datasheet_df9c0ce9-e69b-47d3-af63-ecabfcbabf9b.pdf?v=1736404606",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20894_SDoC_624669ed-e929-45c2-9737-74bae37c768f.pdf?v=1736404604",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20894_Extension_Rod_4eb07f57-0cba-4691-aa97-184a74554551.pdf?v=1736404606",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20894-05.jpg?v=1739185436"
  },
  {
    "sku": "20252/05",
    "title": "Brilliant Matt White Vector II-Cruze Ceiling Fan Extension Rod 900mm with Easy Connect Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "99777",
    "title": "Brilliant Multi-Fan Wall Controller",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99777_Datasheetpdf.pdf?v=1736240055",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00874_Controller_99777.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99777_6ebe7d3c-9f45-4dd5-90db-a539f0199049.jpg?v=1740473205"
  },
  {
    "sku": "19164/37",
    "title": "Brilliant Natural Brunswick Table Lamp",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19164_IM.pdf?v=1736245024",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19164_Datasheet.pdf?v=1736245024",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1916437.jpg?v=1737620661"
  },
  {
    "sku": "18769/14",
    "title": "Brilliant Oil Rubbed Bronze Aviator Ceiling Fan Extension Rod 1800mm with Easy Connect Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "22239/14",
    "title": "Brilliant Oil Rubbed Bronze Aviator II 66\'\' DC Ceiling Fan LED CCT Light",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22239-14.jpg?v=1739246019"
  },
  {
    "sku": "20894/14",
    "title": "Brilliant Oil Rubbed Bronze Maxi 66 DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20894_IM.pdf?v=1736321748",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20894_Datasheet.pdf?v=1736321747",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20894_SDoC.pdf?v=1736321747",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20894_Extension_Rod.pdf?v=1736321747",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20894-14.jpg?v=1739185486"
  },
  {
    "sku": "18240/14",
    "title": "Brilliant Oil Rubbed BronzeTempest AC Ceiling Fan Extension Rod 900mm with Easy Connect Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1824014.jpg?v=1736252582"
  },
  {
    "sku": "22162/05",
    "title": "Brilliant Prism WiFi RGB CCT Downlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22162_05_BrilliantSmart_PRISM_downlight_IM_00_a6bd1fd4-f47d-4944-a8fc-76c02757c707.pdf?v=1741173644",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_WiFi_Prism_RGB_SII_Downlight_22162.pdf?v=1748244533",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00873_WIFI_RGB_Downlight_22162.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2216205_6b4ae58f-8488-4fb5-81b6-a97c95422764.jpg?v=1739251302"
  },
  {
    "sku": "22268",
    "title": "Brilliant Recessed Slim 2m Aluminium Profile",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22268_Datasheet.pdf?v=1736240514",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22268_SDoC.pdf?v=1736240514",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22268_440c2376-b08e-4314-896e-249c9a97d768.jpg?v=1737700463"
  },
  {
    "sku": "19705/01",
    "title": "Brilliant Red Coloured LED PAR38 15W Reflector Globe",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19705_Datsheet.pdf?v=1736146986",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19705_SDoC.pdf?v=1736146982",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19705-01.jpg?v=1739252105"
  },
  {
    "sku": "99444",
    "title": "Brilliant Remote Control 3-Speed for Tempo AC Ceiling Fan",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99444_Datsheet.pdf?v=1736242094",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00590_99444.pdf?v=1757906122",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99444.jpg?v=1736408168"
  },
  {
    "sku": "22008",
    "title": "Brilliant RGB & White Pixel 10m Strip Light Kit",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22008_Datasheet.pdf?v=1736313794",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00875_Strip_Light_Kit_22001_22002_22003_22004_22007_22008.pdf?v=1750048827",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22008_e677c3c3-6f69-4737-ba47-e5be43ee7508.jpg?v=1747906344"
  },
  {
    "sku": "22007",
    "title": "Brilliant RGB & White Pixel 5m Strip Light Kit",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22007_Datasheet.pdf?v=1736310749",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00875_Strip_Light_Kit_22001_22002_22003_22004_22007_22008.pdf?v=1750048827",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22007.jpg?v=1736341178"
  },
  {
    "sku": "21446/05",
    "title": "Brilliant Saber 120cm Bluetooth Mesh Linkable Batten Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_Mesh_Saber_Batten_21445-21446.pdf?v=1748244528",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00675_Saber_21445_21446.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2144605.jpg?v=1737708140"
  },
  {
    "sku": "21445/05",
    "title": "Brilliant Saber 60cm Bluetooth Mesh Linkable Batten Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_Mesh_Saber_Batten_21445-21446.pdf?v=1748244528",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00675_Saber_21445_21446.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2144505.jpg?v=1738647707"
  },
  {
    "sku": "21414/03",
    "title": "Brilliant Sammy Blue 1 Light Task Lamp",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21414_IM_53e45646-59d7-4275-be0f-f859217598dc.pdf?v=1736312730",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21414_Datasheet_7aabd202-3509-45ad-8c9e-5b9ec90f98b5.pdf?v=1736312729",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21414_SDoC_816e4a83-4a65-43ad-bd9e-012a923cf88e.pdf?v=1736312730",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2141403.jpg?v=1736412722"
  },
  {
    "sku": "21414/08",
    "title": "Brilliant Sammy Grey 1 Light Task Lamp",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21414_IM_53e45646-59d7-4275-be0f-f859217598dc.pdf?v=1736312730",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21414_Datasheet_7aabd202-3509-45ad-8c9e-5b9ec90f98b5.pdf?v=1736312729",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21414_SDoC_816e4a83-4a65-43ad-bd9e-012a923cf88e.pdf?v=1736312730",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2141408.jpg?v=1736338381"
  },
  {
    "sku": "21414/44",
    "title": "Brilliant Sammy Pink 1 Light Task Lamp",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21414_IM_53e45646-59d7-4275-be0f-f859217598dc.pdf?v=1736312730",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21414_Datasheet_7aabd202-3509-45ad-8c9e-5b9ec90f98b5.pdf?v=1736312729",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21414_SDoC_816e4a83-4a65-43ad-bd9e-012a923cf88e.pdf?v=1736312730",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2141444.jpg?v=1736406671"
  },
  {
    "sku": "22677/13",
    "title": "Brilliant Satin Nickel Colossus 120\" DC Ceiling Fan 6-Blade",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22677_IM_c3e42212-0cac-4fc3-801c-010a100772ba.pdf?v=1736409789",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22677_Datasheet_07ef8c7e-09d7-41a3-92b6-9b3df91ac679.pdf?v=1736409789",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00844_Colossus_22319_22573_22570_22677.pdf?v=1750048828",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22677_Extension_Rod_25c69be9-308d-4161-8326-57663cf1eef6.pdf?v=1736409788",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22677-13.jpg?v=1739187941"
  },
  {
    "sku": "18629/13",
    "title": "Brilliant Satin Nickel Colossus-Maelstrom Ceiling Fan Extension Rod 1800mm with Fully Assembled Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "18628/13",
    "title": "Brilliant Satin Nickel Colossus-Maelstrom Ceiling Fan Extension Rod 900mm with Fully Assemble Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "19975/13",
    "title": "Brilliant Satin Nickel Hunter-III LED Single Light Floodlight with Sensor",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19975_Datasheet_0c600b0a-41b0-45f8-888f-bbefe6b84b6d.pdf?v=1736315317",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00353_Hunter_III_19242_19245_19239_19975.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1997513.jpg?v=1736342586"
  },
  {
    "sku": "18878/13",
    "title": "Brilliant Satin Nickel Power Board Premium Bench Top Power Solution",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18878_IM_f94c46d0-6fe1-4c43-bd82-12e4f775a66f.pdf?v=1736312011",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/PowerBoard-Premium_18878_2023.pdf?v=1748244531",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18878SDoC_31e71efd-d613-4a6a-8517-bc7a5283f0cd.pdf?v=1736312012",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1887813_525e5777-1717-43fb-91de-b784d628b9a8.jpg?v=1738648031"
  },
  {
    "sku": "81000/13",
    "title": "Brilliant Satin Nickel Sphere DIY Glass Ball Batten Fix",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "20099/13",
    "title": "Brilliant Satin NickelMaxi 18W LED Dimmable Light Kit",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20099_Datasheet.pdf?v=1736306309",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20099_SDoC.pdf?v=1736306309",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2009913.jpg?v=1736331086"
  },
  {
    "sku": "100550/13",
    "title": "Brilliant Satin NickelMercury Ceiling Fan Extension Rod 900mm with Easy Connect Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "21021/13",
    "title": "Brilliant Satin Nickle Hercules 120\'\' Ceiling Fan Extension Rod 900mm with Easy Connect Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "22319/13",
    "title": "Brilliant Satin Nicle Colossus 84\" DC Ceiling Fan 6-Blade",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22319_IM_db9811ac-9e15-4bbb-878c-3ddb90e487b1.pdf?v=1736404250",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22319_Datasheet_4fe78a71-c0e8-4786-8bbc-0dae1a4a295b.pdf?v=1736404249",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00844_Colossus_22319_22573_22570_22677.pdf?v=1750048828",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22319_Extension_Rod_5e6748b4-1d65-4085-a243-644cf448a26e.pdf?v=1736404249",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22319-13.jpg?v=1739187475"
  },
  {
    "sku": "20093/11",
    "title": "Brilliant Silver Allora Dimmable LED Ceiling Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20093_IM.pdf?v=1736227196",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20093_Datasheet.pdf?v=1736227196",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2009311.jpg?v=1736416437"
  },
  {
    "sku": "18746/11",
    "title": "Brilliant Silver Greta-II 12W LED Vanity Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18746_IM.pdf?v=1736246731",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18746_Datasheet.pdf?v=1736246732",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18746SDoC.pdf?v=1736246732",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1874611.jpg?v=1738647684"
  },
  {
    "sku": "18747/11",
    "title": "Brilliant Silver Greta-II 18W LED Vanity Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18747_IM.pdf?v=1736310852",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18747_Datasheet.pdf?v=1736310853",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18747_SDoC.pdf?v=1736310852",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1874711.jpg?v=1738647668"
  },
  {
    "sku": "17952/11",
    "title": "Brilliant Silver Prairie Exterior Up/Down Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/17952_Datasheet_61b50349-8545-4df3-a6f0-5431453f5d66.pdf?v=1736241648",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00884_Prairie_17952.pdf?v=1757906124",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1795211.jpg?v=1736414117"
  },
  {
    "sku": "21812/11",
    "title": "Brilliant Silver Smart Wi-Fi Rechargeable Camera with Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21812-11.pdf?v=1745294161",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00728_Flare_Camera_21812.pdf?v=1757906122",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2181211_4e69c677-79b6-4998-a039-cd05fd24e413_1.jpg?v=1738648624"
  },
  {
    "sku": "22266",
    "title": "Brilliant Slim 2m Aluminium Profile",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22266_Datasheet.pdf?v=1736314436",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22266_SDoC.pdf?v=1736314436",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22266_4b6988c2-6784-4f3b-89e8-2035a752373c.jpg?v=1737700437"
  },
  {
    "sku": "21796/05",
    "title": "Brilliant Slimline 1200mm Dual-Watt LED CCT Batten Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21796_IM.pdf?v=1736248051",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21796_Datasheet.pdf?v=1736248052",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00705_Slimline_batten_21795_21796_20009_20010.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2179605.jpg?v=1736342112"
  },
  {
    "sku": "21795/05",
    "title": "Brilliant Slimline 600mm Dual-Watt LED CCT Batten Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21795_Datasheet.pdf?v=1736313693",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00705_Slimline_batten_21795_21796_20009_20010.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2179505.jpg?v=1736335029"
  },
  {
    "sku": "21889",
    "title": "Brilliant Smart 10m Wi-Fi Music LED Strip Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21889_IM.pdf?v=1736239378",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21889_Datasheet.pdf?v=1736239377",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00719_Strip_Light_21887_21888_21889.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21889_941acf53-d4e0-4764-a45d-9409db06a0bf.jpg?v=1736411412"
  },
  {
    "sku": "21887",
    "title": "Brilliant Smart 2m Wi-Fi Music LED Strip Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21887_IM.pdf?v=1736152608",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21887_Datasheet.pdf?v=1736152607",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00719_Strip_Light_21887_21888_21889.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21887_0481b32d-b252-4df4-aca9-bdcc81e60fcb.jpg?v=1736420003"
  },
  {
    "sku": "21888",
    "title": "Brilliant Smart 5m Wi-Fi Music LED Strip Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21888_IM.pdf?v=1736224633",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21888_Datasheet.pdf?v=1736224625",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00719_Strip_Light_21887_21888_21889.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21888_1b59b655-cc5f-46ed-9991-9fac1f3a5ca5.jpg?v=1736418440"
  },
  {
    "sku": "21955",
    "title": "Brilliant Smart 9W A60 B22 Globe",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_WiFi_A60_Biorhythm_Globe_WW_21954-21955.pdf?v=1748244528",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00783_LED_globe_21892_21893_21955_21956_21957_21959.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21955_94f00d5c-8a70-4325-8823-66aae79f4e18.jpg?v=1739252709"
  },
  {
    "sku": "22091",
    "title": "Brilliant Smart Black  2 Wire Rotary Dimmer Mech",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22091_Datasheet.pdf?v=1734501608",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22091_SDoC.pdf?v=1734501622",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22091_3199a9a1-1be9-4c7a-8f02-3d218b8d715c.jpg?v=1737525730"
  },
  {
    "sku": "22092",
    "title": "Brilliant Smart Black 2 Wire Push Button Dimmer Mech",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22092_Datasheet.pdf?v=1734501898",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00789_Smart_Dimmer_22092.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22092.jpg?v=1736334010"
  },
  {
    "sku": "21631/06",
    "title": "Brilliant Smart Black Botanic 3W Warm White LED Garden Spotlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21631_IM.pdf?v=1736244878",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21631_Datasheet.pdf?v=1736244878",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00895_Botanic_21631_-_21644.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2163106.jpg?v=1738646308"
  },
  {
    "sku": "21633/06",
    "title": "Brilliant Smart Black Botanic 6W RGB LED Garden Spotlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21633_IM.pdf?v=1736225034",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21633_Datasheet.pdf?v=1736225035",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2163306.jpg?v=1738646296"
  },
  {
    "sku": "21666",
    "title": "Brilliant Smart Blue with White Button Bluetooth Mesh Dimmer Mech",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21666_IM.pdf?v=1734501458",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21666_Datasheet.pdf?v=1734501465",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00881_Mech_Switch_20967_21667_21666_21322.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21666.jpg?v=1736342637"
  },
  {
    "sku": "21667",
    "title": "Brilliant Smart Blue with White Button Bluetooth Mesh Relay Mech",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21667_IM_04906f92-027e-43df-b80c-e384750397ce.pdf?v=1736314277",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21667_Datasheetpdf_586b9ce0-5892-4189-926c-ce04343ec7e0.pdf?v=1736314277",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00881_Mech_Switch_20967_21667_21666_21322.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21667.jpg?v=1736333213"
  },
  {
    "sku": "19575/06",
    "title": "Brilliant Smart Bluetooth Fan Control Kit",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "22567",
    "title": "Brilliant Smart CCT COB Strip Light Controller",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22567_Datasheet.pdf?v=1736239296",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22567_SDoC.pdf?v=1736239296",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22567.jpg?v=1736411482"
  },
  {
    "sku": "21951/08",
    "title": "Brilliant Smart Grey Solar Panel for Rechargeable Battery Cameras",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Solar_panel_for_Smart_WiFi_Camera_21951.pdf?v=1748244527",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00879_Solar_Panel_21951.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2195108_9637f085-f7d5-499f-929d-7e825e07e9dd.jpg?v=1737529091"
  },
  {
    "sku": "21443/05",
    "title": "Brilliant Smart Mesh Epic RGB CCT Downlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21443_IM.pdf?v=1736306356",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21443_Datasheet.pdf?v=1736306355",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21443_SDoC.pdf?v=1736306355",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2144305_41438122-c361-4b74-936d-ea77118da277.jpg?v=1737536341"
  },
  {
    "sku": "21444/05",
    "title": "Brilliant Smart Mesh Sync CCT Downlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21444_IM.pdf?v=1736231537",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21444_Datasheet.pdf?v=1736231536",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21444_SDoC.pdf?v=1736231535",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21444-05.jpg?v=1739249806"
  },
  {
    "sku": "21441/05",
    "title": "Brilliant Smart Minka Bluetooth Square Mesh CCT LED Panel Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/IM.pdf?v=1738209548",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_Mesh_Minka_Panel_21440-21441.pdf?v=1748244529",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDOC.pdf?v=1738209548",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2144105_87251327-556d-4862-bfd8-680c8f8e5a74.jpg?v=1737005664"
  },
  {
    "sku": "21440/05",
    "title": "Brilliant Smart Minka White 35W Bluetooth Rectangle Mesh CCT LED Panel Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/IM.pdf?v=1738209548",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_Mesh_Minka_Panel_21440-21441.pdf?v=1748244529",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00674_LED_Panel_21440_21441_21442.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21440_05.jpg?v=1737005664"
  },
  {
    "sku": "21438/05",
    "title": "Brilliant Smart Patrol Pan & Tilt Camera - White",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_WiFi_Patrol_Camera_21438.pdf?v=1748244528",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00643_Patrol_Pan_and_Tilt_Camera_21438.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2143805_1.jpg?v=1738648611"
  },
  {
    "sku": "21721SMART",
    "title": "Brilliant Smart Receiver For Amari Series II (Suitable for 21719 & 21721 Series 2)",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SMART_RECEIVER_FOR_AMARI_-_DATASHEET_OL.pdf?v=1771900958",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00700_Receiver_21721Smart.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21721SMART.jpg?v=1737005666"
  },
  {
    "sku": "21725SMART",
    "title": "Brilliant Smart Receiver For Amari Series II (Suitable for 21723 & 21725 Series 2)",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SMART_RECEIVER_FOR_AMARI_-_DATASHEET_OL.pdf?v=1771900958",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00858_Pacifica_II_21721_21722_21723.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21725SMAR.jpg?v=1737108558"
  },
  {
    "sku": "VECTORDCSMART",
    "title": "Brilliant Smart Receiver for Vector DC Ceiling Fan",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SMART_RECEIVER_FOR_VECTOR_DC_-_DATASHEET_OL.pdf?v=1772426693",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00846_VECTORDCSMART.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21725SMAR_1200x1200_ee1250e7-e733-4e73-bf79-1c3a30c8c42c.webp?v=1772425816"
  },
  {
    "sku": "21892",
    "title": "Brilliant Smart RGB+CCT C37 E14 Globe",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_WiFi_C37_Biorhythm_Globe_RGB-CCT_21892.pdf?v=1748244528",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00739_smart_globe_21892_21893_21954_-21960.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21892_4cf148f0-4d74-4bac-8c27-9923b731a35f.jpg?v=1739252585"
  },
  {
    "sku": "21893",
    "title": "Brilliant Smart RGB+CCT G45 E14 Globe",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_WiFi_G45_Biorhythm_Globe_RGB-CCT_21893.pdf?v=1748244529",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00739_smart_globe_21892_21893_21954_-21960.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21893_671f11fd-a776-4897-80a3-80ac84347e33.jpg?v=1739252611"
  },
  {
    "sku": "22568",
    "title": "Brilliant Smart RGB+W COB Strip Light Controller",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22568_Datasheet.pdf?v=1736246431",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22568_SDoC.pdf?v=1736246432",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22568.jpg?v=1736406202"
  },
  {
    "sku": "22167/05",
    "title": "Brilliant Smart Temperature & Humidity Sensor with LCD Screen",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_WiFi_Temperature_Humidity_Sensor_22167.pdf?v=1748244533",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00794_Sensor_22167.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2216705_1_126ac456-8637-4c20-a95a-7fbef855213b.jpg?v=1738648177"
  },
  {
    "sku": "99111",
    "title": "Brilliant Smart White Wi-Fi Ceiling Fan Controller",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99111_Datasheet.pdf?v=1736240888",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00550_99111.pdf?v=1757906122",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99111.jpg?v=1738645804"
  },
  {
    "sku": "99888",
    "title": "Brilliant Smart White Wi-Fi Ceiling Fan Wall Controller",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99888_IM.pdf?v=1736239933",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99888_Datasheet.pdf?v=1736239933",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00726_Wall_controller_99888.pdf?v=1757906122",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99888.jpg?v=1738645781"
  },
  {
    "sku": "20967",
    "title": "Brilliant Smart White Wi-Fi Dimmer Mech",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20967_IM_f9ca43cc-d6a2-4f98-aa8d-f21dfce6a6d9.pdf?v=1736313741",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20967_Datasheet_41384141-92a7-4140-8e51-5190834bf12d.pdf?v=1736313741",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20967_SDoC_69f6f8ff-f75b-480a-a813-0cb12d5e7484.pdf?v=1736313741",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20967_01e1370a-20b0-47fb-a686-2daee251850d.jpg?v=1737525558"
  },
  {
    "sku": "21521",
    "title": "Brilliant Smart White Wi-Fi Master Dimmer Mech",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21521_IM_b70df419-5472-45e0-9e16-3123119cf855.pdf?v=1736311633",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21521_Datasheet_bb620498-943c-400f-9608-3ac05d5f3968.pdf?v=1736311632",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21521_SDoC_e1ba2d90-9dcd-41ac-a44a-e800367f769e.pdf?v=1736311633",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21521_499c5acf-e115-42ad-87fa-bbea2d503b94.jpg?v=1737527633"
  },
  {
    "sku": "21322",
    "title": "Brilliant Smart White Wi-Fi Relay Mech",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21322_IM_66528178-fbb9-4098-9b9e-f4db6b2a94f6.pdf?v=1736247548",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21322_datasheet_a17d267e-5b3b-4554-9a04-f9054b37b634.pdf?v=1736247548",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21322SDoc_cda68cdd-ed07-426e-8941-12e38f103d49.pdf?v=1736247548",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21322.jpg?v=1736422606"
  },
  {
    "sku": "20715/05",
    "title": "Brilliant Smart White Wi-Fi Sensor Camera",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_Handy_Camera_20715.pdf?v=1748244525",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00526_Smart_Handy_Camera_20715.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2071505_1_bdea0a2c-cf5b-4831-a826-b6a1421e914c.jpg?v=1737005664"
  },
  {
    "sku": "21530",
    "title": "Brilliant Smart White Wi-Fi Slave Dimmer Mech",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21530_IM_3df07afe-0389-4410-955e-03172d682617.pdf?v=1736311010",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21530_Datasheet_7ad371b8-cd0e-4aaf-bf0d-9e9054b1e7a8.pdf?v=1736311009",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21530SDoC_fea79bf2-b0dd-4d40-a1ef-7d4f2e18e901.pdf?v=1736311009",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21530.jpg?v=1736422398"
  },
  {
    "sku": "21957",
    "title": "Brilliant Smart Wi-Fi A60 CCT LED Biorhythm B22 Globe",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21957_IM.pdf?v=1736312557",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21957_Datasheet.pdf?v=1736312558",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00783_LED_globe_21892_21893_21956_21957_21959.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21957.jpg?v=1736421203"
  },
  {
    "sku": "21956",
    "title": "Brilliant Smart Wi-Fi A60 CCT LED Biorhythm E27 Globe",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21956_IM.pdf?v=1736244011",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21956_Datasheet.pdf?v=1736244011",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00783_LED_globe_21892_21893_21956_21957_21959.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21956_a8596dd9-cc90-4a55-ace5-4937806a0f41.jpg?v=1739252761"
  },
  {
    "sku": "21959",
    "title": "Brilliant Smart Wi-Fi A60 RGB+W LED Biorhythm B22 Globe",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20239_Datasheet.pdf?v=1736225384",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00783_LED_globe_21892_21893_21956_21957_21959.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21959_69327097-b99d-416a-967a-9a8128a946ec.jpg?v=1739252853"
  },
  {
    "sku": "21958",
    "title": "Brilliant Smart Wi-Fi A60 RGB+W LED Biorhythm E27 Globe",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21958_IM.pdf?v=1736311883",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21958_Datasheet.pdf?v=1736311883",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21958_a4ae3b95-890b-4a51-8ef1-80790f1ea6e4.jpg?v=1739252832"
  },
  {
    "sku": "22081",
    "title": "Brilliant Smart Wi-Fi GU10 CCT LED Biorhythm Globe",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22081_Datasheet.pdf?v=1736311454",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22081_42d40d13-f205-4c41-bd5a-38e66e663c90.jpg?v=1739252914"
  },
  {
    "sku": "21960",
    "title": "Brilliant Smart Wi-Fi GU10 RGB+W LED Biorhythm Globe",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21960_Datasheet.pdf?v=1736315186",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_WiFi_GU10_Biorhythm_Globes_21960-22081.pdf?v=1748244529",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00739_smart_globe_21892_21893_21954_-21960.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21960_0e78dde5-4b3a-42e2-9f67-11ac9d811e63.jpg?v=1739252886"
  },
  {
    "sku": "21518",
    "title": "Brilliant Smart Wi-Fi Home Security Kit",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21518SP004_Datasheet.pdf?v=1736316276",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00650_Security_Kit_21518.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21518_88bdeb80-3862-4a4e-ba2f-21f2952012ba.jpg?v=1738648239"
  },
  {
    "sku": "21518SP002",
    "title": "Brilliant Smart Wi-Fi Home Security Kit Add- on Door/Window Magnetic Reed Switch",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21518SP004_Datasheet.pdf?v=1736316276",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00650_Security_Kit_21518.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21518SP002_5a20561d-855f-4b23-b489-649ada5ee2cf.jpg?v=1737005666"
  },
  {
    "sku": "21518SP001",
    "title": "Brilliant Smart Wi-Fi Home Security Kit Add- on PIR Motion Sensor",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21518SP004_Datasheet.pdf?v=1736316276",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00650_Security_Kit_21518.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21518SP001.jpg?v=1738648274"
  },
  {
    "sku": "21518SP004",
    "title": "Brilliant Smart Wi-Fi Home Security Kit Add-on Remote",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21518SP004_IM.pdf?v=1736316277",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21518SP004_Datasheet.pdf?v=1736316276",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00650_Security_Kit_21518.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21518SP004.jpg?v=1738648284"
  },
  {
    "sku": "20794",
    "title": "Brilliant Smart Wi-Fi LED Strip Light Controller",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20794_IM.pdf?v=1736227355",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20794_Datasheet.pdf?v=1736227354",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20794_SDoC.pdf?v=1736227355",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20794.jpg?v=1736416236"
  },
  {
    "sku": "22765/05",
    "title": "Brilliant Solana 52 DC Matt White",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIM23089_02_SOLANA_48in_52in_3_BLADE_DC_CEILING_FAN_22763_22765_05_06_INSTALLATION_MANUAL_21112024.pdf?v=1769747426",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22765_Datasheet_c9e575f7-da87-4d70-b518-800c7da69ed0.pdf?v=1736411097",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00869_Solana_22763_22765.pdf?v=1757906124",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22765-05.jpg?v=1739188107"
  },
  {
    "sku": "20101/16",
    "title": "Brilliant Stainless-Steel Atrium 48\" AC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20101_16_IM.pdf?v=1738226232",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20101_16_Datasheet.pdf?v=1738226232",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00439_Atrium_20101_20102_20108.pdf?v=1757906123",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20101_16_EXtension_rod_matrix.pdf?v=1738226231",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20101-16.jpg?v=1739185250"
  },
  {
    "sku": "20102/16",
    "title": "Brilliant Stainless-Steel Atrium 52\" AC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20102_IM.pdf?v=1736333995",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20102_Datasheet.pdf?v=1736333995",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00439_Atrium_20101_20102_20108.pdf?v=1757906123",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20102_Extension_Rod.pdf?v=1736333994",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20102-16.jpg?v=1739185280"
  },
  {
    "sku": "20103/16",
    "title": "Brilliant Stainless-Steel Atrium 56\" AC Ceiling Fan",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20103-16.jpg?v=1739185343"
  },
  {
    "sku": "20108/16",
    "title": "Brilliant Stainless-Steel Atrium E27 Ceiling Light Kit",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Product_Specs_-_Atrium.pdf.pdf?v=1757907493",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00439_Atrium_20101_20102_20108.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "100666/16",
    "title": "Brilliant Stainless-Steel Ceiling Fan Extension Rod 900mm with Fully Assembled Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "17942/16",
    "title": "Brilliant Stainless-Steel Entasis Exterior Wall Light Exterior Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/17942_Datasheet_a1f0e27e-59e9-449c-872d-68ff358c51f2.pdf?v=1736311600",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00882_Entasis_17942.pdf?v=1757906122",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1794216.jpg?v=1736413578"
  },
  {
    "sku": "18043/16",
    "title": "Brilliant Stainless-Steel Finial Energy Saving 600mm Bollard",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18043_Datasheet.pdf?v=1736243643",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00897_Berea_99939_SII_17383_18043.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1804316.jpg?v=1736407294"
  },
  {
    "sku": "18031/16",
    "title": "Brilliant Stainless-Steel Leto Energy Saving Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18031_datasheet.pdf?v=1736310914",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1803116.jpg?v=1736489469"
  },
  {
    "sku": "18051/16",
    "title": "Brilliant Stainless-Steel Portico 900mm Louvered Bollard",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18051_Datasheet.pdf?v=1736314474",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00883_Portico_18051.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1805116.jpg?v=1736332605"
  },
  {
    "sku": "21625SP003",
    "title": "Brilliant Stainless-Steel Seaford 20cm Extension Rod for Garden Lights",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "20607/16",
    "title": "Brilliant Stainless-Steel Seaford LED Exterior Up/Down Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20607_Datasheet.pdf?v=1736241779",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00536_Seaford_20597_20601_20605_20607.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2060716.jpg?v=1737713636"
  },
  {
    "sku": "21625/16",
    "title": "Brilliant Stainless-Steel Seaford LED Garden Spotlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21625_IM_052c6168-a1f3-436a-ae2e-e9e364cc1f74.pdf?v=1736316183",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21625_Datasheet_46bf5079-d5b4-41bc-8669-8f10ce1145fb.pdf?v=1736316183",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2162516.jpg?v=1738647504"
  },
  {
    "sku": "22267",
    "title": "Brilliant Standard 2m Aluminium Profile",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22267_Datasheet.pdf?v=1736221113",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22267_SDoC.pdf?v=1736221113",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22267_d211c9aa-b081-45c5-8f1b-ae11b9fac7a7.jpg?v=1737700416"
  },
  {
    "sku": "19937",
    "title": "Brilliant Talon-Duct Flexible Aluminium 100mm Dia X 3m Length",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "19940",
    "title": "Brilliant Talon-Duct Flexible Aluminium 150mm Dia X 6m Length",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "100550/77",
    "title": "Brilliant Titanium Como Ceiling Fan Extension Rod 900mm with Easy Connect Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "88888",
    "title": "Brilliant Touch Ceiling Fan Remote Control",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/88888_Datasheet.pdf?v=1736240157",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/88888_SDoc.pdf?v=1736240157",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/88888.jpg?v=1736410236"
  },
  {
    "sku": "22323",
    "title": "Brilliant Tri-Colour Colossus 24W LED Ceiling Fan Light Kit",
    "instructions": "",
    "datasheet": "",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00844_Colossus_22319_22573_22570_22677_22323.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22323.jpg?v=1756367583"
  },
  {
    "sku": "22086/05",
    "title": "Brilliant Trilogy WiFi Downlight",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_WiFi_Trilogy_Downlight_s2_22086.pdf?v=1748244530",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_WiFi_Trilogy_Downlight_s2_22086.pdf?v=1748244530",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2208605_f7d37677-377e-4fa8-8b4f-de74da9b1000.jpg?v=1739251249"
  },
  {
    "sku": "99999",
    "title": "Brilliant Universal Remotes to Suit AC Ceiling Fan",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99999_Datasheet.pdf?v=1736231255",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00418_Remote_Control_99999.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99999.jpg?v=1736413085"
  },
  {
    "sku": "DCWALLCONTROL",
    "title": "Brilliant Wall Controller for DC Ceiling Fans",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/DCWALLCONTROL_-_INSTRUCTION_MANUAL_V1.pdf?v=1765424684",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/DCWALLCONTROL.pdf?v=1748244535",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/DCWALLCONTROL-1.jpg?v=1737376104"
  },
  {
    "sku": "ISODCWALLCONTROL",
    "title": "Brilliant Wall Controller for DC Ceiling Fans with Isolation Switch",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/ISODCWALLCONTROL_-_INSTRUCTION_MANUAL_V1.pdf?v=1764821104",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Wall_Controller_Data_Sheets_OL.pdf?v=1764821104",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/ISODCWALLCONTROL.jpg?v=1764836141"
  },
  {
    "sku": "17558/01",
    "title": "Brilliant Warm White LED 2.4m Modular Strip Lighting Kit",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "21894",
    "title": "Brilliant Warm White LED MR16 5W Globe",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21894_Datasheet.pdf?v=1736220798",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21894_46c2da97-f60e-4c30-8ae6-903401dc4e73.jpg?v=1739252647"
  },
  {
    "sku": "22002",
    "title": "Brilliant Warm White Pixel 10m Strip Light Kit",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22002_Datasheet.pdf?v=1736240466",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00875_Strip_Light_Kit_22001_22002_22003_22004_22007_22008.pdf?v=1750048827",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22002.jpg?v=1736409680"
  },
  {
    "sku": "22001",
    "title": "Brilliant Warm White Pixel 5m Strip Light Kit",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22001_Datasheet.pdf?v=1736247271",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00875_Strip_Light_Kit_22001_22002_22003_22004_22007_22008.pdf?v=1750048827",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22001.jpg?v=1736405068"
  },
  {
    "sku": "18207",
    "title": "Brilliant Whisper 240mm Exhaust Fan 8\" Duct Adapter",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "18208",
    "title": "Brilliant Whisper 270mm Exhaust Fan 10\" Duct Adapter",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "19761/05",
    "title": "Brilliant White / Tri-Colour Ramsis 13W LED Dimmable Downlight",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19761-05.jpg?v=1739249053"
  },
  {
    "sku": "19764/05",
    "title": "Brilliant White / Tri-Colour Ramsis 24W LED Dimmable Downlight",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19764-05.jpg?v=1739249087"
  },
  {
    "sku": "22242/05",
    "title": "Brilliant White 18W CCT Dimmable Fan Light Kit",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22242_Datasheet.pdf?v=1736242917",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00806_Tempo_Plus_22270_22273_22276_22279_22242.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2224205.jpg?v=1737012613"
  },
  {
    "sku": "20759/05",
    "title": "Brilliant White 2 Gang Smart kinetic RF Dimmer Switch",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_Kinetic_RF_Dimmer_Switch_20758-20759-20760.pdf?v=1748244524",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00544_Kinetic_Dimming_Switch_20758_20759_20760.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2075905_ef987771-3408-4061-b4fa-65081aac8ba3.jpg?v=1737106026"
  },
  {
    "sku": "22808/05",
    "title": "Brilliant White 20W LED Fan Light Kit for Fantastic Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIM23091_01_FANTASTIC_DC_CEILING_FAN_LED_LIGHTKIT_22808_-_INSTRUCTION_MANUAL_V2.pdf?v=1765868537",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22808_05_06_FANTASTIC_LED_Light_Kit_OL.pdf?v=1765868542",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22808_05.jpg?v=1765868444"
  },
  {
    "sku": "22653/05",
    "title": "Brilliant White 240v Hardwired Interconnected Smoke Alarm",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22653_IM.pdf?v=1736245095",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22653_Datasheet.pdf?v=1736245095",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22653_SDoC.pdf?v=1736245094",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2265305.jpg?v=1736406280"
  },
  {
    "sku": "20760/05",
    "title": "Brilliant White 3 Gang Smart kinetic RF Dimmer Switch",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_Kinetic_RF_Dimmer_Switch_20758-20759-20760.pdf?v=1748244524",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00544_Kinetic_Dimming_Switch_20758_20759_20760.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2076005_0fdaa0dc-a523-4e94-8203-96f4de8bb7f3.jpg?v=1737005665"
  },
  {
    "sku": "20685/05",
    "title": "Brilliant White 3 Smart Elite Wi-Fi Glass Wall Switch",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_Elite_Glass_Switch_2068120683-20685-20687.pdf?v=1748244524",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00525_Wall_switch_20681_20683_20685_20687.pdf?v=1757906122",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2068505.jpg?v=1738648322"
  },
  {
    "sku": "22165/05",
    "title": "Brilliant White 6 Power Outlets Cannes Wi-Fi Power Board with USB-A & USB-C Charging",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_Cannes_WiFi_Surge_Powerboard_22165.pdf?v=1748244533",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00791_Powerboard_22165_22166.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2216505.jpg?v=1737005666"
  },
  {
    "sku": "80886/05",
    "title": "Brilliant White 70mm Conversion Plate to Suit Fixed Downlight",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "22166/05",
    "title": "Brilliant White 8 Power Outlets Cannes Wi-Fi Power Board with USB-A & USB-C Charging",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_Cannes_WiFi_Surge_Powerboard_22166.pdf?v=1748244533",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00791_Powerboard_22165_22166.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2216605_fcbb5c36-45d6-4458-bfb8-4ae59dd71ff6.jpg?v=1737005665"
  },
  {
    "sku": "80887/05",
    "title": "Brilliant White 90mm Conversion Plate to Suit Gimbal Downlight",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "23093/05",
    "title": "Brilliant White Airforce 2 lights 3-in-1 Bathroom Heater",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008683_02_INSTRUCTIONS_AIRFORCE_Bathroom_Heater_23093.pdf?v=1778643139",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/23093-05_AIRFORCE_Data_Sheet-2_OL.pdf?v=1778643140",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2309305_1.webp?v=1779336885"
  },
  {
    "sku": "20891/05",
    "title": "Brilliant White Aluminium Airmotion 48\'\' AC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20891_IM.pdf?v=1736335860",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20891_Datasheet.pdf?v=1736335860",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20891_SDoC.pdf?v=1736335860",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20891_Extension_Rod.pdf?v=1736335859",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20891-05.jpg?v=1739185404"
  },
  {
    "sku": "21553/05",
    "title": "Brilliant White Aluminium Airmotion-II 48\'\' AC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21553_IM.pdf?v=1736336304",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21553_Datasheet.pdf?v=1736336303",
    "sdoc": "",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21553_Extension_Rod.pdf?v=1736336304",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21553-05.jpg?v=1739185698"
  },
  {
    "sku": "21719/05",
    "title": "Brilliant White Amari Series II 4-Blades 52\'\' DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21719_IM_f493eac6-ad68-4d07-b37d-4568d21cc21e.pdf?v=1736400491",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21719_Datasheet_e9b77058-28b7-470c-b1a6-582787937170.pdf?v=1736400491",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21719_SDoC_c4c8d77d-64a0-40f4-9346-897cd52d0341.pdf?v=1736400491",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21719_Extension_Rod_001d81be-4fe7-414d-970e-6f7c9b5afd69.pdf?v=1736400490",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21719-05_22755e5c-1411-4361-9fdb-e385460e4696.jpg?v=1761641387"
  },
  {
    "sku": "21723/05",
    "title": "Brilliant White Amari Series II 56\'\' DC 5-Blades  Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21723_IM.pdf?v=1736331508",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Amari_II-56_Fan_21723__2107.pdf?v=1748244526",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21723_SDoC.pdf?v=1736331507",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21723_Extension_Rod.pdf?v=1736331507",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21723_05.jpg?v=1761622132"
  },
  {
    "sku": "21933/05",
    "title": "Brilliant White Archy LED CCT Recessed Face Downlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21933_IM_d79f8390-6ba6-42fd-8193-74b4c6fe8a00.pdf?v=1736248207",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21933_Datasheet_1abf2117-a6c6-48aa-8bce-ad47acc79a8c.pdf?v=1736248208",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00727_Archy_21933.pdf?v=1757906122",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21933-05.jpg?v=1739250128"
  },
  {
    "sku": "18839/05",
    "title": "Brilliant White Astro Clip Lamp",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "18627/05",
    "title": "Brilliant White Aviator Ceiling Fan Extension Rod 900mm with Easy Connect Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "22239/05",
    "title": "Brilliant White Aviator II 66\'\' DC Ceiling Fan LED CCT Light",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22239-05.jpg?v=1739245996"
  },
  {
    "sku": "19625/05",
    "title": "Brilliant White Backlit Panel Recessed Plaster Kit",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "21551/05",
    "title": "Brilliant White Backlit Panel Surface Mount Kit",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "19587/05",
    "title": "Brilliant White Bahama 52\" DC Ceiling Fan",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19587_Datasheet_98375f0e-df39-4195-ad30-c644b90be412.pdf?v=1736407031",
    "sdoc": "",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19587_Extension_Rod_a35da56e-0873-49aa-87a7-2f6a73837ca0.pdf?v=1736407030",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19587-05.jpg?v=1739184910"
  },
  {
    "sku": "21845/05",
    "title": "Brilliant White Belize 52\" DC 3-Blade Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21845_IM.pdf?v=1736329870",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21845_Datasheet.pdf?v=1736329870",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21845_SDoC.pdf?v=1736329869",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21845-05.jpg?v=1739186241"
  },
  {
    "sku": "19878/05",
    "title": "Brilliant White Blade Recessed 2W LED Emergency Exit Sign",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19878IM_f1b6426b-f57a-4da2-8be8-7dee62d04b68.pdf?v=1736230236",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19878_data_sheet_244928e4-5c4f-4cdb-b170-ffc8fdda5968.pdf?v=1736230236",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19878SDoc_5f98c9a6-1f3d-4e69-9f82-c071ba6c7a30.pdf?v=1736230236",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1987805.jpg?v=1736414786"
  },
  {
    "sku": "22773/05",
    "title": "Brilliant White Blizzard 270mm DC CCT Exhaust Fan with light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIM23082_01_BLIZZARD_Exhaust_Fan_SERIES_II_22771_22772_22773_22774_INSTRUCTIONS_04112024.pdf?v=1757646470",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Blizzard_Exhaust_Fan_Series_II-datasheet-new.pdf?v=1757646465",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00857_Blizzard_22771_22772_22773_22774.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2277305.jpg?v=1736408225"
  },
  {
    "sku": "22774/05",
    "title": "Brilliant White Blizzard 330mm DC CCT Exhaust Fan with light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIM23082_01_BLIZZARD_Exhaust_Fan_SERIES_II_22771_22772_22773_22774_INSTRUCTIONS_04112024.pdf?v=1757646470",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Blizzard_Exhaust_Fan_Series_II-datasheet-new.pdf?v=1757646465",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00857_Blizzard_22771_22772_22773_22774.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2277405.jpg?v=1736330212"
  },
  {
    "sku": "22771/05",
    "title": "Brilliant White Blizzard DC 270mm Exhaust Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIM23082_01_BLIZZARD_Exhaust_Fan_SERIES_II_22771_22772_22773_22774_INSTRUCTIONS_04112024.pdf?v=1757646470",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Blizzard_Exhaust_Fan_Series_II-datasheet-new.pdf?v=1757646465",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00857_Blizzard_22771_22772_22773_22774.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2277105.jpg?v=1736322426"
  },
  {
    "sku": "22772/05",
    "title": "Brilliant White Blizzard DC 330mm Exhaust Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIM23082_01_BLIZZARD_Exhaust_Fan_SERIES_II_22771_22772_22773_22774_INSTRUCTIONS_04112024.pdf?v=1757646470",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Blizzard_Exhaust_Fan_Series_II-datasheet-new.pdf?v=1757646465",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00857_Blizzard_22771_22772_22773_22774.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2277205.jpg?v=1736319597"
  },
  {
    "sku": "23026/05",
    "title": "Brilliant White Blizzard Square 270mm DC Exhaust Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Blizzard_Square_INSTRUCTION_BOOK_REV_1.pdf?v=1770174395",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Blizzard_Square_Exhaust_Fan_FA.pdf?v=1770174397",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2302605_2dce56cd-2908-45dd-853a-14951183292a.jpg?v=1770262323"
  },
  {
    "sku": "23028/05",
    "title": "Brilliant White Blizzard Square 270mm DC Exhaust Fan with LED Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Blizzard_Square_INSTRUCTION_BOOK_REV_1.pdf?v=1770174395",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Blizzard_Square_Exhaust_Fan_FA.pdf?v=1770174397",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2302805_aa5792b6-05be-461f-b905-b1fc6b225076.jpg?v=1770262309"
  },
  {
    "sku": "23027/05",
    "title": "Brilliant White Blizzard Square 330mm DC Exhaust Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Blizzard_Square_INSTRUCTION_BOOK_REV_1.pdf?v=1770174395",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Blizzard_Square_Exhaust_Fan_FA.pdf?v=1770174397",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2302705.jpg?v=1770262116"
  },
  {
    "sku": "23029/05",
    "title": "Brilliant White Blizzard Square 330mm DC Exhaust Fan with LED Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Blizzard_Square_INSTRUCTION_BOOK_REV_1.pdf?v=1770174395",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Blizzard_Square_Exhaust_Fan_FA.pdf?v=1770174397",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2302905.jpg?v=1770262361"
  },
  {
    "sku": "20750/05",
    "title": "Brilliant White Boreal-II 25W Round Exhaust Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20750_IM.pdf?v=1736332018",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20750_Datasheet.pdf?v=1736332019",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20750_SDoC.pdf?v=1736332018",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2075005.jpg?v=1736322466"
  },
  {
    "sku": "20751/05",
    "title": "Brilliant White Boreal-II 45W Round Exhaust Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20751_IM.pdf?v=1736408182",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20751_Datasheet.pdf?v=1736408183",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20751_SDoC.pdf?v=1736408183",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2075105.jpg?v=1736253618"
  },
  {
    "sku": "21883/05",
    "title": "Brilliant White Cannes Smart Wi-Fi Double Plug with USB-A and USB-C Chargers",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21884_05_IM.pdf?v=1738219667",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_Cannes_WiFi_Double_Adaptor_21883.pdf?v=1748244528",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00735_Smart_Cannes_21883_20767_20768.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2188305_0d80561b-f16e-4cbd-a938-1bc7339c37dd.jpg?v=1737109242"
  },
  {
    "sku": "21882/05",
    "title": "Brilliant White Cannes Smart Wi-Fi Powerboard with USB-A and USB-C Chargers",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_Cannes_WiFi_Surge_Powerboard_21882.pdf?v=1748244529",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00735_Smart_Cannes_Powerboard_21882.pdf?v=1757906122",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2188205.jpg?v=1737109129"
  },
  {
    "sku": "21884/05",
    "title": "Brilliant White Cannes Smart Wi-Fi Single Plug with USB-A and USB-C Chargers",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21884_05_IM.pdf?v=1738219667",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_Cannes_WiFi_Single_Adaptor_21884.pdf?v=1748244528",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00740_Smart_Cannes_21884_22000.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2188405.jpg?v=1737114461"
  },
  {
    "sku": "21929/05",
    "title": "Brilliant White Carbon Monoxide Digital Display Alarm",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21929_IM.pdf?v=1736306464",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21929_Datasheet.pdf?v=1736306464",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00876_Monoxide_Dectector_21929_21930.pdf?v=1750048827",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2192905.jpg?v=1738647920"
  },
  {
    "sku": "20265/05",
    "title": "Brilliant White Ceiling Fan Extension Rod 900mm with Assembled Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "20200/05",
    "title": "Brilliant White Ceiling Fan Extension Rod for Tempo DC 900mm with Fully Assembled Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "22128/05",
    "title": "Brilliant White Ceres CCT 3-Light Track Kit",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22128_IM_3fc2f52a-b602-4c48-ab93-fe8a89b5fd0d.pdf?v=1736314373",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22128_Datasheet_dbf32af4-b50c-4767-89c9-f46a4a9c160a.pdf?v=1736314372",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00824_Ceres_track_22128.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22128_05_e7285206-87e9-4c07-b11c-640ca75c243f.jpg?v=1737620215"
  },
  {
    "sku": "22127/05",
    "title": "Brilliant White Ceres CCT Spotlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22127_IM_25b3b09f-ef89-4680-9939-55d0bb8a6b77.pdf?v=1736316556",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22127_Datasheet_887512f0-2c80-4d45-b8e8-26c17d60c0cf.pdf?v=1736316556",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00893_Ceres_22127.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22127_05.jpg?v=1736330025"
  },
  {
    "sku": "22781/05",
    "title": "Brilliant White Ceres Pendant Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22781_IM_e8a6f718-0779-4847-b85a-6e0731ff58e5.pdf?v=1736231145",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22781_Datasheet_7a5cb4f0-71a1-4f04-92ef-8094b7d75b0c.pdf?v=1736231145",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22781_SDoC_b0a47ef5-b320-4818-b8b9-be7943a90b18.pdf?v=1736231145",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22781_05.jpg?v=1736478715"
  },
  {
    "sku": "20241",
    "title": "Brilliant White Cirque Fancy Round Soft Opal LED Globe",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20241_Datasheet.pdf?v=1736312825",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00420_LED_Globe_20239_20240_20241.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20241_7dd74371-7c61-4829-8edf-05f6a4e8a5f5.jpg?v=1739252295"
  },
  {
    "sku": "20240",
    "title": "Brilliant White Cirque G125 Soft Opal LED Globe",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20240_Datasheet.pdf?v=1736244082",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00420_LED_Globe_20239_20240_20241.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20240_dc3f1fd8-ae7b-43f8-a2a3-949fe86a2057.jpg?v=1739252253"
  },
  {
    "sku": "20239",
    "title": "Brilliant White Cirque G95 Soft Opal LED Globe",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20239_Datasheet.pdf?v=1736225384",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00420_LED_Globe_20239_20240_20241.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20239_5df196ef-962d-49ae-a373-0fc4bb8ada45.jpg?v=1739252217"
  },
  {
    "sku": "22677/05",
    "title": "Brilliant White Colossus 120\" DC Ceiling Fan 6-Blade",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22677_IM_c3e42212-0cac-4fc3-801c-010a100772ba.pdf?v=1736409789",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22677_Datasheet_07ef8c7e-09d7-41a3-92b6-9b3df91ac679.pdf?v=1736409789",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00844_Colossus_22319_22573_22570_22677.pdf?v=1750048828",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22677_Extension_Rod_25c69be9-308d-4161-8326-57663cf1eef6.pdf?v=1736409788",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22677-05.jpg?v=1739187568"
  },
  {
    "sku": "22319/05",
    "title": "Brilliant White Colossus 84\" DC Ceiling Fan 6-Blade",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22319_IM.pdf?v=1736329795",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22319_Datasheet.pdf?v=1736329795",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00844_Colossus_22319_22573_22570_22677.pdf?v=1750048828",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22319_Extension_Rod.pdf?v=1736329794",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22319-05.jpg?v=1739187409"
  },
  {
    "sku": "18769/05",
    "title": "Brilliant White Colossus-Aviator Ceiling Fan Extension Rod 900mm with Easy Connect Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "20071/05",
    "title": "Brilliant White Concorde-II 12W LED Light Kit",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20071_Datasheet_e87fa99d-59cb-4e59-815f-ce44ff0c2c72.pdf?v=1736230994",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2007105.jpg?v=1736413623"
  },
  {
    "sku": "19309/05",
    "title": "Brilliant White Cordia 12W Dimmable LED Flush Ceiling Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19309_IM.pdf?v=1736230603",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19309_Datasheet.pdf?v=1736230604",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19309_SDoC.pdf?v=1736230604",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1930905.jpg?v=1736413909"
  },
  {
    "sku": "19527/05",
    "title": "Brilliant White Cordia 12W Dimmable LED Round Ceiling Light",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "20460/05",
    "title": "Brilliant White Cordia 12W Flush Ceiling Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20460_Datasheet.pdf?v=1736227140",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00747_Concord_20460_20461_20462.pdf?v=1757906122",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2046005.jpg?v=1736416487"
  },
  {
    "sku": "20461/05",
    "title": "Brilliant White Cordia 18W Flush Ceiling Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20461_IM.pdf?v=1736226928",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20461_Datasheet.pdf?v=1736226928",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00747_Concord_20460_20461_20462.pdf?v=1757906122",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2046105.jpg?v=1736416585"
  },
  {
    "sku": "19529/05",
    "title": "Brilliant White Cordia 24W Dimmable LED Round Ceiling Light",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "20462/05",
    "title": "Brilliant White Cordia 24W Flush Ceiling Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20462_IM.pdf?v=1736239423",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20462_Datasheet.pdf?v=1736239423",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00747_Concord_20460_20461_20462.pdf?v=1757906122",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2046205.jpg?v=1736411126"
  },
  {
    "sku": "20532/05",
    "title": "Brilliant White Cruze 52 AC Ceiling Fan and LED Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20532_IM.pdf?v=1736334324",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20532_Datasheet.pdf?v=1736334323",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20532_SDoC.pdf?v=1736334323",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20532_Extension_Rod.pdf?v=1736334323",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20532-05.jpg?v=1739245107"
  },
  {
    "sku": "22204/05",
    "title": "Brilliant White Durban 58\'\' Ceiling Fan",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22204-05.jpg?v=1739186971"
  },
  {
    "sku": "23138/05",
    "title": "Brilliant White E27 Light Kit for Tonga DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN009099_23138_05_TONGA_E27_draft_0_1.pdf?v=1787630335",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/TONGA_DC_Ceiling_Fan_-_Light_Kit_Data_Sheet_OL.pdf?v=1787293918",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2313805.png?v=1787556078"
  },
  {
    "sku": "22828/05",
    "title": "Brilliant White Eco Flush LED CCT Dimmable Downlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22828_IM.pdf?v=1736314852",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22886_05_22828_05_ECO_LED_Downlight_OL.pdf?v=1761621214",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00896_Eco_22616_22617_22618_22619_22620_22621_22828.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22828-05.jpg?v=1739251117"
  },
  {
    "sku": "22886/05",
    "title": "Brilliant White Eco Recessed LED CCT Dimmable Downlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/INSTRUCTIONS_ECO_8W_CCT_DIMMABLE_DOWNLIGHT_RECESSED_22886_05_OL_-_Copy.pdf?v=1761622163",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22886_05_22828_05_ECO_LED_Downlight_OL.pdf?v=1761621214",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00896_Eco_22616_22617_22618_22619_22620_22621_22828.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2288605.jpg?v=1761639989"
  },
  {
    "sku": "20682/05",
    "title": "Brilliant White Elite Glass Wall Switch 1 Gang",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20682_IM_f2b49435-80a3-49a7-9b9b-51a3265cb0dd.pdf?v=1736241081",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Glass_Switch_20682-20684-20686-20688.pdf?v=1748244522",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20682SDoc_d9d8eb28-267c-4862-a230-d4d1142a7427.pdf?v=1736241081",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2068205_bbefb02f-3839-41c5-99db-edc5e43ddd4f.jpg?v=1738648090"
  },
  {
    "sku": "20684/05",
    "title": "Brilliant White Elite Glass Wall Switch 2 Gang",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Glass_Switch_20682-20684-20686-20688.pdf?v=1748244522",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00524_Wall_Switch_20682_20684_20686_20688.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2068405_cbb93826-127e-4ea2-a57f-0b0a75779c89.jpg?v=1738648102"
  },
  {
    "sku": "20686/05",
    "title": "Brilliant White Elite Glass Wall Switch 3 Gang",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Glass_Switch_20682-20684-20686-20688.pdf?v=1748244522",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00524_Wall_Switch_20682_20684_20686_20688.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2068605_7f4ad645-bd1d-4366-b600-2e858a6cd1bb.jpg?v=1738648117"
  },
  {
    "sku": "20688/05",
    "title": "Brilliant White Elite Glass Wall Switch 4 Gang",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Glass_Switch_20682-20684-20686-20688.pdf?v=1748244522",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00524_Wall_Switch_20682_20684_20686_20688.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2068805_0dd82f2a-8291-4d9d-8769-30d8c88a5af3.jpg?v=1738648155"
  },
  {
    "sku": "22752/08",
    "title": "Brilliant White Endura 12W/20W Dual-Watt LED Tri-Colour Batten",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22752_IM.pdf?v=1736320202",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22752_Datasheet.pdf?v=1736320203",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22752_SDoC.pdf?v=1736320202",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2275208.jpg?v=1736329867"
  },
  {
    "sku": "22753/08",
    "title": "Brilliant White Endura 12W/20W Dual-Wattage LED Tri-Colour Batten with Corridor function and Microwave Sensor",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22753_IM.pdf?v=1736320560",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22753_22755_Endura_Tri-Proof_Sensor_CCT_LED_Batten_OL.pdf?v=1748244535",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22753_SDoC.pdf?v=1736320559",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2275308.jpg?v=1736328755"
  },
  {
    "sku": "22754/08",
    "title": "Brilliant White Endura 12W/20W Dual-Wattage LED Tri-Colour Emergency Sensor Batten",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22754_IM.pdf?v=1736320615",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22754_22756_Endura_Tri-Proof_Emergency_CCT_LED_Batten_OL.pdf?v=1748244535",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22754_SDoC.pdf?v=1736320614",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2275408.jpg?v=1736328649"
  },
  {
    "sku": "22755/08",
    "title": "Brilliant White Endura 22W/40W Dual-Wattage LED Tri-Colour Batten with Corridor function and Microwave Sensor",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22755_IM.pdf?v=1736320334",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22753_22755_Endura_Tri-Proof_Sensor_CCT_LED_Batten_OL.pdf?v=1748244535",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00864_Endura_22752_22753_22755.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2275508.jpg?v=1736329733"
  },
  {
    "sku": "22756/08",
    "title": "Brilliant White Endura 22W/40W Dual-Wattage LED Tri-Colour Emergency Sensor Batten",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22756_IM.pdf?v=1736411041",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22754_22756_Endura_Tri-Proof_Emergency_CCT_LED_Batten_OL.pdf?v=1748244535",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22756_SDoC.pdf?v=1736411040",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2275608.jpg?v=1736252807"
  },
  {
    "sku": "19929/05",
    "title": "Brilliant White Essex LED Oval Bunker Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19929_Datasheet_8d2cc588-b480-489b-a26b-066719464618.pdf?v=1736405246",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00887_Essex_19820_19929_19930.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1992905.jpg?v=1736255325"
  },
  {
    "sku": "19930/05",
    "title": "Brilliant White Essex Louvred LED Oval Bunker Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19930_Datasheet.pdf?v=1736327624",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00887_Essex_19820_19929_19930.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1993005.jpg?v=1736327506"
  },
  {
    "sku": "18063/05",
    "title": "Brilliant White EYE 360 Series-II Surface Mount Recessed Pir Security Sensor",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18063_Datasheet.pdf?v=1736246971",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18063_SDoCpdf.pdf?v=1736246971",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1806305.jpg?v=1736405137"
  },
  {
    "sku": "20051/05",
    "title": "Brilliant White Eye-360 Microwave Security Sensor",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20051_Datasheet.pdf?v=1736316409",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00464_Eye-360_20048_20051.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2005105.jpg?v=1736330129"
  },
  {
    "sku": "22804/05",
    "title": "Brilliant White Fantastic 52\'\' DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIMXXXX_01_FANTASTIC_52in_3_BLADE_DC_CEILING_FAN_22804_05_06_INSTALLATION_MANUAL_31072024.pdf?v=1769747425",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22804_Datasheet_b7cc33be-aded-4643-b50e-46599b0cb148.pdf?v=1736320944",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00870_Fantastic_22804.pdf?v=1757906122",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22804_05.jpg?v=1761545635"
  },
  {
    "sku": "20777/05",
    "title": "Brilliant White Glenelg LED Exterior Up/Down Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20777_Datasheet_d43aae46-5be9-4372-a011-986fe652f099.pdf?v=1736239260",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00564_Glenelg_20775_20777_20779_20781.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20777_05.jpg?v=1737714768"
  },
  {
    "sku": "20775/05",
    "title": "Brilliant White Glenelg LED Exterior Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20775_Datasheet_c10040be-a5bf-4045-87f8-7602fc9d2dc5.pdf?v=1736312860",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00564_Glenelg_20775_20777_20779_20781.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20775_05.jpg?v=1737714720"
  },
  {
    "sku": "20781/05",
    "title": "Brilliant White Glenelg-Ambient LED Exterior Up/Down Wall Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20781_Datasheet_ba6bcd3a-6240-4085-9b28-912cfbfa6658.pdf?v=1736313971",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00564_Glenelg_20775_20777_20779_20781.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20781_05.jpg?v=1737714985"
  },
  {
    "sku": "20458/05",
    "title": "Brilliant White Griffin CCT 30W Round Snorkel Shop light",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "22908/05",
    "title": "Brilliant White Hardy 12W CCT Bunker Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22908_Hardy_Bunker_Light_OL.pdf?v=1781577871",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2290805.webp?v=1781609390"
  },
  {
    "sku": "19973/05",
    "title": "Brilliant White Hardy Led Eyelid Vandal-Proof Polycarbonate Bunker",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19973_Datasheet_d3ebb46b-e2e2-476f-9716-b248c11a07e1.pdf?v=1736400956",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00888_Hardy_19971_19973.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1997305.jpg?v=1736323732"
  },
  {
    "sku": "19971/05",
    "title": "Brilliant White Hardy LED Vandal-Proof Polycarbonate Bunker Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19971_Datasheet_387e5586-5a06-4e7b-b821-06b26e8f08a2.pdf?v=1736331887",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00888_Hardy_19971_19973.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1997105.jpg?v=1736322579"
  },
  {
    "sku": "20073/05",
    "title": "Brilliant White Hercules 84\" Industrial Sized Ceiling Fan",
    "instructions": "",
    "datasheet": "",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00442_Hercules_Ceiling_Fan_20073.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20073-05.jpg?v=1739185220"
  },
  {
    "sku": "19847/05",
    "title": "Brilliant White Horizon 2 Light Bathroom Mate",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19847_IMpdf.pdf?v=1736408127",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19847_Datasheet.pdf?v=1736408127",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19847_SDoC.pdf?v=1736408127",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1984705_9557dd82-a455-489a-b460-becfd90d091e.jpg?v=1737629981"
  },
  {
    "sku": "19849/05",
    "title": "Brilliant White Horizon 4 Light Bathroom Mate",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19849_IM.pdf?v=1736405291",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19849_Datasheet.pdf?v=1736405290",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19849_SDoC.pdf?v=1736405291",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1984905_e3c9f1a2-516e-461d-83df-9139e0c35ad3.jpg?v=1737630049"
  },
  {
    "sku": "20616/05",
    "title": "Brilliant White Hunter Trio Single Floodlight",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20616_Datasheet.pdf?v=1736230011",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00697_Hunter_Trio_20616_20622_20625.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2061605.jpg?v=1736415232"
  },
  {
    "sku": "20622/05",
    "title": "Brilliant White Hunter Trio Twin Floodlight",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20622_Datasheet_fbab68f1-7cf4-438e-bbd5-728de8a93c62.pdf?v=1736311490",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00697_Hunter_Trio_20616_20622_20625.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2062205.jpg?v=1736340215"
  },
  {
    "sku": "20625/05",
    "title": "Brilliant White Hunter Trio Twin Floodlight with Sensor",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20625_Datasheet_917e4c9e-5c0c-45b3-b62c-2225bbf18f23.pdf?v=1736315829",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00697_Hunter_Trio_20616_20622_20625.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2062505.jpg?v=1736330535"
  },
  {
    "sku": "19239/05",
    "title": "Brilliant White Hunter-III LED Single Light Floodlight",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19239_Datasheet_ecfcea38-826b-4e51-bf2a-ba711fd64e1c.pdf?v=1736242304",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00353_Hunter_III_19242_19245_19239_19975.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1923905.jpg?v=1736410420"
  },
  {
    "sku": "19975/05",
    "title": "Brilliant White Hunter-III LED Single Light Floodlight with Sensor",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19975_Datasheet_0c600b0a-41b0-45f8-888f-bbefe6b84b6d.pdf?v=1736315317",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00353_Hunter_III_19242_19245_19239_19975.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1997505.jpg?v=1736331160"
  },
  {
    "sku": "19242/05",
    "title": "Brilliant White Hunter-III LED Twin Light Floodlight",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19242_Datasheet_9022cdcd-386b-450a-8c2e-f7074d4173ce.pdf?v=1736314982",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00353_Hunter_III_19242_19245_19239_19975.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1924205.jpg?v=1736331878"
  },
  {
    "sku": "19245/05",
    "title": "Brilliant White Hunter-III LED Twin Light Floodlight with Sensor",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19245_Datasheet_b1167f13-abf6-4cd3-89e0-e3a0cea39b2d.pdf?v=1736311319",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00353_Hunter_III_19242_19245_19239_19975.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1924505.jpg?v=1736407015"
  },
  {
    "sku": "22269/05",
    "title": "Brilliant White Illumina CCT Gimbal Downlight",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22269_Datasheet.pdf?v=1736163319",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00793_Illumina_22269.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22269-05.jpg?v=1739250811"
  },
  {
    "sku": "21930/05",
    "title": "Brilliant White Interconnected Carbon Monoxide Alarm",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21930_IM.pdf?v=1736306418",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21930_Datasheet.pdf?v=1736306418",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00876_Monoxide_Dectector_21929_21930.pdf?v=1750048827",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2193005.jpg?v=1738647932"
  },
  {
    "sku": "21926/05",
    "title": "Brilliant White Interconnected Smoke Alarm",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21926_IM.pdf?v=1736220887",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21926_Datasheet.pdf?v=1736220887",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00823_Smoke_Alarm_21926_21927.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2192605.jpg?v=1738647964"
  },
  {
    "sku": "20676/05",
    "title": "Brilliant White Ireland Smart Wi-Fi Plug with USB Charger",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21884_05_IM.pdf?v=1738219667",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_Ireland_Plug_20676.pdf?v=1748244525",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00518_WIFI_Plug_20676.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2067605_1.jpg?v=1737701276"
  },
  {
    "sku": "22195/05",
    "title": "Brilliant White Joli 52\" DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22195_IM.pdf?v=1736399326",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22195_Datasheet.pdf?v=1736399326",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00753_Joli_22195.pdf?v=1757906123",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22195_Extension_Rod.pdf?v=1736399325",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22195-05.jpg?v=1739188398"
  },
  {
    "sku": "22196/05",
    "title": "Brilliant White Joli 52\" DC Ceiling Fan with Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22196_Datasheet.pdf?v=1736329734",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22196_05_709737a7-b309-45df-81a2-599fd13bdd28.jpg?v=1739245516"
  },
  {
    "sku": "20693/05",
    "title": "Brilliant White Jupiter Smart Wi-Fi Dimmer Connector",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_Jupiter_Dimmer_20693.pdf?v=1748244525",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00519_Jupiter_20693.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2069305.jpg?v=1737005666"
  },
  {
    "sku": "21427/05",
    "title": "Brilliant White Kalla Floor Lamp",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21427_IM_72aa4611-9336-41f7-8ace-9c3d62d22beb.pdf?v=1736243945",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21427_Datasheet_b2189bf6-4b17-462a-8ad1-d0702efe2449.pdf?v=1736243945",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00681_Kalla_Task_Lamp_21426_21427.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2142705.jpg?v=1736478129"
  },
  {
    "sku": "21426/05",
    "title": "Brilliant White Kalla LED Task Lamp",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21426_IM_556b568c-ec6d-42cd-b59c-55b3d027c2a1.pdf?v=1736242966",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21426_Datasheet_15069b85-c40b-43d0-a191-644d5f1a6749.pdf?v=1736242966",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21426_SDoC_2b2775c6-4b18-4d9c-a19a-3d172ea73389.pdf?v=1736242966",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2142605.jpg?v=1736409574"
  },
  {
    "sku": "22016/05",
    "title": "Brilliant White Kensley 10W Impact Poly LED Bunker Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Kensley_Bunker_Light_22016_22018.pdf?v=1748244529",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00784_Kensley_22016_22018.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2201605.jpg?v=1738646769"
  },
  {
    "sku": "22018/05",
    "title": "Brilliant White Kensley 20W Impact Poly LED Bunker Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22018.pdf?v=1741316345",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00784_Kensley_22016_22018.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2201805_62c2e17a-5d96-4db1-8a9f-ee7ea7e98cd0.jpg?v=1737622394"
  },
  {
    "sku": "19696/05",
    "title": "Brilliant White Lachlan LED Square Step Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19696_Datasheet_f6f37be9-a24a-4ba6-9658-3561576981cd.pdf?v=1736315684",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00885_Lachlan_19696_19698_20029_20030.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1969605.jpg?v=1736498887"
  },
  {
    "sku": "21430/05",
    "title": "Brilliant White Laine LED Task Lamp",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21430_IM.pdf?v=1736241589",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21430_Datasheet.pdf?v=1736241588",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21430_SDoC.pdf?v=1736241589",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2143005_a2f00e4d-76c5-4452-b95b-497b3772ec0f.jpg?v=1738064439"
  },
  {
    "sku": "23137/05",
    "title": "Brilliant White LED 18W Light Kit for Tonga DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN009098_23137_05_TONGA_LED_draft_0_1.pdf?v=1787293918",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/TONGA_DC_Ceiling_Fan_-_Light_Kit_Data_Sheet_OL.pdf?v=1787293918",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/23137-05.png?v=1787297845"
  },
  {
    "sku": "22201/05",
    "title": "Brilliant White LED 22W Light Kit for Mascot DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22201_IM_4874caed-2506-4361-875e-22456713b6a0.pdf?v=1736311421",
    "datasheet": "",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00756_Mascot_22197_22199_22201.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2220105.jpg?v=1736340289"
  },
  {
    "sku": "20365",
    "title": "Brilliant White LED Classic 12W A60 Shaped Globe",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20365_Datasheet.pdf?v=1736239974",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00428_LED_globe_20360_20361_20362_20362_20364_20365.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20365_94dd78fb-82e3-4b64-8119-a65a01ea32bf.jpg?v=1739252480"
  },
  {
    "sku": "19854",
    "title": "Brilliant White LED Classic 5W A60 Shaped Globe",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19854_Datsheet.pdf?v=1736226743",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19854_4727a2da-a136-4ed7-9a45-018fa36156f9.jpg?v=1739252185"
  },
  {
    "sku": "20361",
    "title": "Brilliant White LED Classic 9W A60 Shaped Globe",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20361_Datasheet.pdf?v=1736307422",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00428_LED_globe_20360_20361_20362_20362_20364_20365.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20361_aa404a0d-2884-4b67-8ad2-d6ce85d28096.jpg?v=1739252430"
  },
  {
    "sku": "21895",
    "title": "Brilliant White LED GU10 Globe",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21895_Datasheet.pdf?v=1736230338",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21895_SDoC.pdf?v=1736230340",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21895_c8a6ff82-ba1d-4367-90c5-265686a7a10b.jpg?v=1739252684"
  },
  {
    "sku": "22882/05",
    "title": "Brilliant White LED Light Kit for Cairns Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008343_CAIRNS_48-52_18W_CCT_LED_LIGHT_KIT_22882.pdf?v=1755677502",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22882_Cairns_LED_Light_Kit-2_OL.pdf?v=1764057532",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2288205.jpg?v=1755608827"
  },
  {
    "sku": "22747/05",
    "title": "Brilliant White Luca Pendant Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22747_IM_8bcd74c9-5188-4a9b-b44a-1288b9475f03.pdf?v=1736313475",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22747_Datasheet_d8477044-1db2-4705-9883-12d1a75fcf05.pdf?v=1736313476",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22747_SDoC_c0708364-f807-4b67-9f10-fede734dedd2.pdf?v=1736313475",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22747_05.jpg?v=1736916831"
  },
  {
    "sku": "20214/05",
    "title": "Brilliant White Lumascan-II CCT Downlight with Sensor",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20214_IM.pdf?v=1736246675",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Lumascan-II_Downlight_Update_2025_20214.pdf?v=1773631890",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20214_IM.pdf?v=1736246675",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20214-05.jpg?v=1739249371"
  },
  {
    "sku": "20203/05",
    "title": "Brilliant White Luxor CCT Gimbal LED Downlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20203_IM.pdf?v=1736161591",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20203_Datasheet.pdf?v=1736161592",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00826_Umbra_Luxor_20203_20204.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2020305.jpg?v=1736342505"
  },
  {
    "sku": "22779/05",
    "title": "Brilliant White Magma 2 lights 3-in-1 Bathroom Mate",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22779_IM.pdf?v=1736321304",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22779_Datasheet.pdf?v=1736321305",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22779_SDoCpdf.pdf?v=1736321304",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2277905.jpg?v=1736328154"
  },
  {
    "sku": "22780/05",
    "title": "Brilliant White Magma 4 Lights 3-in-1 Bathroom Mate",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22780_IMpdf.pdf?v=1736321359",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22780_Datasheet.pdf?v=1736321359",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22780_SDoC.pdf?v=1736321358",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2278005_e14e9dae-ca2e-441a-b432-d43ee84a6c60.jpg?v=1737624472"
  },
  {
    "sku": "21478/05",
    "title": "Brilliant White Marvel 3-In-1 Bathroom Mate",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21478_IM_7e814c13-af44-424e-a3d3-939d0f748633.pdf?v=1736399016",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21478_Datasheet_9bd4e98a-5930-45ad-a007-ccb8c0a5ed6b.pdf?v=1736399016",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21478_SDoC_a86cb05c-e300-4295-bae4-d14135f0c596.pdf?v=1736399015",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2147805_c3bcfc01-bb39-4ae1-aabd-4b0d72bbacf9.jpg?v=1737630668"
  },
  {
    "sku": "22197/05",
    "title": "Brilliant White Mascot 52\" DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22197_IM_b574f47d-355f-406e-9791-2c9cd08c4ffa.pdf?v=1736330602",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22197_Datasheet_eca9ebfc-b1e3-489c-97e9-81187956f70d.pdf?v=1736330602",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00756_Mascot_22197_22199_22201.pdf?v=1750048828",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22197_Extension_Rod_22e0369f-d4b3-454a-bb4a-97936da9077f.pdf?v=1736330601",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22197-05.jpg?v=1739186815"
  },
  {
    "sku": "22199/05",
    "title": "Brilliant White Mascot 58 AC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22199_IM_836d0ef3-ece9-46d7-abac-c99f2c9a143e.pdf?v=1736407417",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22199_Datasheet_9c6ab863-536d-4e29-aa4e-2cb69e6d6383.pdf?v=1736407416",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00756_Mascot_22197_22199_22201.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22199-05.jpg?v=1739186905"
  },
  {
    "sku": "20454/05",
    "title": "Brilliant White Mini Trim II CCT Gimbal Downlight",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20454_Datasheet_88808674-e553-4383-98bb-c2dd8e30569f.pdf?v=1736316452",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00889_Mini_Trim_20454.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20454-05.jpg?v=1739249454"
  },
  {
    "sku": "22887/05",
    "title": "Brilliant White Nevada 4-In-1 Bathroom Heater",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22887_Nevada_Instruction_BLIN008326_V2.pdf?v=1762481459",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22887-05_NEVADA_OL.pdf?v=1743761553",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00900_Nevada_22887.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2288705.jpg?v=1744099303"
  },
  {
    "sku": "20351/05",
    "title": "Brilliant White Newton 2+1 Light 3-In-1 Bathroom Mate",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20351_IM.pdf?v=1736330365",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20351_Datasheet.pdf?v=1736330365",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20351_SDoC.pdf?v=1736330365",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2035105.jpg?v=1736323583"
  },
  {
    "sku": "20352/05",
    "title": "Brilliant White Newton 4 Light Bathroom Mate",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20352_IM.pdf?v=1736408307",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20352_Datasheet.pdf?v=1736408307",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20352_SDoC.pdf?v=1736408308",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2035205.jpg?v=1736253354"
  },
  {
    "sku": "19986/05",
    "title": "Brilliant White Novellis Emergency LED Oyster Emergency Exit Lights",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "19874/05",
    "title": "Brilliant White One-Box 2W Exit Sign",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19874_IM_509f5e46-d3ec-4ff3-9556-4df4b3558335.pdf?v=1736313935",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19874_datasheet_3f860a5a-8d7a-4e37-aa07-9ee8a7ee30d7.pdf?v=1736313935",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1987405.jpg?v=1736333947"
  },
  {
    "sku": "99201/55",
    "title": "Brilliant White Optica Desk Mini-Magnifier Lamp",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "22721/05",
    "title": "Brilliant White Pacifica 48 DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22721_IM.pdf?v=1736240091",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22721_Datasheet.pdf?v=1736240090",
    "sdoc": "",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22721_Extension_Rod.pdf?v=1736240090",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22721-05_01b0d443-41b7-4365-be29-9d86c2aa05c8.jpg?v=1761643087"
  },
  {
    "sku": "22949/05",
    "title": "Brilliant White Pacifica II 48 DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/CPIN008413_01_PACIFICA_DC_48INCH_CEILING_FAN_22949.pdf?v=1762757289",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Pacifica_II_DC_Ceiling_Fan_Data_Sheets_OL.pdf?v=1762757290",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2294905.jpg?v=1762756209"
  },
  {
    "sku": "22722/05",
    "title": "Brilliant White Pacifica II 56\" DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22722_IM.pdf?v=1736311363",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22722_Datasheet.pdf?v=1736311362",
    "sdoc": "",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22722_Extension_Rod.pdf?v=1736311361",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22722-05_b4420fd7-7493-43f5-98d5-6f1336489eb9.jpg?v=1761643960"
  },
  {
    "sku": "22719/05",
    "title": "Brilliant White Pacifica-II 48 AC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22719_IM.pdf?v=1736313561",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22719_Datasheet.pdf?v=1736313561",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22719_SDoC.pdf?v=1736313560",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22719_Extension_Rod.pdf?v=1736313560",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22719-05_7c342117-9d30-4b96-a5ae-06bbdf6112dc.jpg?v=1761648543"
  },
  {
    "sku": "22720/05",
    "title": "Brilliant White Pacifica-II 56 AC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22720_IM.pdf?v=1736241139",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22720_Datasheet.pdf?v=1736241139",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22720_SDoC.pdf?v=1736241138",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22720_Extension_Rod.pdf?v=1736241138",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22720-05_be1b370e-31c1-4a8a-80e9-7e94f8048649.jpg?v=1761646767"
  },
  {
    "sku": "22723/05",
    "title": "Brilliant White Pacifica-II Clipper Light Kit",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22723_IM.pdf?v=1736313323",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22723_Datasheet.pdf?v=1736313323",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2272305_abcf2324-8bf1-479e-94ab-5caba974c3c9.jpg?v=1737631311"
  },
  {
    "sku": "22724/05",
    "title": "Brilliant White Pacifica-II Oyster Light Kit",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22724_IM.pdf?v=1736306548",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22724_Datasheet.pdf?v=1736306548",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22724_SDoC.pdf?v=1736306547",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2272405.jpg?v=1736422529"
  },
  {
    "sku": "22087/05",
    "title": "Brilliant White Preston 48\" DC Ceiling Fan Hugger",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22087_IM.pdf?v=1736331458",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22087_Datasheet.pdf?v=1736331457",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22087-05.jpg?v=1739186722"
  },
  {
    "sku": "22089/05",
    "title": "Brilliant White Preston 48\" DC Ceiling Fan Hugger with LED CCT Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22089_IM.pdf?v=1736393822",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22089_Datasheet.pdf?v=1736393822",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22089-05_26a3104b-2886-40d0-af94-e841bc5be9f0.jpg?v=1739245479"
  },
  {
    "sku": "21996/05",
    "title": "Brilliant White Project Propack CCT Downlight & Socket-20-Pack",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21996_IM.pdf?v=1736311684",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21996_Datasheet.pdf?v=1736311684",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21996_SDoC.pdf?v=1736311683",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21996-05.jpg?v=1739250228"
  },
  {
    "sku": "22785/05",
    "title": "Brilliant White Ramsis Series II 13W Downlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22785_IM.pdf?v=1736320775",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22785_Datasheet.pdf?v=1736320775",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22785_SDoC.pdf?v=1736320775",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22785-05.jpg?v=1739250977"
  },
  {
    "sku": "22786/05",
    "title": "Brilliant White Ramsis Series II 15W Downlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22786_IM.pdf?v=1736320405",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22786_Datasheet.pdf?v=1736320405",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22786_SDoC.pdf?v=1736320404",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22786-05.jpg?v=1739251019"
  },
  {
    "sku": "22787/05",
    "title": "Brilliant White Ramsis Series II 18W Downlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22787_IM.pdf?v=1736320272",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22787_Datasheet.pdf?v=1736320272",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22787_SDoC.pdf?v=1736320272",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22787-05.jpg?v=1739251052"
  },
  {
    "sku": "22788/05",
    "title": "Brilliant White Ramsis Series II 24W Downlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22788_DAatasheet.pdf?v=1736320456",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22788_DAatasheet.pdf?v=1736320456",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22788_SDoC.pdf?v=1736320455",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2278805.jpg?v=1736332842"
  },
  {
    "sku": "21472/05",
    "title": "Brilliant White Rectangle Backlit 36W Single Colour LED Panel Light",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "21473/05",
    "title": "Brilliant White Rectangle Backlit 36W Tri-Colour LED Panel Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21473_IM.pdf?v=1736230787",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21473_Datasheet.pdf?v=1736230786",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21473_SDoC.pdf?v=1736230785",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2147305.jpg?v=1737369137"
  },
  {
    "sku": "20052/05",
    "title": "Brilliant White Retro-Fit Microwave Ceiling and Wall Sensor",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20052_Datasheet.pdf?v=1736231287",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00465_Retro-fit_sensor_20052.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2005205.jpg?v=1736413031"
  },
  {
    "sku": "22654/05",
    "title": "Brilliant White Rf Remote Control for Interconnected Smoke &  Carbon Monoxide Alarms",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22654_IM.pdf?v=1736316248",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smoke_alarm_remote_control_22654.pdf?v=1748244528",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2265405.jpg?v=1738648010"
  },
  {
    "sku": "21937",
    "title": "Brilliant White RGB LED 10m Strip Light Kit",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "18983/05",
    "title": "Brilliant White Saint Louis Arched Floor Lamp",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "22375/05",
    "title": "Brilliant White Sarico 270mm LED CCT Exhaust Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22375_IM.pdf?v=1736227041",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22375_Datasheet.pdf?v=1736227040",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22375_SDoC.pdf?v=1736227041",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2237505.jpg?v=1736416532"
  },
  {
    "sku": "22376/05",
    "title": "Brilliant White Sarico 325mm LED CCT Exhaust Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22376_IM.pdf?v=1736163105",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22376_Datasheet.pdf?v=1736163105",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22376_SDoC.pdf?v=1736163105",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2237605.jpg?v=1736404533"
  },
  {
    "sku": "23030/05",
    "title": "Brilliant White Sarico Promax Square 270mm AC Exhaust Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008603_01_Sarico_Promax_23030_23031_23032_23033_INSTRUCTIONS.pdf?v=1771295527",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/23030-05_23031-05_Sarico_Exhaust_Fan_FA.pdf?v=1770874798",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2303005.jpg?v=1770972737"
  },
  {
    "sku": "23032/05",
    "title": "Brilliant White Sarico Promax Square 270mm AC Exhaust Fan with LED Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008603_01_Sarico_Promax_23030_23031_23032_23033_INSTRUCTIONS.pdf?v=1771295527",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/23032-05_23033-05_Sarico_Exhaust_Fan_with_Light_FA.pdf?v=1770874798",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2303205.jpg?v=1770972465"
  },
  {
    "sku": "23031/05",
    "title": "Brilliant White Sarico Promax Square 330mm AC Exhaust Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008603_01_Sarico_Promax_23030_23031_23032_23033_INSTRUCTIONS.pdf?v=1771295527",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/23030-05_23031-05_Sarico_Exhaust_Fan_FA.pdf?v=1770874798",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2303105.jpg?v=1770972570"
  },
  {
    "sku": "23033/05",
    "title": "Brilliant White Sarico Promax Square 330mm AC Exhaust Fan with LED Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008603_01_Sarico_Promax_23030_23031_23032_23033_INSTRUCTIONS.pdf?v=1771295527",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/23032-05_23033-05_Sarico_Exhaust_Fan_with_Light_FA.pdf?v=1770874798",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2303305.jpg?v=1770972322"
  },
  {
    "sku": "18193/05",
    "title": "Brilliant White Sarico-II Square 270mm Exhaust Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18193_IM.pdf?v=1736328179",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18193_Datasheet.pdf?v=1736328180",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18193_SDoC.pdf?v=1736328179",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1819305.jpg?v=1736327112"
  },
  {
    "sku": "18194/05",
    "title": "Brilliant White Sarico-II Square 325mm Exhaust Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18194_IM.pdf?v=1736399081",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18194_Datasheet.pdf?v=1736399082",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18194_SDoC.pdf?v=1736399082",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1819405.jpg?v=1736319230"
  },
  {
    "sku": "22125/05",
    "title": "Brilliant White Saturn 15W CCT Ceiling Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22125_Datasheet.pdf?v=1736246611",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00820_Saturn_22125_22126.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2212505.jpg?v=1736405798"
  },
  {
    "sku": "22126/05",
    "title": "Brilliant White Saturn 24W CCT Ceiling Light",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22126_Datasheet.pdf?v=1736226179",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00820_Saturn_22125_22126.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2212605.jpg?v=1736417491"
  },
  {
    "sku": "21353/05",
    "title": "Brilliant White Series II Eye 360 Mini PIR Sensor",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21353_Datasheet.pdf?v=1736306509",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00651_Eye_Sensor_21353.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2135305.jpg?v=1736404662"
  },
  {
    "sku": "20788/05",
    "title": "Brilliant White Shielder LED Single Light Floodlight",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20788_Datasheet_796458ca-134d-479f-aa11-5bbbe6248c4e.pdf?v=1736226638",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00569_Shielder_20784_20786_20788.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2078805.jpg?v=1736417635"
  },
  {
    "sku": "20786/05",
    "title": "Brilliant White Shielder LED Twin Floodlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Shielder_20786_Double_Instructions____12082019.pdf?v=1746509974",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20786_Datasheet_3e76373d-09fb-49e0-8185-3dcc3d95c8ce.pdf?v=1736313208",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00569_Shielder_20784_20786_20788.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2078605.jpg?v=1736336955"
  },
  {
    "sku": "20784/05",
    "title": "Brilliant White Shielder LED Twin Light Floodlight with Sensor",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20784_Datasheet_673655ff-5220-4e8a-a85e-0fec30b38a76.pdf?v=1736314147",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00569_Shielder_20784_20786_20788.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2078405.jpg?v=1736341303"
  },
  {
    "sku": "21439/05",
    "title": "Brilliant White Smart Mesh Bluetooth Gateway",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_Mesh_Gateway_21439.pdf?v=1748244527",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00664_Mesh_Gateway_21439.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2143905_71961ce4-f6cd-436e-accf-ab4cc017fb97.jpg?v=1737528906"
  },
  {
    "sku": "21465",
    "title": "Brilliant White Smart Nexus Universal Gateway Home Ultimate",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21465_IM_57e7e81d-cb75-4447-97fb-2cb78f906653.pdf?v=1736225307",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21465_Datasheet_5bb15c9b-c4ca-4eef-8fe5-ef78350f6643.pdf?v=1736225305",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00667_Nexus_Gateway_21463_21464_21465.pdf?v=1757906122",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21465.jpg?v=1736417913"
  },
  {
    "sku": "20714/05",
    "title": "Brilliant White Smart Wi-Fi Contact Sensor",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_Reed_Switch_20714.pdf?v=1748244526",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00529_DIY_REED_Switch_20714.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2071405.jpg?v=1738648218"
  },
  {
    "sku": "21879/05",
    "title": "Brilliant White Smart Wi-Fi Droplet Indoor Camera",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_WiFi_Droplet_Camera_21879-21880.pdf?v=1748244528",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00741_Droplet_21879_21880.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2187905_1.jpg?v=1737005665"
  },
  {
    "sku": "21456/05",
    "title": "Brilliant White Smart Wi-Fi Garage Door Controller",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_WiFi_Garage_Door_Controller_21456.pdf?v=1748244529",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2145605.jpg?v=1738648356"
  },
  {
    "sku": "21927/05",
    "title": "Brilliant White Smart Wi-Fi Interconnected Smoke Alarm",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_Interconnect_Smoke_Alarm_21927.pdf?v=1748244535",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00823_Smoke_Alarm_21926_21927.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2192705_8b172cb0-952f-4ab6-9c14-457c74aa18a4.jpg?v=1738647974"
  },
  {
    "sku": "21436/05",
    "title": "Brilliant White Smart Wi-Fi Rechargeable Camera",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_WiFi_Zip_Camera_21436.pdf?v=1748244529",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00649_Smart_Camera_21436.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2143605.jpg?v=1737005667"
  },
  {
    "sku": "20712/05",
    "title": "Brilliant White Smart Wi-Fi Siren Alarm",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_Siren_Alarm_20712.pdf?v=1748244526",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00528_Siren_Alarm_20712.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2071205_89adf37f-9879-43ce-be57-29a33e937039.jpg?v=1738647985"
  },
  {
    "sku": "21007/05",
    "title": "Brilliant White Smart Wi-Fi Solar Camera",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_WiFi_Trident_Camera_21007.pdf?v=1748244528",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00595_Solar_Camera_21007.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2100705_1.jpg?v=1737005668"
  },
  {
    "sku": "21457/05",
    "title": "Brilliant White Smart Wi-Fi Universal Door Controller",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_WiFi_Universal_Door_Controller_21457.pdf?v=1748244530",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00668_Door_Opener_21457.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2145705_cea4bdb5-3dd6-4cc5-97c0-5243f6860469.jpg?v=1738648375"
  },
  {
    "sku": "22063/05",
    "title": "Brilliant White Smart Wi-Fi Video Doorbell and Chime",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_WiFi_Deacon_Doorbell_and_Chime_22063.pdf?v=1748244529",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00828_Deacon_22063.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2206305_1.jpg?v=1737005665"
  },
  {
    "sku": "22168/05",
    "title": "Brilliant White Smart Wi-Fi Water Leak Detector",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_WiFi_Water_Leak_Sensor_Sensor_22168.pdf?v=1748244533",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00795_Water_Leak_Sensor_22168.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2216805_5d2b3804-d7c6-45d6-9fe4-de083453f791.jpg?v=1738647997"
  },
  {
    "sku": "20708/05",
    "title": "Brilliant White Smart WiFi PIR Motion Sensor",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_PIR_Sensor_20708.pdf?v=1748244525",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00527_Smart_PIR_sensor_20708.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2070805_999b1bbb-137d-4e1e-9eb9-4df79742965d.jpg?v=1738648508"
  },
  {
    "sku": "22169/05",
    "title": "Brilliant White Smart WiFi PIR Sensor Series II",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_PIR_Sensor_Series_II_22169.pdf?v=1748244534",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00796_Smart_sensor_22169.pdf?v=1757906121",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2216905_c953090b-687e-411c-97f5-376538250171.jpg?v=1737005666"
  },
  {
    "sku": "21476/05",
    "title": "Brilliant White Solace 4-In-1 Bathroom Mate",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21476_IM.pdf?v=1736404094",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21476_Datasheet.pdf?v=1736404093",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21476_SDoC.pdf?v=1736404093",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2147605.jpg?v=1736257142"
  },
  {
    "sku": "21785/05",
    "title": "Brilliant White Solace XL 4-In-1 Bathroom Mate",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21785_IM.pdf?v=1736329680",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21785_Datasheet.pdf?v=1736329680",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21785_SDoC.pdf?v=1736329680",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2178505.jpg?v=1736326712"
  },
  {
    "sku": "22767/05",
    "title": "Brilliant White Solana 18W LED CCT Light Kit",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIM23089_01_SOLANA_CEILING_FAN_LED_LIGHTKIT_22767_05_06_INSTALLATION_MANUAL_21112024.pdf?v=1769747425",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2276705.jpg?v=1756367139"
  },
  {
    "sku": "22759/05",
    "title": "Brilliant White Solana 48\" AC ABS Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIM23089_01_SOLANA_48in_52in_3_BLADE_AC_CEILING_FAN_22759_22761_05_06_INSTALLATION_MANUAL_21112024.pdf?v=1769747426",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Solana_Data_Sheet.pdf?v=1793182345",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00868_Solana_22759_22761.pdf?v=1757906123",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22759_Extension_Rod_abfeecbb-4976-4e12-b5e3-98ba5ac338ef.pdf?v=1736410773",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22759-05.jpg?v=1739187626"
  },
  {
    "sku": "22763/05",
    "title": "Brilliant White Solana 48\" DC ABS Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIM23089_02_SOLANA_48in_52in_3_BLADE_DC_CEILING_FAN_22763_22765_05_06_INSTALLATION_MANUAL_21112024.pdf?v=1769747426",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22763_Datasheet_c986aa62-5281-4e95-a00e-02f4cb222850.pdf?v=1736410962",
    "sdoc": "",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22763_Extension_Rod_ade3ddeb-03b9-46f4-b2c8-937945098263.pdf?v=1736410960",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22763-05.jpg?v=1739188058"
  },
  {
    "sku": "22761/05",
    "title": "Brilliant White Solana 52\" AC ABS Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIM23089_01_SOLANA_48in_52in_3_BLADE_AC_CEILING_FAN_22759_22761_05_06_INSTALLATION_MANUAL_21112024.pdf?v=1769747426",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Solana_Data_Sheet.pdf?v=1793182345",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00868_Solana_22759_22761.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22761-05.jpg?v=1739188004"
  },
  {
    "sku": "22769/05",
    "title": "Brilliant White Solana Clipper Light Kit",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIM23089_01_SOLANA_CEILING_FAN_CLIPPER_LIGHTKIT_22769_05_06_INSTALLATION_MANUAL_21112024.pdf?v=1769747425",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2276905.jpg?v=1756367295"
  },
  {
    "sku": "21474/05",
    "title": "Brilliant White Square Backlit 36W Single Colour LED Panel Light",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "21475/05",
    "title": "Brilliant White Square Backlit 36W Tri-Colour LED Panel Light",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "22822/05",
    "title": "Brilliant White Stinger LED Single Flood Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22822_IM_84df51a5-a387-4df0-a9e2-e2557cce9b3e.pdf?v=1736320709",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22822_Datasheet_62fa5b66-f202-4b47-b2da-dd6ea80992f2.pdf?v=1736320710",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22822_SDoC_fa1f6735-5773-4853-9f17-11326dde254c.pdf?v=1736320709",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2282205.jpg?v=1736328585"
  },
  {
    "sku": "22287/05",
    "title": "Brilliant White Stinger LED Twin Floodlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22287_IM_4e7f19eb-b473-44dd-a181-a4d4f330ed59.pdf?v=1736313649",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22287_Datasheet_b2eb2e83-e3c1-48c4-8155-9967e7aefbd2.pdf?v=1736313649",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00807_Stinger_22287_22289.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2228705.jpg?v=1736418187"
  },
  {
    "sku": "22289/05",
    "title": "Brilliant White Stinger LED Twin Security Light with Sensor",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22289_IM_01c6d00c-40a9-4d07-a027-42e921a92c45.pdf?v=1736311549",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22289_Datasheet_ce263bc5-84c1-4140-bf16-b620c2fb2f7d.pdf?v=1736311549",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00807_Stinger_22287_22289.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2228905.jpg?v=1736339956"
  },
  {
    "sku": "22824/05",
    "title": "Brilliant White Stinger Single Floodlight with Sensor",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22824_IM_8901b026-188f-4032-9000-fd5af5732d02.pdf?v=1736320837",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22824_Datasheet_bb5037bf-cba0-4681-afee-3a832e76e0e7.pdf?v=1736320837",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22824_SDoC_63e19fea-373e-4234-acb5-a1eb83497219.pdf?v=1736320836",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2282405.jpg?v=1736328812"
  },
  {
    "sku": "20748/05",
    "title": "Brilliant White Supernova-II 2+1 Light 3-In-1 Bathroom Mate",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20748_IM.pdf?v=1736336034",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20748_Datasheet.pdf?v=1736336033",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20748_SDoC.pdf?v=1736336034",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2074805.jpg?v=1736321247"
  },
  {
    "sku": "20749/05",
    "title": "Brilliant White Supernova-II 4+1 Light 3-In-1 Bathroom Mate",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Supernova-II_4_Light_Heater_20749.pdf?v=1748244527",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00545_SuperNova_20748_20749.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2074905.jpg?v=1736321861"
  },
  {
    "sku": "20801/05",
    "title": "Brilliant White Swift Smart Wi-Fi Pan and Tilt Camera",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Smart_WiFi_Swift_Camera_20801.pdf?v=1748244527",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00596_Swift_Camera_20801.pdf?v=1757906122",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2080105_1_ecdd0dfa-33d4-47ef-93cd-84ef0a2f2b98.jpg?v=1738648549"
  },
  {
    "sku": "22373/05",
    "title": "Brilliant White Talon 270mm LED CCT Exhaust Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22373_IM.pdf?v=1736394177",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22373_Datasheet.pdf?v=1736394177",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22373_SDoC.pdf?v=1736394177",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2237305_4bf5da6e-1256-4f5f-bca1-e146841e5289.jpg?v=1738128061"
  },
  {
    "sku": "22374/05",
    "title": "Brilliant White Talon 325mm LED CCT Exhaust Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22374_IM.pdf?v=1736224770",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22374_Datasheet.pdf?v=1736224769",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22374_SDoCpdf.pdf?v=1736224770",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2237405.jpg?v=1736418285"
  },
  {
    "sku": "22888/05",
    "title": "Brilliant White Talon Promax Round 270mm Exhaust Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/V02_TALON_PROMAX_Exhaust_Fan_22888_22889_22890_22891_INSTRUCTIONS.pdf?v=1751858931",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22888_22889_Promax_Exhaust_Fan_OL.pdf?v=1743761553",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00898_Promax_22888_22889_22890_22891_22894_22895_22904_22905.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22888-05.jpg?v=1762165093"
  },
  {
    "sku": "22894/05",
    "title": "Brilliant White Talon Promax Round 270mm Exhaust Fan with Delay Timer",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Talon_ProMax_Timer_IM.pdf?v=1756952838",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22894_22895_Promax_Exhaust_Fan_OL.pdf?v=1743761553",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00898_Promax_22888_22889_22890_22891_22894_22895_22904_22905.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2289405.jpg?v=1744100701"
  },
  {
    "sku": "22890/05",
    "title": "Brilliant White Talon Promax Round 270mm Exhaust Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/V02_TALON_PROMAX_Exhaust_Fan_22888_22889_22890_22891_INSTRUCTIONS.pdf?v=1751858931",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22890_22891_Promax_Exhuast_Fan_OL.pdf?v=1743761552",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00898_Promax_22888_22889_22890_22891_22894_22895_22904_22905.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22890-05.jpg?v=1762164007"
  },
  {
    "sku": "22904/05",
    "title": "Brilliant White Talon Promax Round 270mm Exhaust Fan with Light and Delay Timer",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Talon_ProMax_Timer_IM.pdf?v=1756952838",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22904_22907_Promax_Exhaust_Fan_OL.pdf?v=1756711889",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00898_Promax_22888_22889_22890_22891_22894_22895_22904_22905.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2290405.jpg?v=1756717995"
  },
  {
    "sku": "22889/05",
    "title": "Brilliant White Talon Promax Round 330mm Exhaust Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/V02_TALON_PROMAX_Exhaust_Fan_22888_22889_22890_22891_INSTRUCTIONS.pdf?v=1751858931",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22888_22889_Promax_Exhaust_Fan_OL.pdf?v=1743761553",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00898_Promax_22888_22889_22890_22891_22894_22895_22904_22905.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2288905.jpg?v=1744099896"
  },
  {
    "sku": "22895/05",
    "title": "Brilliant White Talon Promax Round 330mm Exhaust Fan with Delay Timer",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Talon_ProMax_Timer_IM.pdf?v=1756952838",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22894_22895_Promax_Exhaust_Fan_OL.pdf?v=1743761553",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00898_Promax_22888_22889_22890_22891_22894_22895_22904_22905.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2289505.jpg?v=1744100800"
  },
  {
    "sku": "22891/05",
    "title": "Brilliant White Talon Promax Round 330mm Exhaust Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/V02_TALON_PROMAX_Exhaust_Fan_22888_22889_22890_22891_INSTRUCTIONS.pdf?v=1751858931",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22890_22891_Promax_Exhuast_Fan_OL.pdf?v=1743761552",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00898_Promax_22888_22889_22890_22891_22894_22895_22904_22905.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22891-05.jpg?v=1762164326"
  },
  {
    "sku": "22907/05",
    "title": "Brilliant White Talon Promax Round 330mm Exhaust Fan with Light and Delay Timer",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Talon_ProMax_Timer_IM.pdf?v=1756952838",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22904_22907_Promax_Exhaust_Fan_OL.pdf?v=1756711889",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2290705.jpg?v=1756718037"
  },
  {
    "sku": "18255/05",
    "title": "Brilliant White Talon Round 240mm Exhaust Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18255_IM.pdf?v=1736335944",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Updated_Talon_Round_Exhaust_Fan_18190_18255_c16812c1-aed4-48c7-b0bd-de5b781cba13.pdf?v=1747199222",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18255SDoC.pdf?v=1736335944",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1825505.jpg?v=1736321337"
  },
  {
    "sku": "18190/05",
    "title": "Brilliant White Talon Round 290mm Exhaust Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18190_IM.pdf?v=1736406166",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Updated_Talon_Round_Exhaust_Fan_18190_18255_c16812c1-aed4-48c7-b0bd-de5b781cba13.pdf?v=1747199222",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18190_SDoC.pdf?v=1736406166",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1819005.jpg?v=1736253975"
  },
  {
    "sku": "20049/05",
    "title": "Brilliant White Techno-Scan Security Sensor with Remote",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20049_Datasheet.pdf?v=1736231056",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00466_Techno-scan_sensor_20049.pdf?v=1757906122",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2004905.jpg?v=1736413323"
  },
  {
    "sku": "20580/05",
    "title": "Brilliant White Tempest 52\'\' AC 4-Blade Ceiling Fan with LED Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20580_IM.pdf?v=1736330069",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20580_Datasheet.pdf?v=1736330068",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20580_SDoC.pdf?v=1736330068",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20580_Extension_Rod.pdf?v=1736330068",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20580-05.jpg?v=1739245133"
  },
  {
    "sku": "22235/05",
    "title": "Brilliant White Tempest ABS 52\" DC Ceiling Fan",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22235_Datasheet_9604c23b-3328-44a9-80ab-fbf73d36c738.pdf?v=1736408374",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00808_Tempest_ABS_22235.pdf?v=1750048828",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22235_Extension_Rod_96a5ec15-c927-4ed1-887f-424404b2dd04.pdf?v=1736408374",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22235-05.jpg?v=1739187027"
  },
  {
    "sku": "22237/05",
    "title": "Brilliant White Tempest ABS DC LED Ceiling Fan Light kit",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22237_Datasheet.pdf?v=1736225852",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00808_Tempest_ABS_22235_22237.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2223705.jpg?v=1736416392"
  },
  {
    "sku": "22312/05",
    "title": "Brilliant White Tempest DC ABS 1800mm Ceiling Fan Extension Rod",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2231205.jpg?v=1736342767"
  },
  {
    "sku": "22309/05",
    "title": "Brilliant White Tempest DC ABS 900mm Ceiling Fan Extension Rod",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "99988/05",
    "title": "Brilliant White Tempest-II 52\'\' AC 4-Blade Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99988_IM.pdf?v=1736221521",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99988_Datasheet.pdf?v=1736221520",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00378_Tempest_99988.pdf?v=1757906121",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99988_Extension_Rod.pdf?v=1736221519",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99988-05.jpg?v=1739248899"
  },
  {
    "sku": "20907/05",
    "title": "Brilliant White Tempest-Supreme 52 AC Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20907_IM.pdf?v=1736403537",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20907_Datasheet.pdf?v=1736403538",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20907_SDoC.pdf?v=1736403538",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20907_Extension_Rod.pdf?v=1736403537",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20907-05.jpg?v=1739245219"
  },
  {
    "sku": "22270/05",
    "title": "Brilliant White Tempo Plus 48\" AC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22270_IM_03e0bece-975a-4017-8d09-fda875011deb.pdf?v=1736407267",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22270_Datasheet_888c0222-7775-4b0e-a25e-a4c7ca384c03.pdf?v=1736407267",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22270_SDoC_491d07ba-10b3-4d0b-9be2-dff526fdd0f3.pdf?v=1736407266",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22270_Extension_Rod_3e5b6673-3800-4897-b65e-726f14f72618.pdf?v=1736407266",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22270-05.jpg?v=1739187172"
  },
  {
    "sku": "22273/05",
    "title": "Brilliant White Tempo Plus 48\'\' AC 4-Blade Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22273_IM.pdf?v=1736331594",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22273_Datasheet.pdf?v=1736331595",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22273_SDoC.pdf?v=1736331594",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22273_Extension_Rod.pdf?v=1736331594",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22273-05_0cd036bc-0aef-4003-a98f-59e1bbf32d03.jpg?v=1761562010"
  },
  {
    "sku": "22273/05R",
    "title": "Brilliant White Tempo Plus 48\'\' AC 4-Blade Ceiling Fan with Light and Remote",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22273_IM.pdf?v=1736331594",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22273_Datasheet.pdf?v=1736331595",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22273_SDoC.pdf?v=1736331594",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22273_Extension_Rod.pdf?v=1736331594",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22273_05R.jpg?v=1761545188"
  },
  {
    "sku": "22276/05",
    "title": "Brilliant White Tempo Plus 52\" AC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22276_IM_1982c2b6-f372-4429-a234-f9609b8e2c01.pdf?v=1736409992",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22276_Datasheet_0a2215a2-2056-4c01-97d6-21ab38c9dd62.pdf?v=1736409992",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00806_Tempo_Plus_22270_22273_22276_22279_22242.pdf?v=1757906121",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22276_Extension_Rod_0d6e56f6-66c0-410e-a240-fbad35f39b3e.pdf?v=1736409991",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22276-05.jpg?v=1739187298"
  },
  {
    "sku": "22279/05",
    "title": "Brilliant White Tempo Plus 52\'\' AC 4-Blade Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22279_IM.pdf?v=1736329946",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22279_Datasheet.pdf?v=1736329946",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22279_SDoC.pdf?v=1736329945",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22279_Extension_Rod.pdf?v=1736329945",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2227905_noremote.jpg?v=1761559877"
  },
  {
    "sku": "22279/05R",
    "title": "Brilliant White Tempo Plus 52\'\' AC Ceiling Fan with Light and Remote",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22279_IM.pdf?v=1736329946",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22279_Datasheet.pdf?v=1736329946",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22279_SDoC.pdf?v=1736329945",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22279_Extension_Rod.pdf?v=1736329945",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22279_05R.jpg?v=1761560053"
  },
  {
    "sku": "18062/05",
    "title": "Brilliant White Three-Sixty Surface Mount PIR Sensor",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18062_Datasheet.pdf?v=1736312647",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18062_SDoC.pdf?v=1736312646",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1806205_9e50953e-8907-444a-bcc3-ae2ad1397e97.jpg?v=1736500948"
  },
  {
    "sku": "19911/05",
    "title": "Brilliant White Tornado 250mm Exhaust Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19911_IM.pdf?v=1736406226",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19911_Datasheet.pdf?v=1736406226",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19911_SDoC.pdf?v=1736406226",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1991105.jpg?v=1736253830"
  },
  {
    "sku": "20429/05",
    "title": "Brilliant White Trilogy LED CCT Downlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20429_IM.pdf?v=1736315224",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20429_Datasheet.pdf?v=1736315223",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20429_SDoC.pdf?v=1736315223",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20429-05_9a918f47-ef7f-4df5-940c-681e2c71e5cb.jpg?v=1739249420"
  },
  {
    "sku": "21755/05",
    "title": "Brilliant White Trilogy-Project LED CCT Downlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21755_IM.pdf?v=1736314895",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21755_Datsheet.pdf?v=1736314895",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00891_Neon_2.0_21755.pdf?v=1757906122",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21755-05.jpg?v=1739249955"
  },
  {
    "sku": "20204/05",
    "title": "Brilliant White Umbra CCT Downlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20204_IM.pdf?v=1736246823",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20204_Datasheet.pdf?v=1736246822",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20204_SDoC.pdf?v=1736246823",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20204-05.jpg?v=1739249336"
  },
  {
    "sku": "21932/05",
    "title": "Brilliant White Umbra Trio LED CCT Downlight",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21932_IM.pdf?v=1736313520",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21932_Datasheet.pdf?v=1736313519",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00892_Uni_Trio_21931_21932.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21932-05.jpg?v=1739250099"
  },
  {
    "sku": "21931/05",
    "title": "Brilliant White Uni Trio LED CCT Downlight with Interchangeable Colour Trims",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21931_IM.pdf?v=1736162851",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21931_Datasheet.pdf?v=1736162851",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00892_Uni_Trio_21931_21932.pdf?v=1757906123",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2193105.jpg?v=1736342902"
  },
  {
    "sku": "18060/05",
    "title": "Brilliant White Uni-Scan 180 PIR Security Sensor",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18060_Datasheet_682b9c86-cee0-462e-b0b3-384f3c865ff7.pdf?v=1736306262",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18060_SDoC_4e5b06c9-d53c-41b0-bac7-21af10034d21.pdf?v=1736306262",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1806005.jpg?v=1736341979"
  },
  {
    "sku": "22693/05",
    "title": "Brilliant White Vector 48 DC Ceiling Fan with CCT LED Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22693_IM_b540230f-542f-43fa-9900-4dde2ebc5e18.pdf?v=1736407199",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22693_Datsheet_fbf8df55-e8fb-45d3-ad71-0bcbefe1380b.pdf?v=1736407199",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22693_SDoC_165c701d-6700-4514-8233-020e7370a867.pdf?v=1736407199",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22693_Extension_Rod_dd95b980-ec1a-4131-9846-c4ce366aea89.pdf?v=1736407199",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2269305_d7d04ed3-ab4b-4291-bfca-a82e4d6e7d8e.jpg?v=1761563425"
  },
  {
    "sku": "22687/05",
    "title": "Brilliant White Vector 48 DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22687_IM.pdf?v=1736392753",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22687_Datasheet.pdf?v=1736392753",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22687_SDoC.pdf?v=1736392752",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22687_Extension_Rod.pdf?v=1736392751",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22687-05_0bce20d3-bef5-48bd-a2bb-ab84d2776d9f.jpg?v=1761642627"
  },
  {
    "sku": "22689/05",
    "title": "Brilliant White Vector 52\" DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22689_IM.pdf?v=1736328114",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22689_Datasheet.pdf?v=1736328114",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22689_SDoC.pdf?v=1736328113",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22689_Extension_Rod.pdf?v=1736328113",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22689_05.jpg?v=1761631131"
  },
  {
    "sku": "22695/05",
    "title": "Brilliant White Vector 52\'\' DC 4-Blade Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22695_IM.pdf?v=1736327867",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22695_Datasheet.pdf?v=1736327867",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22695_SDoC.pdf?v=1736327866",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22695_Extension_Rod.pdf?v=1736327866",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22695-05_c73315e0-ee33-40c2-8a7d-08d9cfd60875.jpg?v=1761561155"
  },
  {
    "sku": "22691/05",
    "title": "Brilliant White Vector 56\" DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22691_IM_6db5e34a-1559-4358-9753-9531c1ce1006.pdf?v=1736313364",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22691_Datasheet_ecd36f36-08a3-4132-93a8-64fa684cf201.pdf?v=1736313364",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22691_SDoC_412614d1-4838-4724-a7a6-65a29f5f4aa3.pdf?v=1736313363",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22691_Extension_Rod_722c289e-b3a8-4a1f-8804-53a6ab5d185b.pdf?v=1736313363",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22691-05_cca6fe45-8dbd-4e76-9288-90dcd7c1e9bd.jpg?v=1761636727"
  },
  {
    "sku": "22697/05",
    "title": "Brilliant White Vector 56\'\' DC Ceiling Fan with Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22697_IM_ff87e3dd-d38e-4446-8e1a-e401949c2ef2.pdf?v=1736335022",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22697_Datasheet_ab849d94-9f0d-47fe-8b81-8d0f0a4a9ebd.pdf?v=1736335022",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22697_SDoC_abf4bad3-2d2a-4c7d-882e-421ed17863cb.pdf?v=1736335021",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22697_Extension_Rod_a255889c-9f50-48a5-8cb9-6c7b6f85ecc1.pdf?v=1736335021",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22697-05_513fa044-7bda-4a11-a4d6-56055d733e20.jpg?v=1761561514"
  },
  {
    "sku": "21912/05",
    "title": "Brilliant White Vector II Ceiling Fan Extension Rod 1800mm with Easy Connect Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "21546/05",
    "title": "Brilliant White Vector-III 48 AC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21546.IM_523030df-1cff-4456-963e-79ae483d3bd4.pdf?v=1736400362",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21546_Datasheet_89eeaeeb-f2aa-4a54-814c-47f945c4a83b.pdf?v=1736400362",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21546_SDoC_4ef6cb62-ed2c-4fae-8b83-087f6e8ebc93.pdf?v=1736400361",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21546_Extension_Rod_8bdd0448-3b24-468b-b539-f6dee0bba4de.pdf?v=1736400361",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2154605_cd996140-ff4a-4023-86df-0328e7f3bccd.jpg?v=1761730800"
  },
  {
    "sku": "22291/05",
    "title": "Brilliant White Vector-III 48 AC Ceiling Fan with CCT LED Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22291_IM_b16f7ded-966f-4db9-a913-b2fcf2cdd875.pdf?v=1736404787",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22291_Datasheet_b8a35a34-eac2-4f1b-b556-764e72859884.pdf?v=1736404788",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22291_SDoC_20f645c2-6075-4abb-8aee-4e7def637eba.pdf?v=1736404786",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22291_Extension_Rod_e99df6f3-466a-467e-b163-d9bb1734af81.pdf?v=1736404786",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2229105_39318963-bd87-42eb-98f1-e64d86c8e142.jpg?v=1761625918"
  },
  {
    "sku": "21548/05",
    "title": "Brilliant White Vector-III 52 AC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21548_IM_a8755bd4-1c28-4029-91ea-7cf05f7b604e.pdf?v=1736409920",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21548_Datasheet_d2d4c200-ec9a-4403-9aed-a172559ed981.pdf?v=1736409921",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21548_SDoC_a386af7d-9eb5-4293-9385-dd7cbd8ada40.pdf?v=1736409920",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21548_Extension_Rod_600d9ae5-315f-4f87-ae31-d0176145ab35.pdf?v=1736409920",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21548-05.jpg?v=1739185637"
  },
  {
    "sku": "22293/05",
    "title": "Brilliant White Vector-III 52 AC Ceiling Fan with CCT LED Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22293_IM_d40ffdbb-58c6-4df6-b8c6-e07a99063651.pdf?v=1736403827",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22293_Datasheet_d8296927-2aad-4f83-8848-adb17fd2d586.pdf?v=1736403827",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22293_SDoC_40893882-3727-4d86-a008-2840a0336979.pdf?v=1736403827",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22293_Extension_Rod_ebf0f6b2-6304-42a5-85e7-6614dcc3b261.pdf?v=1736403826",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2229305_97697b97-4ffc-4bce-bccc-cc330450289e.jpg?v=1761624744"
  },
  {
    "sku": "22563/05",
    "title": "Brilliant White Vector-III 56\" AC ABS Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22563.pdf?v=1752049376",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Vector-III-56_Fan_22563-22565.pdf?v=1752049377",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22563_SDoC_f8638b87-b527-436a-9494-1c07ef394b68.pdf?v=1736408061",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22563_Extension_Rod_d2d34305-3f20-430e-a109-78be1848aa5c.pdf?v=1736408061",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22563-05_5b910d2b-5f9d-40c2-99d0-54b0cce765ef.jpg?v=1761632164"
  },
  {
    "sku": "22565/05",
    "title": "Brilliant White Vector-III 56\'\' AC 4-Blade Ceiling Fan with LED CCT Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIM23070_3_VECTOR_III_48-52-56_INCH_ABS_AC_CEILING_FAN_WITH_CCT_DIMMABLE_LED_ARRAY_22565_22291_22293.pdf?v=1786503738",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/Vector-III-56_Fan_22563-22565_3ec7313f-90b3-43fb-b7a0-1f954b34d281.pdf?v=1786503740",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22565_SDoC.pdf?v=1736328522",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2256505_c6efb3c4-b53a-4326-b733-e5a2f1a08ffe.jpg?v=1761628514"
  },
  {
    "sku": "20353/05",
    "title": "Brilliant White Velocity-II 2+1 Light 3-In-1 Bathroom Mate",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20353_IM.pdf?v=1736336085",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20353_Datasheet.pdf?v=1736336085",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20353_SDoC.pdf?v=1736336085",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2035305_20dc6959-a312-44f1-a72f-82e3ac27595d.jpg?v=1737624644"
  },
  {
    "sku": "20354/05",
    "title": "Brilliant White Velocity-II 4+1 Light 3-In-1 Bathroom Mate",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20354_IM.pdf?v=1736327927",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20354_Datasheet.pdf?v=1736327927",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20354_SDoC.pdf?v=1736327928",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2035405.jpg?v=1736327236"
  },
  {
    "sku": "18203/05",
    "title": "Brilliant White Whisper High-Velocity 270mm Exhaust Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18203_IM.pdf?v=1736331664",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18203_Datasheet.pdf?v=1736331664",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00332_Whisper_18203_18204.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1820305.jpg?v=1736323090"
  },
  {
    "sku": "18204/05",
    "title": "Brilliant White Whisper High-Velocity 325mm Exhaust Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18204_IM.pdf?v=1736400905",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/18204_Datasheet.pdf?v=1736400906",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00332_Whisper_18203_18204.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1820405.jpg?v=1736318877"
  },
  {
    "sku": "21719/37",
    "title": "Brilliant White with Oak Timber Amari Series II 4-Blades 52\'\' DC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21719_IM_f493eac6-ad68-4d07-b37d-4568d21cc21e.pdf?v=1736400491",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21719_Datasheet_e9b77058-28b7-470c-b1a6-582787937170.pdf?v=1736400491",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21719_SDoC_c4c8d77d-64a0-40f4-9346-897cd52d0341.pdf?v=1736400491",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21719_Extension_Rod_001d81be-4fe7-414d-970e-6f7c9b5afd69.pdf?v=1736400490",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/21719-37.jpg?v=1739186097"
  },
  {
    "sku": "99983/05",
    "title": "Brilliant White with White Blades Tempest 52\'\' AC Ceiling Fan",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99983_99988_IM_ccdf426d-3fbf-453f-b2fc-f1bed6268f06.pdf?v=1756349582",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99983_Datsheet_eee0e3e5-41a9-4a23-9c32-523d292ba214.pdf?v=1736315130",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99983_SDoC_1f0fb2cd-3a0a-4ce1-988d-127be2f7e806.pdf?v=1736315130",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/99983_Extension_Rod_94672144-bbfa-443c-a41c-e0db90cd86fa.pdf?v=1736315129",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/9998305_ae24d079-8013-486b-9bf1-420b9e27ef4e.jpg?v=1761644729"
  },
  {
    "sku": "100010/05",
    "title": "Brilliant White with White Blades Tempo 48\" Ceiling Fan",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/100010-05.jpg?v=1739188292"
  },
  {
    "sku": "19587/37",
    "title": "Brilliant White with Whitewash Timber Finish Blades Bahama 52\" DC Ceiling Fan",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19587_Datasheet_98375f0e-df39-4195-ad30-c644b90be412.pdf?v=1736407031",
    "sdoc": "",
    "extension_rod_matrix": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19587_Extension_Rod_a35da56e-0873-49aa-87a7-2f6a73837ca0.pdf?v=1736407030",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/1958737_5c9e3296-cede-4f39-98ed-73bd029f4d11.jpg?v=1739257915"
  },
  {
    "sku": "20099/05",
    "title": "Brilliant WhiteMaxi 18W LED Dimmable Light Kit",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20099_Datasheet_24f486b4-b38c-44bb-90e5-fb4c0ed11c52.pdf?v=1736313246",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/20099_SDoC_b255b35d-fd52-4d1b-ae13-6978d7ec558f.pdf?v=1736313245",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2009905.jpg?v=1736336855"
  },
  {
    "sku": "100550/05",
    "title": "Brilliant WhiteVector II Ceiling Fan Extension Rod 900mm with Easy Connect Loom",
    "instructions": "",
    "datasheet": "",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": ""
  },
  {
    "sku": "19705/02",
    "title": "Brilliant Yellow Coloured LED PAR38 15W Reflector Globe",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19705_Datsheet_f05df43a-6972-4cf4-a5c8-4337828d741d.pdf?v=1736312689",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19705_SDoC_0bd09297-a255-4517-bae5-788180ff6050.pdf?v=1736312690",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/19705-02.jpg?v=1739252149"
  },
  {
    "sku": "100ALUDUCT6M",
    "title": "Flexible 100mm Aluminium Duct",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BL_ALUMINIUM_DUCT_DATASHEET-3_OL.pdf?v=1784003579",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/100ALUDUCT6M_1eab7d96-ee1f-4275-9abc-da16187b1d21.jpg?v=1763968244"
  },
  {
    "sku": "100ALUDUCT6M10",
    "title": "Flexible 100mm Aluminium Duct-10 Pack",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BL_ALUMINIUM_DUCT_DATASHEET-3_OL.pdf?v=1784003579",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/100ALUDUCT6M10_d1c51d79-9539-487f-ab40-f4ff07bd0c47.jpg?v=1763968297"
  },
  {
    "sku": "125ALUDUCT6M",
    "title": "Flexible 125mm Aluminium Duct",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BL_ALUMINIUM_DUCT_DATASHEET-3_OL.pdf?v=1784003579",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/125ALUDUCT6M.jpg?v=1763968099"
  },
  {
    "sku": "125ALUDUCT6M10",
    "title": "Flexible 125mm Aluminium Duct-10 Pack",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BL_ALUMINIUM_DUCT_DATASHEET-3_OL.pdf?v=1784003579",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/125ALUDUCT6M10.jpg?v=1763968364"
  },
  {
    "sku": "150ALUDUCT6M",
    "title": "Flexible 150mm Aluminium Duct",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BL_ALUMINIUM_DUCT_DATASHEET-3_OL.pdf?v=1784003579",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/150ALUDUCT6M.jpg?v=1763968142"
  },
  {
    "sku": "150ALUDUCT6M10",
    "title": "Flexible 150mm Aluminium Duct-10 Pack",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BL_ALUMINIUM_DUCT_DATASHEET-3_OL.pdf?v=1784003579",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/150ALUDUCT6M10.jpg?v=1763968407"
  },
  {
    "sku": "200ALUDUCT6M",
    "title": "Flexible 200mm Aluminium Duct",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BL_ALUMINIUM_DUCT_DATASHEET-3_OL.pdf?v=1784003579",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/200ALUDUCT6M.jpg?v=1763968179"
  },
  {
    "sku": "200ALUDUCT6M10",
    "title": "Flexible 200mm Aluminium Duct-10 Pack",
    "instructions": "",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BL_ALUMINIUM_DUCT_DATASHEET-3_OL.pdf?v=1784003579",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/200ALUDUCT6M10.jpg?v=1763968444"
  },
  {
    "sku": "22011/06",
    "title": "Jenkins LED Oval Bunker Light",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22011_IM.pdf?v=1736408434",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/22011_Datasheet.pdf?v=1736408434",
    "sdoc": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/SDoC00830_Jenkins_Welby_22010_22011.pdf?v=1750048828",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/2201106_d24ac94e-7ad1-4d58-aafe-e1626d3990ac.jpg?v=1738646190"
  },
  {
    "sku": "BRF1050",
    "title": "Ripple White 1050Hz Signal Filter",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008489_OL.pdf?v=1773120371",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BRF750_BRF1050_Datasheet_OL.pdf?v=1773120372",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BRF750_58fbc48e-9980-4d8f-a5ed-278a860f8694.webp?v=1773288984"
  },
  {
    "sku": "BRF750",
    "title": "Ripple White 750Hz Signal Filter",
    "instructions": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BLIN008489_OL.pdf?v=1773120371",
    "datasheet": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BRF750_BRF1050_Datasheet_OL.pdf?v=1773120372",
    "sdoc": "",
    "extension_rod_matrix": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0767/4760/4002/files/BRF750.webp?v=1773288554"
  }
];